!(function (t) {
  'object' == typeof exports && 'undefined' != typeof module ? (module.exports = t()) : 'function' == typeof define && define.amd ? define([], t) : (('undefined' != typeof window ? window : 'undefined' != typeof global ? global : 'undefined' != typeof self ? self : this).domDelegate = t())
})(function () {
  return (function n(s, r, o) {
    function a(i, t) {
      if (!r[i]) {
        if (!s[i]) {
          var e = 'function' == typeof require && require
          if (!t && e) return e(i, !0)
          if (l) return l(i, !0)
          e = new Error("Cannot find module '" + i + "'")
          throw ((e.code = 'MODULE_NOT_FOUND'), e)
        }
        e = r[i] = { exports: {} }
        s[i][0].call(
          e.exports,
          function (t) {
            var e = s[i][1][t]
            return a(e || t)
          },
          e,
          e.exports,
          n,
          s,
          r,
          o
        )
      }
      return r[i].exports
    }
    for (var l = 'function' == typeof require && require, t = 0; t < o.length; t++) a(o[t])
    return a
  })(
    {
      1: [
        function (t, e, i) {
          'use strict'
          function n(t) {
            ;(this.listenerMap = [{}, {}]), t && this.root(t), (this.handle = n.prototype.handle.bind(this))
          }
          function a(t, e) {
            return t.toLowerCase() === e.tagName.toLowerCase()
          }
          function l(t, e) {
            return t === e.id
          }
          ;((e.exports = n).prototype.root = function (t) {
            var e,
              i = this.listenerMap
            if (this.rootElement) {
              for (e in i[1]) i[1].hasOwnProperty(e) && this.rootElement.removeEventListener(e, this.handle, !0)
              for (e in i[0]) i[0].hasOwnProperty(e) && this.rootElement.removeEventListener(e, this.handle, !1)
            }
            if (!t || !t.addEventListener) return this.rootElement && delete this.rootElement, this
            for (e in ((this.rootElement = t), i[1])) i[1].hasOwnProperty(e) && this.rootElement.addEventListener(e, this.handle, !0)
            for (e in i[0]) i[0].hasOwnProperty(e) && this.rootElement.addEventListener(e, this.handle, !1)
            return this
          }),
            (n.prototype.captureForType = function (t) {
              return -1 !== ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(t)
            }),
            (n.prototype.on = function (t, e, i, n) {
              var s, r, o
              if (!t) throw new TypeError('Invalid event type: ' + t)
              if (('function' == typeof e && ((n = i), (i = e), (e = null)), void 0 === n && (n = this.captureForType(t)), 'function' != typeof i)) throw new TypeError('Handler must be a type of Function')
              return (
                (s = this.rootElement),
                (r = this.listenerMap[n ? 1 : 0])[t] || (s && s.addEventListener(t, this.handle, n), (r[t] = [])),
                (n = e
                  ? /^[a-z]+$/i.test(e)
                    ? ((o = e), a)
                    : /^#[a-z0-9\-_]+$/i.test(e)
                    ? ((o = e.slice(1)), l)
                    : ((o = e), h)
                  : ((o = null),
                    function (t, e) {
                      return this.rootElement === window ? e === document : this.rootElement === e
                    }.bind(this))),
                r[t].push({ selector: e, handler: i, matcher: n, matcherParam: o }),
                this
              )
            }),
            (n.prototype.off = function (t, e, i, n) {
              var s, r, o, a, l
              if (('function' == typeof e && ((n = i), (i = e), (e = null)), void 0 === n)) return this.off(t, e, i, !0), this.off(t, e, i, !1), this
              if (((o = this.listenerMap[n ? 1 : 0]), !t)) {
                for (l in o) o.hasOwnProperty(l) && this.off(l, e, i)
                return this
              }
              if (!(a = o[t]) || !a.length) return this
              for (s = a.length - 1; 0 <= s; s--) (r = a[s]), (e && e !== r.selector) || (i && i !== r.handler) || a.splice(s, 1)
              return a.length || (delete o[t], this.rootElement && this.rootElement.removeEventListener(t, this.handle, n)), this
            }),
            (n.prototype.handle = function (t) {
              var e,
                i,
                n,
                s,
                r,
                o,
                a = t.type,
                l = [],
                h = 'ftLabsDelegateIgnore'
              if (!0 !== t[h]) {
                switch ((3 === (o = t.target).nodeType && (o = o.parentNode), (n = this.rootElement), t.eventPhase || (t.target !== t.currentTarget ? 3 : 2))) {
                  case 1:
                    l = this.listenerMap[1][a]
                    break
                  case 2:
                    this.listenerMap[0] && this.listenerMap[0][a] && (l = l.concat(this.listenerMap[0][a])), this.listenerMap[1] && this.listenerMap[1][a] && (l = l.concat(this.listenerMap[1][a]))
                    break
                  case 3:
                    l = this.listenerMap[0][a]
                }
                for (i = l.length; o && i; ) {
                  for (e = 0; e < i && (s = l[e]); e++) if ((s.matcher.call(o, s.matcherParam, o) && (r = this.fire(t, o, s)), !1 === r)) return (t[h] = !0), void t.preventDefault()
                  if (o === n) break
                  ;(i = l.length), (o = o.parentElement)
                }
              }
            }),
            (n.prototype.fire = function (t, e, i) {
              return i.handler.call(e, t, e)
            })
          var h = (function (t) {
            if (t) {
              t = t.prototype
              return t.matches || t.matchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector
            }
          })(Element)
          n.prototype.destroy = function () {
            this.off(), this.root()
          }
        },
        {},
      ],
      2: [
        function (t, e, i) {
          'use strict'
          var n = t('./delegate')
          ;(e.exports = function (t) {
            return new n(t)
          }),
            (e.exports.Delegate = n)
        },
        { './delegate': 1 },
      ],
    },
    {},
    [2]
  )(2)
})
var disableBodyScroll = (function () {
  function n(t) {
    ;(!1 !== a && t.target.closest(o)) || t.preventDefault()
  }
  function s(t) {
    1 === t.targetTouches.length && (i = t.targetTouches[0].clientY)
  }
  function r(t) {
    var e
    1 === t.targetTouches.length && ((e = t.targetTouches[0].clientY - i), 0 === a.scrollTop && 0 < e && t.preventDefault(), a.scrollHeight - a.scrollTop <= a.clientHeight && e < 0 && t.preventDefault())
  }
  var i,
    o = !1,
    a = !1
  return function (t, e) {
    void 0 !== e && ((o = e), (a = document.querySelector(e)))
    var i = !1
    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get: function () {
            i = !0
          },
        })
      )
    } catch (t) {}
    !0 === t
      ? (a && (a.addEventListener('touchstart', s, !1), a.addEventListener('touchmove', r, !1)), document.body.addEventListener('touchmove', n, !!i && { capture: !1, passive: !1 }))
      : (a && (a.removeEventListener('touchstart', s, !1), a.removeEventListener('touchmove', r, !1)), document.body.removeEventListener('touchmove', n, !!i && { capture: !1, passive: !1 }))
  }
})()
!(function (t) {
  'use strict'
  function e() {
    ;(this.reads = []), (this.writes = []), (this.raf = n.bind(t)), o('initialized', this)
  }
  function s(t) {
    t.scheduled ||
      ((t.scheduled = !0),
      t.raf(
        function (t) {
          o('flush')
          var e,
            i = t.writes,
            n = t.reads
          try {
            o('flushing reads', n.length), r(n), o('flushing writes', i.length), r(i)
          } catch (t) {
            e = t
          }
          if (((t.scheduled = !1), (n.length || i.length) && s(t), e)) {
            if ((o('task errored', e.message), !t.catch)) throw e
            t.catch(e)
          }
        }.bind(null, t)
      ),
      o('flush scheduled'))
  }
  function r(t) {
    o('run tasks')
    for (var e; (e = t.shift()); ) e()
  }
  function i(t, e) {
    e = t.indexOf(e)
    return !!~e && !!t.splice(e, 1)
  }
  var o = function () {},
    n =
      t.requestAnimationFrame ||
      t.webkitRequestAnimationFrame ||
      t.mozRequestAnimationFrame ||
      t.msRequestAnimationFrame ||
      function (t) {
        return setTimeout(t, 16)
      }
  e.prototype = {
    constructor: e,
    measure: function (t, e) {
      o('measure')
      t = e ? t.bind(e) : t
      return this.reads.push(t), s(this), t
    },
    mutate: function (t, e) {
      o('mutate')
      t = e ? t.bind(e) : t
      return this.writes.push(t), s(this), t
    },
    clear: function (t) {
      return o('clear', t), i(this.reads, t) || i(this.writes, t)
    },
    extend: function (t) {
      if ((o('extend', t), 'object' != typeof t)) throw new Error('expected object')
      var e = Object.create(this)
      return (
        (function (t, e) {
          for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
        })(e, t),
        (e.fastdom = this),
        e.initialize && e.initialize(),
        e
      )
    },
    catch: null,
  }
  var a = (t.fastdom = t.fastdom || new e())
  'function' == typeof define
    ? define(function () {
        return a
      })
    : 'object' == typeof module && (module.exports = a)
})('undefined' != typeof window ? window : this),
  (function (e, i) {
    'function' == typeof define && define.amd
      ? define('jquery-bridget/jquery-bridget', ['jquery'], function (t) {
          return i(e, t)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(e, require('jquery')))
      : (e.jQueryBridget = i(e, e.jQuery))
  })(window, function (t, e) {
    'use strict'
    function i(l, h, c) {
      ;(c = c || e || t.jQuery) &&
        (h.prototype.option ||
          (h.prototype.option = function (t) {
            c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t))
          }),
        (c.fn[l] = function (t) {
          if ('string' != typeof t)
            return (
              (a = t),
              this.each(function (t, e) {
                var i = c.data(e, l)
                i ? (i.option(a), i._init()) : ((i = new h(e, a)), c.data(e, l, i))
              }),
              this
            )
          var n,
            s,
            r,
            o,
            a,
            e = u.call(arguments, 1)
          return (
            (s = e),
            (o = '$().' + l + '("' + (n = t) + '")'),
            (t = this).each(function (t, e) {
              var i = c.data(e, l)
              i ? ((e = i[n]) && '_' != n.charAt(0) ? ((i = e.apply(i, s)), (r = void 0 === r ? i : r)) : d(o + ' is not a valid method')) : d(l + ' not initialized. Cannot call methods, i.e. ' + o)
            }),
            void 0 !== r ? r : t
          )
        }),
        n(c))
    }
    function n(t) {
      !t || (t && t.bridget) || (t.bridget = i)
    }
    var u = Array.prototype.slice,
      s = t.console,
      d =
        void 0 === s
          ? function () {}
          : function (t) {
              s.error(t)
            }
    return n(e || t.jQuery), i
  }),
  (function (t, e) {
    'function' == typeof define && define.amd ? define('ev-emitter/ev-emitter', e) : 'object' == typeof module && module.exports ? (module.exports = e()) : (t.EvEmitter = e())
  })('undefined' != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            t = (i[t] = i[t] || [])
          return -1 == t.indexOf(e) && t.push(e), this
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e)
          var i = (this._onceEvents = this._onceEvents || {})
          return ((i[t] = i[t] || {})[e] = !0), this
        }
      }),
      (e.off = function (t, e) {
        t = this._events && this._events[t]
        if (t && t.length) {
          e = t.indexOf(e)
          return -1 != e && t.splice(e, 1), this
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t]
        if (i && i.length) {
          ;(i = i.slice(0)), (e = e || [])
          for (var n = this._onceEvents && this._onceEvents[t], s = 0; s < i.length; s++) {
            var r = i[s]
            n && n[r] && (this.off(t, r), delete n[r]), r.apply(this, e)
          }
          return this
        }
      }),
      (e.allOff = function () {
        delete this._events, delete this._onceEvents
      }),
      t
    )
  }),
  (function (t, e) {
    'use strict'
    'function' == typeof define && define.amd ? define('get-size/get-size', [], e) : 'object' == typeof module && module.exports ? (module.exports = e()) : (t.getSize = e())
  })(window, function () {
    'use strict'
    function f(t) {
      var e = parseFloat(t)
      return -1 == t.indexOf('%') && !isNaN(e) && e
    }
    function p(t) {
      t = getComputedStyle(t)
      return t || e('Style returned ' + t + '. Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1'), t
    }
    function m(t) {
      if (
        (y ||
          ((y = !0),
          ((d = document.createElement('div')).style.width = '200px'),
          (d.style.padding = '1px 2px 3px 4px'),
          (d.style.borderStyle = 'solid'),
          (d.style.borderWidth = '1px 2px 3px 4px'),
          (d.style.boxSizing = 'border-box'),
          (u = document.body || document.documentElement).appendChild(d),
          (c = p(d)),
          (m.isBoxSizeOuter = g = 200 == f(c.width)),
          u.removeChild(d)),
        'string' == typeof t && (t = document.querySelector(t)),
        t && 'object' == typeof t && t.nodeType)
      ) {
        var e = p(t)
        if ('none' == e.display)
          return (function () {
            for (var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0; e < _; e++) t[v[e]] = 0
            return t
          })()
        var i = {}
        ;(i.width = t.offsetWidth), (i.height = t.offsetHeight)
        for (var n = (i.isBorderBox = 'border-box' == e.boxSizing), s = 0; s < _; s++) {
          var r = v[s],
            o = e[r],
            o = parseFloat(o)
          i[r] = isNaN(o) ? 0 : o
        }
        var a = i.paddingLeft + i.paddingRight,
          l = i.paddingTop + i.paddingBottom,
          h = i.marginLeft + i.marginRight,
          c = i.marginTop + i.marginBottom,
          u = i.borderLeftWidth + i.borderRightWidth,
          d = i.borderTopWidth + i.borderBottomWidth,
          t = n && g,
          n = f(e.width)
        !1 !== n && (i.width = n + (t ? 0 : a + u))
        n = f(e.height)
        return !1 !== n && (i.height = n + (t ? 0 : l + d)), (i.innerWidth = i.width - (a + u)), (i.innerHeight = i.height - (l + d)), (i.outerWidth = i.width + h), (i.outerHeight = i.height + c), i
      }
      var d, u, c
    }
    var g,
      e =
        'undefined' == typeof console
          ? function () {}
          : function (t) {
              console.error(t)
            },
      v = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'],
      _ = v.length,
      y = !1
    return m
  }),
  (function (t, e) {
    'use strict'
    'function' == typeof define && define.amd ? define('desandro-matches-selector/matches-selector', e) : 'object' == typeof module && module.exports ? (module.exports = e()) : (t.matchesSelector = e())
  })(window, function () {
    'use strict'
    var i = (function () {
      var t = window.Element.prototype
      if (t.matches) return 'matches'
      if (t.matchesSelector) return 'matchesSelector'
      for (var e = ['webkit', 'moz', 'ms', 'o'], i = 0; i < e.length; i++) {
        var n = e[i] + 'MatchesSelector'
        if (t[n]) return n
      }
    })()
    return function (t, e) {
      return t[i](e)
    }
  }),
  (function (e, i) {
    'function' == typeof define && define.amd
      ? define('fizzy-ui-utils/utils', ['desandro-matches-selector/matches-selector'], function (t) {
          return i(e, t)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(e, require('desandro-matches-selector')))
      : (e.fizzyUIUtils = i(e, e.matchesSelector))
  })(window, function (i, r) {
    var h = {
        extend: function (t, e) {
          for (var i in e) t[i] = e[i]
          return t
        },
        modulo: function (t, e) {
          return ((t % e) + e) % e
        },
        makeArray: function (t) {
          var e = []
          if (Array.isArray(t)) e = t
          else if (t && 'object' == typeof t && 'number' == typeof t.length) for (var i = 0; i < t.length; i++) e.push(t[i])
          else e.push(t)
          return e
        },
        removeFrom: function (t, e) {
          e = t.indexOf(e)
          ;-1 != e && t.splice(e, 1)
        },
        getParent: function (t, e) {
          for (; t.parentNode && t != document.body; ) if (((t = t.parentNode), r(t, e))) return t
        },
        getQueryElement: function (t) {
          return 'string' == typeof t ? document.querySelector(t) : t
        },
        handleEvent: function (t) {
          var e = 'on' + t.type
          this[e] && this[e](t)
        },
        filterFindElements: function (t, n) {
          t = h.makeArray(t)
          var s = []
          return (
            t.forEach(function (t) {
              if (t instanceof HTMLElement)
                if (n) {
                  r(t, n) && s.push(t)
                  for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++) s.push(e[i])
                } else s.push(t)
            }),
            s
          )
        },
        debounceMethod: function (t, e, n) {
          var s = t.prototype[e],
            r = e + 'Timeout'
          t.prototype[e] = function () {
            var t = this[r]
            t && clearTimeout(t)
            var e = arguments,
              i = this
            this[r] = setTimeout(function () {
              s.apply(i, e), delete i[r]
            }, n || 100)
          }
        },
        docReady: function (t) {
          var e = document.readyState
          'complete' == e || 'interactive' == e ? setTimeout(t) : document.addEventListener('DOMContentLoaded', t)
        },
        toDashed: function (t) {
          return t
            .replace(/(.)([A-Z])/g, function (t, e, i) {
              return e + '-' + i
            })
            .toLowerCase()
        },
      },
      c = i.console
    return (
      (h.htmlInit = function (a, l) {
        h.docReady(function () {
          var t = h.toDashed(l),
            s = 'data-' + t,
            e = document.querySelectorAll('[' + s + ']'),
            t = document.querySelectorAll('.js-' + t),
            t = h.makeArray(e).concat(h.makeArray(t)),
            r = s + '-options',
            o = i.jQuery
          t.forEach(function (e) {
            var t,
              i = e.getAttribute(s) || e.getAttribute(r)
            try {
              t = i && JSON.parse(i)
            } catch (t) {
              return void (c && c.error('Error parsing ' + s + ' on ' + e.className + ': ' + t))
            }
            var n = new a(e, t)
            o && o.data(e, l, n)
          })
        })
      }),
      h
    )
  }),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define('flickity/js/cell', ['get-size/get-size'], function (t) {
          return e(0, t)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = e(0, require('get-size')))
      : ((t.Flickity = t.Flickity || {}), (t.Flickity.Cell = e(0, t.getSize)))
  })(window, function (t, e) {
    function i(t, e) {
      ;(this.element = t), (this.parent = e), this.create()
    }
    var n = i.prototype
    return (
      (n.create = function () {
        ;(this.element.style.position = 'absolute'), (this.x = 0), (this.shift = 0)
      }),
      (n.destroy = function () {
        this.element.style.position = ''
        var t = this.parent.originSide
        this.element.style[t] = ''
      }),
      (n.getSize = function () {
        this.size = e(this.element)
      }),
      (n.setPosition = function (t) {
        ;(this.x = t), this.updateTarget(), this.renderPosition(t)
      }),
      (n.updateTarget = n.setDefaultTarget =
        function () {
          var t = 'left' == this.parent.originSide ? 'marginLeft' : 'marginRight'
          this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign
        }),
      (n.renderPosition = function (t) {
        var e = this.parent.originSide
        this.element.style[e] = this.parent.getPositionValue(t)
      }),
      (n.wrapShift = function (t) {
        ;(this.shift = t), this.renderPosition(this.x + this.parent.slideableWidth * t)
      }),
      (n.remove = function () {
        this.element.parentNode.removeChild(this.element)
      }),
      i
    )
  }),
  (function (t, e) {
    'function' == typeof define && define.amd ? define('flickity/js/slide', e) : 'object' == typeof module && module.exports ? (module.exports = e()) : ((t.Flickity = t.Flickity || {}), (t.Flickity.Slide = e()))
  })(window, function () {
    'use strict'
    function t(t) {
      ;(this.parent = t), (this.isOriginLeft = 'left' == t.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0)
    }
    var e = t.prototype
    return (
      (e.addCell = function (t) {
        var e
        this.cells.push(t), (this.outerWidth += t.size.outerWidth), (this.height = Math.max(t.size.outerHeight, this.height)), 1 == this.cells.length && ((this.x = t.x), (e = this.isOriginLeft ? 'marginLeft' : 'marginRight'), (this.firstMargin = t.size[e]))
      }),
      (e.updateTarget = function () {
        var t = this.isOriginLeft ? 'marginRight' : 'marginLeft',
          e = this.getLastCell(),
          t = e ? e.size[t] : 0,
          t = this.outerWidth - (this.firstMargin + t)
        this.target = this.x + this.firstMargin + t * this.parent.cellAlign
      }),
      (e.getLastCell = function () {
        return this.cells[this.cells.length - 1]
      }),
      (e.select = function () {
        this.changeSelectedClass('add')
      }),
      (e.unselect = function () {
        this.changeSelectedClass('remove')
      }),
      (e.changeSelectedClass = function (e) {
        this.cells.forEach(function (t) {
          t.element.classList[e]('is-selected')
        })
      }),
      (e.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element
        })
      }),
      t
    )
  }),
  (function (e, i) {
    'function' == typeof define && define.amd
      ? define('flickity/js/animate', ['fizzy-ui-utils/utils'], function (t) {
          return i(e, t)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(e, require('fizzy-ui-utils')))
      : ((e.Flickity = e.Flickity || {}), (e.Flickity.animatePrototype = i(e, e.fizzyUIUtils)))
  })(window, function (t, i) {
    var n = t.requestAnimationFrame || t.webkitRequestAnimationFrame,
      s = 0,
      n =
        n ||
        function (t) {
          var e = new Date().getTime(),
            i = Math.max(0, 16 - (e - s)),
            t = setTimeout(t, i)
          return (s = e + i), t
        },
      t = {
        startAnimation: function () {
          this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate())
        },
        animate: function () {
          this.applyDragForce(), this.applySelectedAttraction()
          var t,
            e = this.x
          this.integratePhysics(),
            this.positionSlider(),
            this.settle(e),
            this.isAnimating &&
              ((t = this),
              n(function () {
                t.animate()
              }))
        },
      },
      r = 'string' == typeof document.documentElement.style.transform ? 'transform' : 'WebkitTransform'
    return (
      (t.positionSlider = function () {
        var t = this.x
        this.options.wrapAround && 1 < this.cells.length && ((t = i.modulo(t, this.slideableWidth)), (t -= this.slideableWidth), this.shiftWrapCells(t)), (t += this.cursorPosition), (t = this.options.rightToLeft && r ? -t : t)
        var e = this.getPositionValue(t)
        this.slider.style[r] = this.isAnimating ? 'translate3d(' + e + ',0,0)' : 'translateX(' + e + ')'
        t = this.slides[0]
        t && ((t = (e = -this.x - t.target) / this.slidesWidth), this.dispatchEvent('scroll', null, [t, e]))
      }),
      (t.positionSliderAtSelected = function () {
        this.cells.length && ((this.x = -this.selectedSlide.target), this.positionSlider())
      }),
      (t.getPositionValue = function (t) {
        return this.options.percentPosition ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + '%' : Math.round(t) + 'px'
      }),
      (t.settle = function (t) {
        this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t) || this.restingFrames++, 2 < this.restingFrames && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent('settle'))
      }),
      (t.shiftWrapCells = function (t) {
        var e = this.cursorPosition + t
        this._shiftCells(this.beforeShiftCells, e, -1)
        t = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition)
        this._shiftCells(this.afterShiftCells, t, 1)
      }),
      (t._shiftCells = function (t, e, i) {
        for (var n = 0; n < t.length; n++) {
          var s = t[n],
            r = 0 < e ? i : 0
          s.wrapShift(r), (e -= s.size.outerWidth)
        }
      }),
      (t._unshiftCells = function (t) {
        if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0)
      }),
      (t.integratePhysics = function () {
        ;(this.x += this.velocity), (this.velocity *= this.getFrictionFactor())
      }),
      (t.applyForce = function (t) {
        this.velocity += t
      }),
      (t.getFrictionFactor = function () {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction']
      }),
      (t.getRestingPosition = function () {
        return this.x + this.velocity / (1 - this.getFrictionFactor())
      }),
      (t.applyDragForce = function () {
        var t
        this.isPointerDown && ((t = this.dragX - this.x - this.velocity), this.applyForce(t))
      }),
      (t.applySelectedAttraction = function () {
        var t
        this.isPointerDown || this.isFreeScrolling || !this.cells.length || ((t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction), this.applyForce(t))
      }),
      t
    )
  }),
  (function (o, a) {
    var t
    'function' == typeof define && define.amd
      ? define('flickity/js/flickity', ['ev-emitter/ev-emitter', 'get-size/get-size', 'fizzy-ui-utils/utils', './cell', './slide', './animate'], function (t, e, i, n, s, r) {
          return a(o, t, e, i, n, s, r)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = a(o, require('ev-emitter'), require('get-size'), require('fizzy-ui-utils'), require('./cell'), require('./slide'), require('./animate')))
      : ((t = o.Flickity), (o.Flickity = a(o, o.EvEmitter, o.getSize, o.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype)))
  })(window, function (e, t, i, o, n, a, s) {
    function r(t, e) {
      for (t = o.makeArray(t); t.length; ) e.appendChild(t.shift())
    }
    function l(t, e) {
      var i = o.getQueryElement(t)
      if (i) {
        if (((this.element = i), this.element.flickityGUID)) {
          var n = f[this.element.flickityGUID]
          return n.option(e), n
        }
        h && (this.$element = h(this.element)), (this.options = o.extend({}, this.constructor.defaults)), this.option(e), this._create()
      } else u && u.error('Bad element for Flickity: ' + (i || t))
    }
    var h = e.jQuery,
      c = e.getComputedStyle,
      u = e.console,
      d = 0,
      f = {}
    ;(l.defaults = { accessibility: !0, cellAlign: 'center', freeScrollFriction: 0.075, friction: 0.28, namespaceJQueryEvents: !0, percentPosition: !0, resize: !0, selectedAttraction: 0.025, setGallerySize: !0 }), (l.createMethods = [])
    var p = l.prototype
    o.extend(p, t.prototype),
      (p._create = function () {
        var t = (this.guid = ++d)
        ;(this.element.flickityGUID = t),
          ((f[t] = this).selectedIndex = 0),
          (this.restingFrames = 0),
          (this.x = 0),
          (this.velocity = 0),
          (this.originSide = this.options.rightToLeft ? 'right' : 'left'),
          (this.viewport = document.createElement('div')),
          (this.viewport.className = 'flickity-viewport'),
          this._createSlider(),
          (this.options.resize || this.options.watchCSS) && e.addEventListener('resize', this),
          l.createMethods.forEach(function (t) {
            this[t]()
          }, this),
          this.options.watchCSS ? this.watchCSS() : this.activate()
      }),
      (p.option = function (t) {
        o.extend(this.options, t)
      }),
      (p.activate = function () {
        var t
        this.isActive ||
          ((this.isActive = !0),
          this.element.classList.add('flickity-enabled'),
          this.options.rightToLeft && this.element.classList.add('flickity-rtl'),
          this.getSize(),
          r(this._filterFindCellElements(this.element.children), this.slider),
          this.viewport.appendChild(this.slider),
          this.element.appendChild(this.viewport),
          this.reloadCells(),
          this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener('keydown', this)),
          this.emitEvent('activate'),
          (t = this.options.initialIndex),
          (t = this.isInitActivated ? this.selectedIndex : void 0 !== t && this.cells[t] ? t : 0),
          this.select(t, !1, !0),
          (this.isInitActivated = !0))
      }),
      (p._createSlider = function () {
        var t = document.createElement('div')
        ;(t.className = 'flickity-slider'), (t.style[this.originSide] = 0), (this.slider = t)
      }),
      (p._filterFindCellElements = function (t) {
        return o.filterFindElements(t, this.options.cellSelector)
      }),
      (p.reloadCells = function () {
        ;(this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
      }),
      (p._makeCells = function (t) {
        return this._filterFindCellElements(t).map(function (t) {
          return new n(t, this)
        }, this)
      }),
      (p.getLastCell = function () {
        return this.cells[this.cells.length - 1]
      }),
      (p.getLastSlide = function () {
        return this.slides[this.slides.length - 1]
      }),
      (p.positionCells = function () {
        this._sizeCells(this.cells), this._positionCells(0)
      }),
      (p._positionCells = function (t) {
        ;(t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0)
        var e,
          i = 0
        0 < t && (i = (e = this.cells[t - 1]).x + e.size.outerWidth)
        for (var n = this.cells.length, s = t; s < n; s++) {
          var r = this.cells[s]
          r.setPosition(i), (i += r.size.outerWidth), (this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight))
        }
        ;(this.slideableWidth = i), this.updateSlides(), this._containSlides(), (this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0)
      }),
      (p._sizeCells = function (t) {
        t.forEach(function (t) {
          t.getSize()
        })
      }),
      (p.updateSlides = function () {
        var n, s, r
        ;(this.slides = []),
          this.cells.length &&
            ((n = new a(this)),
            this.slides.push(n),
            (s = 'left' == this.originSide ? 'marginRight' : 'marginLeft'),
            (r = this._getCanCellFit()),
            this.cells.forEach(function (t, e) {
              var i
              n.cells.length && ((i = n.outerWidth - n.firstMargin + (t.size.outerWidth - t.size[s])), r.call(this, e, i) || (n.updateTarget(), (n = new a(this)), this.slides.push(n))), n.addCell(t)
            }, this),
            n.updateTarget(),
            this.updateSelectedSlide())
      }),
      (p._getCanCellFit = function () {
        var t = this.options.groupCells
        if (!t)
          return function () {
            return !1
          }
        if ('number' == typeof t) {
          var e = parseInt(t, 10)
          return function (t) {
            return t % e != 0
          }
        }
        var t = 'string' == typeof t && t.match(/^(\d+)%$/),
          i = t ? parseInt(t[1], 10) / 100 : 1
        return function (t, e) {
          return e <= (this.size.innerWidth + 1) * i
        }
      }),
      (p._init = p.reposition =
        function () {
          this.positionCells(), this.positionSliderAtSelected()
        }),
      (p.getSize = function () {
        ;(this.size = i(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign)
      })
    var m = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } }
    return (
      (p.setCellAlign = function () {
        var t = m[this.options.cellAlign]
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign
      }),
      (p.setGallerySize = function () {
        var t
        this.options.setGallerySize && ((t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight), (this.viewport.style.height = t + 'px'))
      }),
      (p._getWrapShiftCells = function () {
        var t, e
        this.options.wrapAround &&
          (this._unshiftCells(this.beforeShiftCells),
          this._unshiftCells(this.afterShiftCells),
          (t = this.cursorPosition),
          (e = this.cells.length - 1),
          (this.beforeShiftCells = this._getGapCells(t, e, -1)),
          (t = this.size.innerWidth - this.cursorPosition),
          (this.afterShiftCells = this._getGapCells(t, 0, 1)))
      }),
      (p._getGapCells = function (t, e, i) {
        for (var n = []; 0 < t; ) {
          var s = this.cells[e]
          if (!s) break
          n.push(s), (e += i), (t -= s.size.outerWidth)
        }
        return n
      }),
      (p._containSlides = function () {
        var t, e, i, n, s, r
        this.options.contain &&
          !this.options.wrapAround &&
          this.cells.length &&
          ((t = (e = this.options.rightToLeft) ? 'marginRight' : 'marginLeft'),
          (e = e ? 'marginLeft' : 'marginRight'),
          (i = this.slideableWidth - this.getLastCell().size[e]),
          (n = i < this.size.innerWidth),
          (s = this.cursorPosition + this.cells[0].size[t]),
          (r = i - this.size.innerWidth * (1 - this.cellAlign)),
          this.slides.forEach(function (t) {
            n ? (t.target = i * this.cellAlign) : ((t.target = Math.max(t.target, s)), (t.target = Math.min(t.target, r)))
          }, this))
      }),
      (p.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i
        this.emitEvent(t, n), h && this.$element && ((n = t += this.options.namespaceJQueryEvents ? '.flickity' : ''), e && (((e = h.Event(e)).type = t), (n = e)), this.$element.trigger(n, i))
      }),
      (p.select = function (t, e, i) {
        this.isActive &&
          ((t = parseInt(t, 10)),
          this._wrapSelect(t),
          (this.options.wrapAround || e) && (t = o.modulo(t, this.slides.length)),
          this.slides[t] && ((this.selectedIndex = t), this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent('select'), this.dispatchEvent('cellSelect')))
      }),
      (p._wrapSelect = function (t) {
        var e = this.slides.length
        if (!(this.options.wrapAround && 1 < e)) return t
        var i = o.modulo(t, e),
          n = Math.abs(i - this.selectedIndex),
          s = Math.abs(i + e - this.selectedIndex),
          i = Math.abs(i - e - this.selectedIndex)
        !this.isDragSelect && s < n ? (t += e) : !this.isDragSelect && i < n && (t -= e), t < 0 ? (this.x -= this.slideableWidth) : e <= t && (this.x += this.slideableWidth)
      }),
      (p.previous = function (t, e) {
        this.select(this.selectedIndex - 1, t, e)
      }),
      (p.next = function (t, e) {
        this.select(this.selectedIndex + 1, t, e)
      }),
      (p.updateSelectedSlide = function () {
        var t = this.slides[this.selectedIndex]
        t && (this.unselectSelectedSlide(), (this.selectedSlide = t).select(), (this.selectedCells = t.cells), (this.selectedElements = t.getCellElements()), (this.selectedCell = t.cells[0]), (this.selectedElement = this.selectedElements[0]))
      }),
      (p.unselectSelectedSlide = function () {
        this.selectedSlide && this.selectedSlide.unselect()
      }),
      (p.selectCell = function (t, e, i) {
        for (var n = 'number' == typeof t ? this.cells[t] : ('string' == typeof t && (t = this.element.querySelector(t)), this.getCell(t)), s = 0; n && s < this.slides.length; s++) if (-1 != this.slides[s].cells.indexOf(n)) return void this.select(s, e, i)
      }),
      (p.getCell = function (t) {
        for (var e = 0; e < this.cells.length; e++) {
          var i = this.cells[e]
          if (i.element == t) return i
        }
      }),
      (p.getCells = function (t) {
        t = o.makeArray(t)
        var e = []
        return (
          t.forEach(function (t) {
            t = this.getCell(t)
            t && e.push(t)
          }, this),
          e
        )
      }),
      (p.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element
        })
      }),
      (p.getParentCell = function (t) {
        var e = this.getCell(t)
        return e || ((t = o.getParent(t, '.flickity-slider > *')), this.getCell(t))
      }),
      (p.getAdjacentCellElements = function (t, e) {
        if (!t) return this.selectedSlide.getCellElements()
        e = void 0 === e ? this.selectedIndex : e
        var i = this.slides.length
        if (i <= 1 + 2 * t) return this.getCellElements()
        for (var n = [], s = e - t; s <= e + t; s++) {
          var r = this.options.wrapAround ? o.modulo(s, i) : s,
            r = this.slides[r]
          r && (n = n.concat(r.getCellElements()))
        }
        return n
      }),
      (p.uiChange = function () {
        this.emitEvent('uiChange')
      }),
      (p.childUIPointerDown = function (t) {
        this.emitEvent('childUIPointerDown', [t])
      }),
      (p.onresize = function () {
        this.watchCSS(), this.resize()
      }),
      o.debounceMethod(l, 'onresize', 150),
      (p.resize = function () {
        var t
        this.isActive &&
          (this.getSize(), this.options.wrapAround && (this.x = o.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent('resize'), (t = this.selectedElements && this.selectedElements[0]), this.selectCell(t, !1, !0))
      }),
      (p.watchCSS = function () {
        this.options.watchCSS && (-1 != c(this.element, ':after').content.indexOf('flickity') ? this.activate() : this.deactivate())
      }),
      (p.onkeydown = function (t) {
        var e
        !this.options.accessibility ||
          (document.activeElement && document.activeElement != this.element) ||
          (37 == t.keyCode ? ((e = this.options.rightToLeft ? 'next' : 'previous'), this.uiChange(), this[e]()) : 39 == t.keyCode && ((t = this.options.rightToLeft ? 'previous' : 'next'), this.uiChange(), this[t]()))
      }),
      (p.deactivate = function () {
        this.isActive &&
          (this.element.classList.remove('flickity-enabled'),
          this.element.classList.remove('flickity-rtl'),
          this.cells.forEach(function (t) {
            t.destroy()
          }),
          this.unselectSelectedSlide(),
          this.element.removeChild(this.viewport),
          r(this.slider.children, this.element),
          this.options.accessibility && (this.element.removeAttribute('tabIndex'), this.element.removeEventListener('keydown', this)),
          (this.isActive = !1),
          this.emitEvent('deactivate'))
      }),
      (p.destroy = function () {
        this.deactivate(), e.removeEventListener('resize', this), this.emitEvent('destroy'), h && this.$element && h.removeData(this.element, 'flickity'), delete this.element.flickityGUID, delete f[this.guid]
      }),
      o.extend(p, s),
      (l.data = function (t) {
        t = (t = o.getQueryElement(t)) && t.flickityGUID
        return t && f[t]
      }),
      o.htmlInit(l, 'flickity'),
      h && h.bridget && h.bridget('flickity', l),
      (l.setJQuery = function (t) {
        h = t
      }),
      (l.Cell = n),
      l
    )
  }),
  (function (e, i) {
    'function' == typeof define && define.amd
      ? define('unipointer/unipointer', ['ev-emitter/ev-emitter'], function (t) {
          return i(e, t)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(e, require('ev-emitter')))
      : (e.Unipointer = i(e, e.EvEmitter))
  })(window, function (i, t) {
    function e() {}
    t = e.prototype = Object.create(t.prototype)
    ;(t.bindStartEvent = function (t) {
      this._bindStartEvent(t, !0)
    }),
      (t.unbindStartEvent = function (t) {
        this._bindStartEvent(t, !1)
      }),
      (t._bindStartEvent = function (t, e) {
        e = (e = void 0 === e || !!e) ? 'addEventListener' : 'removeEventListener'
        i.PointerEvent ? t[e]('pointerdown', this) : (t[e]('mousedown', this), t[e]('touchstart', this))
      }),
      (t.handleEvent = function (t) {
        var e = 'on' + t.type
        this[e] && this[e](t)
      }),
      (t.getTouch = function (t) {
        for (var e = 0; e < t.length; e++) {
          var i = t[e]
          if (i.identifier == this.pointerIdentifier) return i
        }
      }),
      (t.onmousedown = function (t) {
        var e = t.button
        ;(e && 0 !== e && 1 !== e) || this._pointerDown(t, t)
      }),
      (t.ontouchstart = function (t) {
        this._pointerDown(t, t.changedTouches[0])
      }),
      (t.onpointerdown = function (t) {
        this._pointerDown(t, t)
      }),
      (t._pointerDown = function (t, e) {
        this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier), this.pointerDown(t, e))
      }),
      (t.pointerDown = function (t, e) {
        this._bindPostStartEvents(t), this.emitEvent('pointerDown', [t, e])
      })
    var n = { mousedown: ['mousemove', 'mouseup'], touchstart: ['touchmove', 'touchend', 'touchcancel'], pointerdown: ['pointermove', 'pointerup', 'pointercancel'] }
    return (
      (t._bindPostStartEvents = function (t) {
        t &&
          ((t = n[t.type]).forEach(function (t) {
            i.addEventListener(t, this)
          }, this),
          (this._boundPointerEvents = t))
      }),
      (t._unbindPostStartEvents = function () {
        this._boundPointerEvents &&
          (this._boundPointerEvents.forEach(function (t) {
            i.removeEventListener(t, this)
          }, this),
          delete this._boundPointerEvents)
      }),
      (t.onmousemove = function (t) {
        this._pointerMove(t, t)
      }),
      (t.onpointermove = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t)
      }),
      (t.ontouchmove = function (t) {
        var e = this.getTouch(t.changedTouches)
        e && this._pointerMove(t, e)
      }),
      (t._pointerMove = function (t, e) {
        this.pointerMove(t, e)
      }),
      (t.pointerMove = function (t, e) {
        this.emitEvent('pointerMove', [t, e])
      }),
      (t.onmouseup = function (t) {
        this._pointerUp(t, t)
      }),
      (t.onpointerup = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t)
      }),
      (t.ontouchend = function (t) {
        var e = this.getTouch(t.changedTouches)
        e && this._pointerUp(t, e)
      }),
      (t._pointerUp = function (t, e) {
        this._pointerDone(), this.pointerUp(t, e)
      }),
      (t.pointerUp = function (t, e) {
        this.emitEvent('pointerUp', [t, e])
      }),
      (t._pointerDone = function () {
        ;(this.isPointerDown = !1), delete this.pointerIdentifier, this._unbindPostStartEvents(), this.pointerDone()
      }),
      (t.pointerDone = function () {}),
      (t.onpointercancel = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t)
      }),
      (t.ontouchcancel = function (t) {
        var e = this.getTouch(t.changedTouches)
        e && this._pointerCancel(t, e)
      }),
      (t._pointerCancel = function (t, e) {
        this._pointerDone(), this.pointerCancel(t, e)
      }),
      (t.pointerCancel = function (t, e) {
        this.emitEvent('pointerCancel', [t, e])
      }),
      (e.getPointerPoint = function (t) {
        return { x: t.pageX, y: t.pageY }
      }),
      e
    )
  }),
  (function (e, i) {
    'function' == typeof define && define.amd
      ? define('unidragger/unidragger', ['unipointer/unipointer'], function (t) {
          return i(e, t)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(e, require('unipointer')))
      : (e.Unidragger = i(e, e.Unipointer))
  })(window, function (s, n) {
    function t() {}
    var e = (t.prototype = Object.create(n.prototype))
    return (
      (e.bindHandles = function () {
        this._bindHandles(!0)
      }),
      (e.unbindHandles = function () {
        this._bindHandles(!1)
      }),
      (e._bindHandles = function (t) {
        for (var e = (t = void 0 === t || !!t) ? 'addEventListener' : 'removeEventListener', i = 0; i < this.handles.length; i++) {
          var n = this.handles[i]
          this._bindStartEvent(n, t), n[e]('click', this), s.PointerEvent && (n.style.touchAction = t ? this._touchActionValue : 'pan-y pinch-zoom')
        }
      }),
      (e._touchActionValue = 'pan-y pinch-zoom'),
      (e.pointerDown = function (t, e) {
        if ('INPUT' == t.target.nodeName && 'range' == t.target.type) return (this.isPointerDown = !1), void delete this.pointerIdentifier
        this._dragPointerDown(t, e)
        var i = document.activeElement
        i && i.blur && i.blur(), this._bindPostStartEvents(t), this.emitEvent('pointerDown', [t, e])
      }),
      (e._dragPointerDown = function (t, e) {
        ;(this.pointerDownPoint = n.getPointerPoint(e)), this.canPreventDefaultOnPointerDown(t, e) && t.preventDefault()
      }),
      (e.canPreventDefaultOnPointerDown = function (t) {
        return 'SELECT' != t.target.nodeName
      }),
      (e.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e)
        this.emitEvent('pointerMove', [t, e, i]), this._dragMove(t, e, i)
      }),
      (e._dragPointerMove = function (t, e) {
        var i = n.getPointerPoint(e),
          i = { x: i.x - this.pointerDownPoint.x, y: i.y - this.pointerDownPoint.y }
        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i
      }),
      (e.hasDragStarted = function (t) {
        return 3 < Math.abs(t.x) || 3 < Math.abs(t.y)
      }),
      (e.pointerUp = function (t, e) {
        this.emitEvent('pointerUp', [t, e]), this._dragPointerUp(t, e)
      }),
      (e._dragPointerUp = function (t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e)
      }),
      (e._dragStart = function (t, e) {
        ;(this.isDragging = !0), (this.dragStartPoint = n.getPointerPoint(e)), (this.isPreventingClicks = !0), this.dragStart(t, e)
      }),
      (e.dragStart = function (t, e) {
        this.emitEvent('dragStart', [t, e])
      }),
      (e._dragMove = function (t, e, i) {
        this.isDragging && this.dragMove(t, e, i)
      }),
      (e.dragMove = function (t, e, i) {
        t.preventDefault(), this.emitEvent('dragMove', [t, e, i])
      }),
      (e._dragEnd = function (t, e) {
        ;(this.isDragging = !1),
          setTimeout(
            function () {
              delete this.isPreventingClicks
            }.bind(this)
          ),
          this.dragEnd(t, e)
      }),
      (e.dragEnd = function (t, e) {
        this.emitEvent('dragEnd', [t, e])
      }),
      (e.onclick = function (t) {
        this.isPreventingClicks && t.preventDefault()
      }),
      (e._staticClick = function (t, e) {
        var i
        ;(this.isIgnoringMouseUp && 'mouseup' == t.type) ||
          (('INPUT' != (i = t.target.nodeName) && 'TEXTAREA' != i) || t.target.focus(),
          this.staticClick(t, e),
          'mouseup' != t.type &&
            ((this.isIgnoringMouseUp = !0),
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp
              }.bind(this),
              400
            )))
      }),
      (e.staticClick = function (t, e) {
        this.emitEvent('staticClick', [t, e])
      }),
      (t.getPointerPoint = n.getPointerPoint),
      t
    )
  }),
  (function (n, s) {
    'function' == typeof define && define.amd
      ? define('flickity/js/drag', ['./flickity', 'unidragger/unidragger', 'fizzy-ui-utils/utils'], function (t, e, i) {
          return s(n, t, e, i)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = s(n, require('./flickity'), require('unidragger'), require('fizzy-ui-utils')))
      : (n.Flickity = s(n, n.Flickity, n.Unidragger, n.fizzyUIUtils))
  })(window, function (n, t, e, r) {
    function i(t) {
      var e = 'touchstart' == t.type,
        i = 'touch' == t.pointerType,
        t = u[t.target.nodeName]
      return e || i || t
    }
    function s() {
      return { x: n.pageXOffset, y: n.pageYOffset }
    }
    r.extend(t.defaults, { draggable: !0, dragThreshold: 3 }), t.createMethods.push('_createDrag')
    var o = t.prototype
    r.extend(o, e.prototype), (o._touchActionValue = 'pan-y pinch-zoom')
    var a = 'createTouch' in document,
      l = !1
    ;(o._createDrag = function () {
      this.on('activate', this.bindDrag), this.on('uiChange', this._uiChangeDrag), this.on('childUIPointerDown', this._childUIPointerDownDrag), this.on('deactivate', this.unbindDrag), a && !l && (n.addEventListener('touchmove', function () {}), (l = !0))
    }),
      (o.bindDrag = function () {
        this.options.draggable && !this.isDragBound && (this.element.classList.add('is-draggable'), (this.handles = [this.viewport]), this.bindHandles(), (this.isDragBound = !0))
      }),
      (o.unbindDrag = function () {
        this.isDragBound && (this.element.classList.remove('is-draggable'), this.unbindHandles(), delete this.isDragBound)
      }),
      (o._uiChangeDrag = function () {
        delete this.isFreeScrolling
      }),
      (o._childUIPointerDownDrag = function (t) {
        t.preventDefault(), this.pointerDownFocus(t)
      })
    var h = { TEXTAREA: !0, INPUT: !0, OPTION: !0 },
      c = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 }
    ;(o.pointerDown = function (t, e) {
      if (h[t.target.nodeName] && !c[t.target.type]) return (this.isPointerDown = !1), void delete this.pointerIdentifier
      this._dragPointerDown(t, e)
      var i = document.activeElement
      i && i.blur && i != this.element && i != document.body && i.blur(),
        this.pointerDownFocus(t),
        (this.dragX = this.x),
        this.viewport.classList.add('is-pointer-down'),
        this._bindPostStartEvents(t),
        (this.pointerDownScroll = s()),
        n.addEventListener('scroll', this),
        this.dispatchEvent('pointerDown', t, [e])
    }),
      (o.pointerDownFocus = function (t) {
        t = i(t)
        this.options.accessibility && !t && ((t = n.pageYOffset), this.element.focus(), n.pageYOffset != t && n.scrollTo(n.pageXOffset, t))
      })

     
    var u = { INPUT: !0, SELECT: !0 }
    return (
      (o.canPreventDefaultOnPointerDown = function (t) {
        return !i(t)
      }),
      (o.hasDragStarted = function (t) {
        return Math.abs(t.x) > this.options.dragThreshold
      }),
      (o.pointerUp = function (t, e) {
        delete this.isTouchScrolling, this.viewport.classList.remove('is-pointer-down'), this.dispatchEvent('pointerUp', t, [e]), this._dragPointerUp(t, e)
      }),
      (o.pointerDone = function () {
        n.removeEventListener('scroll', this), delete this.pointerDownScroll
      }),
      (o.dragStart = function (t, e) {
        ;(this.dragStartPosition = this.x), this.startAnimation(), n.removeEventListener('scroll', this), this.dispatchEvent('dragStart', t, [e])
      }),
      (o.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e)
        this.dispatchEvent('pointerMove', t, [e, i]), this._dragMove(t, e, i)
      }),
      (o.dragMove = function (t, e, i) {
        t.preventDefault(), (this.previousDragX = this.dragX)
        var n = this.options.rightToLeft ? -1 : 1,
          s = this.dragStartPosition + i.x * n
        !this.options.wrapAround && this.slides.length && (s = (s = (n = Math.max(-this.slides[0].target, this.dragStartPosition)) < s ? 0.5 * (s + n) : s) < (n = Math.min(-this.getLastSlide().target, this.dragStartPosition)) ? 0.5 * (s + n) : s),
          (this.dragX = s),
          (this.dragMoveTime = new Date()),
          this.dispatchEvent('dragMove', t, [e, i])
      }),
      (o.dragEnd = function (t, e) {
        this.options.freeScroll && (this.isFreeScrolling = !0)
        var i,
          n = this.dragEndRestingSelect()
        this.options.freeScroll && !this.options.wrapAround ? ((i = this.getRestingPosition()), (this.isFreeScrolling = -i > this.slides[0].target && -i < this.getLastSlide().target)) : this.options.freeScroll || n != this.selectedIndex || (n += this.dragEndBoostSelect()),
          delete this.previousDragX,
          (this.isDragSelect = this.options.wrapAround),
          this.select(n),
          delete this.isDragSelect,
          this.dispatchEvent('dragEnd', t, [e])
      }),
      (o.dragEndRestingSelect = function () {
        var t = this.getRestingPosition(),
          e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
          i = this._getClosestResting(t, e, 1),
          e = this._getClosestResting(t, e, -1)
        return (i.distance < e.distance ? i : e).index
      }),
      (o._getClosestResting = function (t, e, i) {
        for (
          var n = this.selectedIndex,
            s = 1 / 0,
            r =
              this.options.contain && !this.options.wrapAround
                ? function (t, e) {
                    return t <= e
                  }
                : function (t, e) {
                    return t < e
                  };
          r(e, s) && ((n += i), (s = e), null !== (e = this.getSlideDistance(-t, n)));

        )
          e = Math.abs(e)
        return { distance: s, index: n - i }
      }),
      (o.getSlideDistance = function (t, e) {
        var i = this.slides.length,
          n = this.options.wrapAround && 1 < i,
          s = n ? r.modulo(e, i) : e,
          s = this.slides[s]
        if (!s) return null
        i = n ? this.slideableWidth * Math.floor(e / i) : 0
        return t - (s.target + i)
      }),
      (o.dragEndBoostSelect = function () {
        if (void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date() - this.dragMoveTime) return 0
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
          e = this.previousDragX - this.dragX
        return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0
      }),
      (o.staticClick = function (t, e) {
        var i = this.getParentCell(t.target),
          n = i && i.element,
          i = i && this.cells.indexOf(i)
        this.dispatchEvent('staticClick', t, [e, n, i])
      }),
      (o.onscroll = function () {
        var t = s(),
          e = this.pointerDownScroll.x - t.x,
          t = this.pointerDownScroll.y - t.y
        ;(3 < Math.abs(e) || 3 < Math.abs(t)) && this._pointerDone()
      }),
      t
    )
  }),
  (function (e, i) {
    'function' == typeof define && define.amd
      ? define('tap-listener/tap-listener', ['unipointer/unipointer'], function (t) {
          return i(e, t)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(e, require('unipointer')))
      : (e.TapListener = i(e, e.Unipointer))
  })(window, function (a, l) {
    function t(t) {
      this.bindTap(t)
    }
    var e = (t.prototype = Object.create(l.prototype))
    return (
      (e.bindTap = function (t) {
        t && (this.unbindTap(), (this.tapElement = t), this._bindStartEvent(t, !0))
      }),
      (e.unbindTap = function () {
        this.tapElement && (this._bindStartEvent(this.tapElement, !0), delete this.tapElement)
      }),
      (e.pointerUp = function (t, e) {
        var i, n, s, r, o
        ;(this.isIgnoringMouseUp && 'mouseup' == t.type) ||
          ((i = l.getPointerPoint(e)),
          (n = this.tapElement.getBoundingClientRect()),
          (s = a.pageXOffset),
          (r = a.pageYOffset),
          i.x >= n.left + s && i.x <= n.right + s && i.y >= n.top + r && i.y <= n.bottom + r && this.emitEvent('tap', [t, e]),
          'mouseup' != t.type &&
            ((this.isIgnoringMouseUp = !0),
            (o = this),
            setTimeout(function () {
              delete o.isIgnoringMouseUp
            }, 400)))
      }),
      (e.destroy = function () {
        this.pointerDone(), this.unbindTap()
      }),
      t
    )
  }),
  (function (t, n) {
    'function' == typeof define && define.amd
      ? define('flickity/js/prev-next-button', ['./flickity', 'tap-listener/tap-listener', 'fizzy-ui-utils/utils'], function (t, e, i) {
          return n(0, t, e, i)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = n(0, require('./flickity'), require('tap-listener'), require('fizzy-ui-utils')))
      : n(0, t.Flickity, t.TapListener, t.fizzyUIUtils)
  })(window, function (t, e, i, n) {
    'use strict'
    function s(t, e) {
      ;(this.direction = t), (this.parent = e), this._create()
    }
    var r = 'http://www.w3.org/2000/svg'
    ;((s.prototype = new i())._create = function () {
      ;(this.isEnabled = !0), (this.isPrevious = -1 == this.direction)
      var t = this.parent.options.rightToLeft ? 1 : -1
      this.isLeft = this.direction == t
      var e = (this.element = document.createElement('button'))
      ;(e.className = 'flickity-prev-next-button'), (e.className += this.isPrevious ? ' previous' : ' next'), e.setAttribute('type', 'button'), this.disable(), e.setAttribute('aria-label', this.isPrevious ? 'previous' : 'next')
      t = this.createSVG()
      e.appendChild(t), this.on('tap', this.onTap), this.parent.on('select', this.update.bind(this)), this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent))
    }),
      (s.prototype.activate = function () {
        this.bindTap(this.element), this.element.addEventListener('click', this), this.parent.element.appendChild(this.element)
      }),
      (s.prototype.deactivate = function () {
        this.parent.element.removeChild(this.element), i.prototype.destroy.call(this), this.element.removeEventListener('click', this)
      }),
      (s.prototype.createSVG = function () {
        var t = document.createElementNS(r, 'svg')
        t.setAttribute('viewBox', '0 0 100 100')
        var e,
          i = document.createElementNS(r, 'path'),
          e = 'string' == typeof (e = this.parent.options.arrowShape) ? e : 'M ' + e.x0 + ',50 L ' + e.x1 + ',' + (e.y1 + 50) + ' L ' + e.x2 + ',' + (e.y2 + 50) + ' L ' + e.x3 + ',50  L ' + e.x2 + ',' + (50 - e.y2) + ' L ' + e.x1 + ',' + (50 - e.y1) + ' Z'
        return i.setAttribute('d', e), i.setAttribute('class', 'arrow'), this.isLeft || i.setAttribute('transform', 'translate(100, 100) rotate(180) '), t.appendChild(i), t
      }),
      (s.prototype.onTap = function () {
        var t
        this.isEnabled && (this.parent.uiChange(), (t = this.isPrevious ? 'previous' : 'next'), this.parent[t]())
      }),
      (s.prototype.handleEvent = n.handleEvent),
      (s.prototype.onclick = function () {
        var t = document.activeElement
        t && t == this.element && this.onTap()
      }),
      (s.prototype.enable = function () {
        this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0))
      }),
      (s.prototype.disable = function () {
        this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1))
      }),
      (s.prototype.update = function () {
        var t = this.parent.slides
        this.parent.options.wrapAround && 1 < t.length ? this.enable() : ((t = t.length ? t.length - 1 : 0), (t = this.isPrevious ? 0 : t), this[this.parent.selectedIndex == t ? 'disable' : 'enable']())
      }),
      (s.prototype.destroy = function () {
        this.deactivate()
      }),
      n.extend(e.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
      e.createMethods.push('_createPrevNextButtons')
    n = e.prototype
    return (
      (n._createPrevNextButtons = function () {
        this.options.prevNextButtons && ((this.prevButton = new s(-1, this)), (this.nextButton = new s(1, this)), this.on('activate', this.activatePrevNextButtons))
      }),
      (n.activatePrevNextButtons = function () {
        this.prevButton.activate(), this.nextButton.activate(), this.on('deactivate', this.deactivatePrevNextButtons)
      }),
      (n.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate(), this.nextButton.deactivate(), this.off('deactivate', this.deactivatePrevNextButtons)
      }),
      (e.PrevNextButton = s),
      e
    )
  }),
  (function (t, n) {
    'function' == typeof define && define.amd
      ? define('flickity/js/page-dots', ['./flickity', 'tap-listener/tap-listener', 'fizzy-ui-utils/utils'], function (t, e, i) {
          return n(0, t, e, i)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = n(0, require('./flickity'), require('tap-listener'), require('fizzy-ui-utils')))
      : n(0, t.Flickity, t.TapListener, t.fizzyUIUtils)
  })(window, function (t, e, i, n) {
    function s(t) {
      ;(this.parent = t), this._create()
    }
    ;((s.prototype = new i())._create = function () {
      ;(this.holder = document.createElement('ol')), (this.holder.className = 'flickity-page-dots'), (this.dots = []), this.on('tap', this.onTap), this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent))
    }),
      (s.prototype.activate = function () {
        this.setDots(), this.bindTap(this.holder), this.parent.element.appendChild(this.holder)
      }),
      (s.prototype.deactivate = function () {
        this.parent.element.removeChild(this.holder), i.prototype.destroy.call(this)
      }),
      (s.prototype.setDots = function () {
        var t = this.parent.slides.length - this.dots.length
        0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t)
      }),
      (s.prototype.addDots = function (t) {
        for (var e = document.createDocumentFragment(), i = []; t; ) {
          var n = document.createElement('li')
          ;(n.className = 'dot'), e.appendChild(n), i.push(n), t--
        }
        this.holder.appendChild(e), (this.dots = this.dots.concat(i))
      }),
      (s.prototype.removeDots = function (t) {
        this.dots.splice(this.dots.length - t, t).forEach(function (t) {
          this.holder.removeChild(t)
        }, this)
      }),
      (s.prototype.updateSelected = function () {
        this.selectedDot && (this.selectedDot.className = 'dot'), this.dots.length && ((this.selectedDot = this.dots[this.parent.selectedIndex]), (this.selectedDot.className = 'dot is-selected'))
      }),
      (s.prototype.onTap = function (t) {
        t = t.target
        'LI' == t.nodeName && (this.parent.uiChange(), (t = this.dots.indexOf(t)), this.parent.select(t))
      }),
      (s.prototype.destroy = function () {
        this.deactivate()
      }),
      (e.PageDots = s),
      n.extend(e.defaults, { pageDots: !0 }),
      e.createMethods.push('_createPageDots')
    n = e.prototype
    return (
      (n._createPageDots = function () {
        this.options.pageDots && ((this.pageDots = new s(this)), this.on('activate', this.activatePageDots), this.on('select', this.updateSelectedPageDots), this.on('cellChange', this.updatePageDots), this.on('resize', this.updatePageDots), this.on('deactivate', this.deactivatePageDots))
      }),
      (n.activatePageDots = function () {
        this.pageDots.activate()
      }),
      (n.updateSelectedPageDots = function () {
        this.pageDots.updateSelected()
      }),
      (n.updatePageDots = function () {
        this.pageDots.setDots()
      }),
      (n.deactivatePageDots = function () {
        this.pageDots.deactivate()
      }),
      (e.PageDots = s),
      e
    )
  }),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define('flickity/js/player', ['ev-emitter/ev-emitter', 'fizzy-ui-utils/utils', './flickity'], e)
      : 'object' == typeof module && module.exports
      ? (module.exports = e(require('ev-emitter'), require('fizzy-ui-utils'), require('./flickity')))
      : e(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
  })(window, function (t, e, i) {
    function n(t) {
      ;(this.parent = t),
        (this.state = 'stopped'),
        r &&
          ((this.onVisibilityChange = function () {
            this.visibilityChange()
          }.bind(this)),
          (this.onVisibilityPlay = function () {
            this.visibilityPlay()
          }.bind(this)))
    }
    var s, r
    'hidden' in document ? ((s = 'hidden'), (r = 'visibilitychange')) : 'webkitHidden' in document && ((s = 'webkitHidden'), (r = 'webkitvisibilitychange')),
      ((n.prototype = Object.create(t.prototype)).play = function () {
        var t
        'playing' != this.state && ((t = document[s]), r && t ? document.addEventListener(r, this.onVisibilityPlay) : ((this.state = 'playing'), r && document.addEventListener(r, this.onVisibilityChange), this.tick()))
      }),
      (n.prototype.tick = function () {
        var t, e
        'playing' == this.state &&
          ((t = 'number' == typeof (t = this.parent.options.autoPlay) ? t : 3e3),
          (e = this).clear(),
          (this.timeout = setTimeout(function () {
            e.parent.next(!0), e.tick()
          }, t)))
      }),
      (n.prototype.stop = function () {
        ;(this.state = 'stopped'), this.clear(), r && document.removeEventListener(r, this.onVisibilityChange)
      }),
      (n.prototype.clear = function () {
        clearTimeout(this.timeout)
      }),
      (n.prototype.pause = function () {
        'playing' == this.state && ((this.state = 'paused'), this.clear())
      }),
      (n.prototype.unpause = function () {
        'paused' == this.state && this.play()
      }),
      (n.prototype.visibilityChange = function () {
        this[document[s] ? 'pause' : 'unpause']()
      }),
      (n.prototype.visibilityPlay = function () {
        this.play(), document.removeEventListener(r, this.onVisibilityPlay)
      }),
      e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
      i.createMethods.push('_createPlayer')
    e = i.prototype
    return (
      (e._createPlayer = function () {
        ;(this.player = new n(this)), this.on('activate', this.activatePlayer), this.on('uiChange', this.stopPlayer), this.on('pointerDown', this.stopPlayer), this.on('deactivate', this.deactivatePlayer)
      }),
      (e.activatePlayer = function () {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener('mouseenter', this))
      }),
      (e.playPlayer = function () {
        this.player.play()
      }),
      (e.stopPlayer = function () {
        this.player.stop()
      }),
      (e.pausePlayer = function () {
        this.player.pause()
      }),
      (e.unpausePlayer = function () {
        this.player.unpause()
      }),
      (e.deactivatePlayer = function () {
        this.player.stop(), this.element.removeEventListener('mouseenter', this)
      }),
      (e.onmouseenter = function () {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener('mouseleave', this))
      }),
      (e.onmouseleave = function () {
        this.player.unpause(), this.element.removeEventListener('mouseleave', this)
      }),
      (i.Player = n),
      i
    )
  }),
  (function (t, i) {
    'function' == typeof define && define.amd
      ? define('flickity/js/add-remove-cell', ['./flickity', 'fizzy-ui-utils/utils'], function (t, e) {
          return i(0, t, e)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(0, require('./flickity'), require('fizzy-ui-utils')))
      : i(0, t.Flickity, t.fizzyUIUtils)
  })(window, function (t, e, o) {
    var i = e.prototype
    return (
      (i.insert = function (t, e) {
        var i,
          n,
          s,
          r,
          o = this._makeCells(t)
        o &&
          o.length &&
          ((n = this.cells.length),
          (e = void 0 === e ? n : e),
          (s = o),
          (r = document.createDocumentFragment()),
          s.forEach(function (t) {
            r.appendChild(t.element)
          }),
          (i = r),
          (t = e == n) ? this.slider.appendChild(i) : ((s = this.cells[e].element), this.slider.insertBefore(i, s)),
          0 === e ? (this.cells = o.concat(this.cells)) : t ? (this.cells = this.cells.concat(o)) : ((n = this.cells.splice(e, n - e)), (this.cells = this.cells.concat(o).concat(n))),
          this._sizeCells(o),
          (o = e > this.selectedIndex ? 0 : o.length),
          this._cellAddedRemoved(e, o))
      }),
      (i.append = function (t) {
        this.insert(t, this.cells.length)
      }),
      (i.prepend = function (t) {
        this.insert(t, 0)
      }),
      (i.remove = function (t) {
        for (var e = this.getCells(t), i = 0, n = e.length, s = 0; s < n; s++) {
          var r = e[s]
          i -= this.cells.indexOf(r) < this.selectedIndex ? 1 : 0
        }
        for (s = 0; s < n; s++) (r = e[s]).remove(), o.removeFrom(this.cells, r)
        e.length && this._cellAddedRemoved(0, i)
      }),
      (i._cellAddedRemoved = function (t, e) {
        ;(e = e || 0), (this.selectedIndex += e), (this.selectedIndex = Math.max(0, Math.min(this.slides.length - 1, this.selectedIndex))), this.cellChange(t, !0), this.emitEvent('cellAddedRemoved', [t, e])
      }),
      (i.cellSizeChange = function (t) {
        t = this.getCell(t)
        t && (t.getSize(), (t = this.cells.indexOf(t)), this.cellChange(t))
      }),
      (i.cellChange = function (t, e) {
        var i = this.slideableWidth
        this._positionCells(t),
          this._getWrapShiftCells(),
          this.setGallerySize(),
          this.emitEvent('cellChange', [t]),
          this.options.freeScroll ? ((i = i - this.slideableWidth), (this.x += i * this.cellAlign), this.positionSlider()) : (e && this.positionSliderAtSelected(), this.select(this.selectedIndex))
      }),
      e
    )
  }),
  (function (t, i) {
    'function' == typeof define && define.amd
      ? define('flickity/js/lazyload', ['./flickity', 'fizzy-ui-utils/utils'], function (t, e) {
          return i(0, t, e)
        })
      : 'object' == typeof module && module.exports
      ? (module.exports = i(0, require('./flickity'), require('fizzy-ui-utils')))
      : i(0, t.Flickity, t.fizzyUIUtils)
  })(window, function (t, e, i) {
    'use strict'
    function n(t, e) {
      ;(this.img = t), (this.flickity = e), this.load()
    }
    e.createMethods.push('_createLazyload')
    var s = e.prototype
    return (
      (s._createLazyload = function () {
        this.on('select', this.lazyLoad)
      }),
      (s.lazyLoad = function () {
        var e,
          t = this.options.lazyLoad
        t &&
          ((t = 'number' == typeof t ? t : 0),
          (t = this.getAdjacentCellElements(t)),
          (e = []),
          t.forEach(function (t) {
            t = 'IMG' == (t = t).nodeName && t.getAttribute('data-flickity-lazyload') ? [t] : ((t = t.querySelectorAll('img[data-flickity-lazyload]')), i.makeArray(t))
            e = e.concat(t)
          }),
          e.forEach(function (t) {
            new n(t, this)
          }, this))
      }),
      (n.prototype.handleEvent = i.handleEvent),
      (n.prototype.load = function () {
        this.img.addEventListener('load', this), this.img.addEventListener('error', this), (this.img.src = this.img.getAttribute('data-flickity-lazyload')), this.img.removeAttribute('data-flickity-lazyload')
      }),
      (n.prototype.onload = function (t) {
        this.complete(t, 'flickity-lazyloaded')
      }),
      (n.prototype.onerror = function (t) {
        this.complete(t, 'flickity-lazyerror')
      }),
      (n.prototype.complete = function (t, e) {
        this.img.removeEventListener('load', this), this.img.removeEventListener('error', this)
        var i = this.flickity.getParentCell(this.img),
          i = i && i.element
        this.flickity.cellSizeChange(i), this.img.classList.add(e), this.flickity.dispatchEvent('lazyLoad', t, i)
      }),
      (e.LazyLoader = n),
      e
    )
  }),
  (function (t) {
    'function' == typeof define && define.amd
      ? define('flickity/js/index', ['./flickity', './drag', './prev-next-button', './page-dots', './player', './add-remove-cell', './lazyload'], t)
      : 'object' == typeof module && module.exports && (module.exports = t(require('./flickity'), require('./drag'), require('./prev-next-button'), require('./page-dots'), require('./player'), require('./add-remove-cell'), require('./lazyload')))
  })(
    (window,
    function (t) {
      return t
    })
  ),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define('flickity-as-nav-for/as-nav-for', ['flickity/js/index', 'fizzy-ui-utils/utils'], e)
      : 'object' == typeof module && module.exports
      ? (module.exports = e(require('flickity'), require('fizzy-ui-utils')))
      : (t.Flickity = e(t.Flickity, t.fizzyUIUtils))
  })(window, function (i, n) {
    i.createMethods.push('_createAsNavFor')
    var t = i.prototype
    return (
      (t._createAsNavFor = function () {
        this.on('activate', this.activateAsNavFor), this.on('deactivate', this.deactivateAsNavFor), this.on('destroy', this.destroyAsNavFor)
        var t,
          e = this.options.asNavFor
        e &&
          ((t = this),
          setTimeout(function () {
            t.setNavCompanion(e)
          }))
      }),
      (t.setNavCompanion = function (t) {
        t = n.getQueryElement(t)
        var e,
          t = i.data(t)
        t &&
          t != this &&
          ((this.navCompanion = t),
          ((e = this).onNavCompanionSelect = function () {
            e.navCompanionSelect()
          }),
          t.on('select', this.onNavCompanionSelect),
          this.on('staticClick', this.onNavStaticClick),
          this.navCompanionSelect(!0))
      }),
      (t.navCompanionSelect = function (t) {
        var e, i, n, s, r
        this.navCompanion &&
          ((r = this.navCompanion.selectedCells[0]),
          (i = (e = this.navCompanion.cells.indexOf(r)) + this.navCompanion.selectedCells.length - 1),
          (n = Math.floor(((n = e), (s = i), (r = this.navCompanion.cellAlign), (s - n) * r + n))),
          this.selectCell(n, !1, t),
          this.removeNavSelectedElements(),
          n >= this.cells.length ||
            ((i = this.cells.slice(e, 1 + i)),
            (this.navSelectedElements = i.map(function (t) {
              return t.element
            })),
            this.changeNavSelectedClass('add')))
      }),
      (t.changeNavSelectedClass = function (e) {
        this.navSelectedElements.forEach(function (t) {
          t.classList[e]('is-nav-selected')
        })
      }),
      (t.activateAsNavFor = function () {
        this.navCompanionSelect(!0)
      }),
      (t.removeNavSelectedElements = function () {
        this.navSelectedElements && (this.changeNavSelectedClass('remove'), delete this.navSelectedElements)
      }),
      (t.onNavStaticClick = function (t, e, i, n) {
        'number' == typeof n && this.navCompanion.selectCell(n)
      }),
      (t.deactivateAsNavFor = function () {
        this.removeNavSelectedElements()
      }),
      (t.destroyAsNavFor = function () {
        this.navCompanion && (this.navCompanion.off('select', this.onNavCompanionSelect), this.off('staticClick', this.onNavStaticClick), delete this.navCompanion)
      }),
      i
    )
  }),
  (function (t, e) {
    'function' == typeof define && define.amd ? define(e) : 'object' == typeof exports ? (module.exports = e()) : (t.PhotoSwipe = e())
  })(this, function () {
    'use strict'
    return function (f, i, t, e) {
      var p = {
        features: null,
        bind: function (t, e, i, n) {
          var s = (n ? 'remove' : 'add') + 'EventListener'
          e = e.split(' ')
          for (var r = 0; r < e.length; r++) e[r] && t[s](e[r], i, !1)
        },
        isArray: function (t) {
          return t instanceof Array
        },
        createEl: function (t, e) {
          e = document.createElement(e || 'div')
          return t && (e.className = t), e
        },
        getScrollY: function () {
          var t = window.pageYOffset
          return void 0 !== t ? t : document.documentElement.scrollTop
        },
        unbind: function (t, e, i) {
          p.bind(t, e, i, !0)
        },
        removeClass: function (t, e) {
          e = new RegExp('(\\s|^)' + e + '(\\s|$)')
          t.className = t.className
            .replace(e, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '')
        },
        addClass: function (t, e) {
          p.hasClass(t, e) || (t.className += (t.className ? ' ' : '') + e)
        },
        hasClass: function (t, e) {
          return t.className && new RegExp('(^|\\s)' + e + '(\\s|$)').test(t.className)
        },
        getChildByClass: function (t, e) {
          for (var i = t.firstChild; i; ) {
            if (p.hasClass(i, e)) return i
            i = i.nextSibling
          }
        },
        arraySearch: function (t, e, i) {
          for (var n = t.length; n--; ) if (t[n][i] === e) return n
          return -1
        },
        extend: function (t, e, i) {
          for (var n in e)
            if (e.hasOwnProperty(n)) {
              if (i && t.hasOwnProperty(n)) continue
              t[n] = e[n]
            }
        },
        easing: {
          sine: {
            out: function (t) {
              return Math.sin(t * (Math.PI / 2))
            },
            inOut: function (t) {
              return -(Math.cos(Math.PI * t) - 1) / 2
            },
          },
          cubic: {
            out: function (t) {
              return --t * t * t + 1
            },
          },
        },
        detectFeatures: function () {
          if (p.features) return p.features
          var t,
            e,
            i = p.createEl().style,
            n = '',
            s = {}
          ;(s.oldIE = document.all && !document.addEventListener),
            (s.touch = 'ontouchstart' in window),
            window.requestAnimationFrame && ((s.raf = window.requestAnimationFrame), (s.caf = window.cancelAnimationFrame)),
            (s.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled),
            s.pointerEvent ||
              ((t = navigator.userAgent),
              !/iP(hone|od)/.test(navigator.platform) || ((e = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)) && 0 < e.length && 1 <= (e = parseInt(e[1], 10)) && e < 8 && (s.isOldIOSPhone = !0)),
              (e = (e = t.match(/Android\s([0-9\.]*)/)) ? e[1] : 0),
              1 <= (e = parseFloat(e)) && (e < 4.4 && (s.isOldAndroid = !0), (s.androidVersion = e)),
              (s.isMobileOpera = /opera mini|opera mobi/i.test(t)))
          for (var r, o, a, l = ['transform', 'perspective', 'animationName'], h = ['', 'webkit', 'Moz', 'ms', 'O'], c = 0; c < 4; c++) {
            n = h[c]
            for (var u = 0; u < 3; u++) (r = l[u]), (o = n + (n ? r.charAt(0).toUpperCase() + r.slice(1) : r)), !s[r] && o in i && (s[r] = o)
            n && !s.raf && ((n = n.toLowerCase()), (s.raf = window[n + 'RequestAnimationFrame']), s.raf && (s.caf = window[n + 'CancelAnimationFrame'] || window[n + 'CancelRequestAnimationFrame']))
          }
          return (
            s.raf ||
              ((a = 0),
              (s.raf = function (t) {
                var e = new Date().getTime(),
                  i = Math.max(0, 16 - (e - a)),
                  n = window.setTimeout(function () {
                    t(e + i)
                  }, i)
                return (a = e + i), n
              }),
              (s.caf = function (t) {
                clearTimeout(t)
              })),
            (s.svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect),
            (p.features = s)
          )
        },
      }
      p.detectFeatures(),
        p.features.oldIE &&
          (p.bind = function (t, e, i, n) {
            e = e.split(' ')
            for (
              var s,
                r = (n ? 'detach' : 'attach') + 'Event',
                o = function () {
                  i.handleEvent.call(i)
                },
                a = 0;
              a < e.length;
              a++
            )
              if ((s = e[a]))
                if ('object' == typeof i && i.handleEvent) {
                  if (n) {
                    if (!i['oldIE' + s]) return !1
                  } else i['oldIE' + s] = o
                  t[r]('on' + s, i['oldIE' + s])
                } else t[r]('on' + s, i)
          })
      var m = this,
        g = {
          allowPanToNext: !0,
          spacing: 0.12,
          bgOpacity: 1,
          mouseUsed: !1,
          loop: !0,
          pinchToClose: !0,
          closeOnScroll: !0,
          closeOnVerticalDrag: !0,
          verticalDragRange: 0.75,
          hideAnimationDuration: 333,
          showAnimationDuration: 333,
          showHideOpacity: !1,
          focus: !0,
          escKey: !0,
          arrowKeys: !0,
          mainScrollEndFriction: 0.35,
          panEndFriction: 0.35,
          isClickableElement: function (t) {
            return 'A' === t.tagName
          },
          getDoubleTapZoom: function (t, e) {
            return t || e.initialZoomLevel < 0.7 ? 1 : 1.33
          },
          maxSpreadZoom: 1.33,
          modal: !0,
          scaleMode: 'fit',
        }
      p.extend(g, e)
      function n() {
        return { x: 0, y: 0 }
      }
      function s(t, e) {
        p.extend(m, e.publicMethods), $t.push(t)
      }
      function o(t) {
        var e = He()
        return e - 1 < t ? t - e : t < 0 ? e + t : t
      }
      function r(t, e) {
        return te[t] || (te[t] = []), te[t].push(e)
      }
      function v(t) {
        var e = te[t]
        if (e) {
          var i = Array.prototype.slice.call(arguments)
          i.shift()
          for (var n = 0; n < e.length; n++) e[n].apply(m, i)
        }
      }
      function c() {
        return new Date().getTime()
      }
      function _(t) {
        ;(Xt = t), (m.bg.style.opacity = t * g.bgOpacity)
      }
      function a(t, e, i, n, s) {
        ;(!Jt || (s && s !== m.currItem)) && (n /= (s || m.currItem).fitRatio), (t[at] = $ + e + 'px, ' + i + 'px' + K + ' scale(' + n + ')')
      }
      function u(t, e) {
        var i
        !g.loop && e && ((i = W + (Vt.x * Ht - t) / Vt.x), (e = Math.round(t - xe.x)), ((i < 0 && 0 < e) || (i >= He() - 1 && e < 0)) && (t = xe.x + e * g.mainScrollEndFriction)), (xe.x = t), ne(t, Y)
      }
      function l(t, e) {
        var i = we[t] - Zt[t]
        return Wt[t] + Ut[t] + i - (e / Q) * i
      }
      function y(t, e) {
        ;(t.x = e.x), (t.y = e.y), e.id && (t.id = e.id)
      }
      function h(t) {
        ;(t.x = Math.round(t.x)), (t.y = Math.round(t.y))
      }
      function d(t, e) {
        return (t = $e(m.currItem, qt, t)), e && (zt = t), t
      }
      function x(t) {
        return (t = t || m.currItem).fitRatio
      }
      function w(t) {
        return 0 < (t = t || m.currItem).w ? g.maxSpreadZoom : 1
      }
      function b(t, e, i, n) {
        return n === m.currItem.initialZoomLevel ? ((i[t] = m.currItem.initialPosition[t]), !0) : ((i[t] = l(t, n)), i[t] > e.min[t] ? ((i[t] = e.min[t]), !0) : i[t] < e.max[t] && ((i[t] = e.max[t]), !0))
      }
      function T(t) {
        var e = ''
        g.escKey && 27 === t.keyCode ? (e = 'close') : g.arrowKeys && (37 === t.keyCode ? (e = 'prev') : 39 === t.keyCode && (e = 'next')), e && (t.ctrlKey || t.altKey || t.shiftKey || t.metaKey || (t.preventDefault ? t.preventDefault() : (t.returnValue = !1), m[e]()))
      }
      function S(t) {
        t && (kt || Ct || Rt || bt) && (t.preventDefault(), t.stopPropagation())
      }
      function P() {
        m.setScrollOffset(0, p.getScrollY())
      }
      function C(t) {
        oe[t] && (oe[t].raf && ut(oe[t].raf), ae--, delete oe[t])
      }
      function k(t) {
        oe[t] && C(t), oe[t] || (ae++, (oe[t] = {}))
      }
      function E() {
        for (var t in oe) oe.hasOwnProperty(t) && C(t)
      }
      function O(t, e, i, n, s, r, o) {
        var a,
          l = c()
        k(t)
        var h = function () {
          if (oe[t]) {
            if (((a = c() - l), n <= a)) return C(t), r(i), void (o && o())
            r((i - e) * s(a / n) + e), (oe[t].raf = ct(h))
          }
        }
        h()
      }
      function A(t, e) {
        return (ge.x = Math.abs(t.x - e.x)), (ge.y = Math.abs(t.y - e.y)), Math.sqrt(ge.x * ge.x + ge.y * ge.y)
      }
      function D(t, e) {
        return (Ce.prevent = !Pe(t.target, g.isClickableElement)), v('preventDragEvent', t, e, Ce), Ce.prevent
      }
      function M(t, e) {
        return (e.x = t.pageX), (e.y = t.pageY), (e.id = t.identifier), e
      }
      function z(t, e, i) {
        ;(i.x = 0.5 * (t.x + e.x)), (i.y = 0.5 * (t.y + e.y))
      }
      function L() {
        var t = Yt.y - m.currItem.initialPosition.y
        return 1 - Math.abs(t / (qt.y / 2))
      }
      function R(t) {
        for (; 0 < Oe.length; ) Oe.pop()
        return (
          lt
            ? ((Bt = 0),
              fe.forEach(function (t) {
                0 === Bt ? (Oe[0] = t) : 1 === Bt && (Oe[1] = t), Bt++
              }))
            : -1 < t.type.indexOf('touch')
            ? t.touches && 0 < t.touches.length && ((Oe[0] = M(t.touches[0], ke)), 1 < t.touches.length && (Oe[1] = M(t.touches[1], Ee)))
            : ((ke.x = t.pageX), (ke.y = t.pageY), (ke.id = ''), (Oe[0] = ke)),
          Oe
        )
      }
      function I(t, e) {
        var i,
          n,
          s,
          r = Yt[t] + e[t],
          o = 0 < e[t],
          a = xe.x + e.x,
          l = xe.x - pe.x,
          h = r > zt.min[t] || r < zt.max[t] ? g.panEndFriction : 1,
          r = Yt[t] + e[t] * h
        return g.allowPanToNext &&
          (Lt
            ? 'h' !== It ||
              'x' !== t ||
              Ct ||
              (o
                ? (r > zt.min[t] && ((h = g.panEndFriction), zt.min[t], (i = zt.min[t] - Wt[t])), (i <= 0 || l < 0) && 1 < He() ? ((s = a), l < 0 && a > pe.x && (s = pe.x)) : zt.min.x !== zt.max.x && (n = r))
                : (r < zt.max[t] && ((h = g.panEndFriction), zt.max[t], (i = Wt[t] - zt.max[t])), (i <= 0 || 0 < l) && 1 < He() ? ((s = a), 0 < l && a < pe.x && (s = pe.x)) : zt.min.x !== zt.max.x && (n = r)))
            : (s = a),
          'x' === t)
          ? (void 0 !== s && (u(s, !0), (Ot = s !== pe.x)), zt.min.x !== zt.max.x && (void 0 !== n ? (Yt.x = n) : Ot || (Yt.x += e.x * h)), void 0 !== s)
          : void (Rt || Ot || (G > m.currItem.fitRatio && (Yt[t] += e[t] * h)))
      }
      function F(t) {
        var e
        ;('mousedown' === t.type && 0 < t.button) ||
          (Ye
            ? t.preventDefault()
            : (Tt && 'mousedown' === t.type) ||
              (D(t, !0) && t.preventDefault(),
              v('pointerDown'),
              lt && ((e = p.arraySearch(fe, t.pointerId, 'id')) < 0 && (e = fe.length), (fe[e] = { x: t.pageX, y: t.pageY, id: t.pointerId })),
              (t = (e = R(t)).length),
              (At = null),
              E(),
              (St && 1 !== t) || ((St = Ft = !0), p.bind(window, H, m), (wt = jt = Nt = bt = Ot = kt = Pt = Ct = !1), (It = null), v('firstTouchStart', e), y(Wt, Yt), (Ut.x = Ut.y = 0), y(ue, e[0]), y(de, ue), (pe.x = Vt.x * Ht), (me = [{ x: ue.x, y: ue.y }]), (yt = _t = c()), d(G, !0), Te(), Se()),
              !Dt && 1 < t && !Rt && !Ot && ((Q = G), (Dt = Pt = !(Ct = !1)), (Ut.y = Ut.x = 0), y(Wt, Yt), y(le, e[0]), y(he, e[1]), z(le, he, be), (we.x = Math.abs(be.x) - Yt.x), (we.y = Math.abs(be.y) - Yt.y), (Mt = A(le, he)))))
      }
      function N(t) {
        var e, i
        t.preventDefault(),
          lt && -1 < (e = p.arraySearch(fe, t.pointerId, 'id')) && (((i = fe[e]).x = t.pageX), (i.y = t.pageY)),
          St && ((i = R(t)), It || kt || Dt ? (At = i) : xe.x !== Vt.x * Ht ? (It = 'h') : ((t = Math.abs(i[0].x - ue.x) - Math.abs(i[0].y - ue.y)), 10 <= Math.abs(t) && ((It = 0 < t ? 'h' : 'v'), (At = i))))
      }
      function X(t) {
        if (gt.isOldAndroid) {
          if (Tt && 'mouseup' === t.type) return
          ;-1 < t.type.indexOf('touch') &&
            (clearTimeout(Tt),
            (Tt = setTimeout(function () {
              Tt = 0
            }, 600)))
        }
        v('pointerUp'),
          D(t, !1) && t.preventDefault(),
          !lt || (-1 < (i = p.arraySearch(fe, t.pointerId, 'id')) && ((r = fe.splice(i, 1)[0]), navigator.pointerEnabled ? (r.type = t.pointerType || 'mouse') : ((r.type = { 4: 'mouse', 2: 'touch', 3: 'pen' }[t.pointerType]), r.type || (r.type = t.pointerType || 'mouse'))))
        var e = R(t),
          i = e.length
        if (('mouseup' === t.type && (i = 0), 2 === i)) return !(At = null)
        1 === i && y(de, e[0]), 0 !== i || It || Rt || (r || ('mouseup' === t.type ? (r = { x: t.pageX, y: t.pageY, type: 'mouse' }) : t.changedTouches && t.changedTouches[0] && (r = { x: t.changedTouches[0].pageX, y: t.changedTouches[0].pageY, type: 'touch' })), v('touchRelease', t, r))
        var n,
          s,
          r = -1
        if (
          (0 === i && ((St = !1), p.unbind(window, H, m), Te(), Dt ? (r = 0) : -1 !== ye && (r = c() - ye)),
          (ye = 1 === i ? c() : -1),
          (r = -1 !== r && r < 150 ? 'zoom' : 'swipe'),
          Dt && i < 2 && ((Dt = !1), 1 === i && (r = 'zoomPointerUp'), v('zoomGestureEnded')),
          (At = null),
          kt || Ct || Rt || bt)
        )
          if ((E(), (xt = xt || De()).calculateSwipeSpeed('x'), bt))
            L() < g.verticalDragRange
              ? m.close()
              : ((n = Yt.y),
                (s = Xt),
                O('verticalDrag', 0, 1, 300, p.easing.cubic.out, function (t) {
                  ;(Yt.y = (m.currItem.initialPosition.y - n) * t + n), _((1 - s) * t + s), ee()
                }),
                v('onVerticalDrag', 1))
          else {
            if ((Ot || Rt) && 0 === i) {
              if (ze(r, xt)) return
              r = 'zoomPointerUp'
            }
            if (!Rt) return 'swipe' !== r ? void Re() : void (!Ot && G > m.currItem.fitRatio && Me(xt))
          }
      }
      var j,
        B,
        U,
        W,
        Y,
        q,
        H,
        Z,
        V,
        G,
        Q,
        $,
        K,
        J,
        tt,
        et,
        it,
        nt,
        st,
        rt,
        ot,
        at,
        lt,
        ht,
        ct,
        ut,
        dt,
        ft,
        pt,
        mt,
        gt,
        vt,
        _t,
        yt,
        xt,
        wt,
        bt,
        Tt,
        St,
        Pt,
        Ct,
        kt,
        Et,
        Ot,
        At,
        Dt,
        Mt,
        zt,
        Lt,
        Rt,
        It,
        Ft,
        Nt,
        Xt,
        jt,
        Bt,
        Ut = n(),
        Wt = n(),
        Yt = n(),
        qt = {},
        Ht = 0,
        Zt = {},
        Vt = n(),
        Gt = 0,
        Qt = !0,
        $t = [],
        Kt = {},
        Jt = !1,
        te = {},
        ee = function (t) {
          Lt && (t && (G > m.currItem.fitRatio ? Jt || (Ke(m.currItem, !1, !0), (Jt = !0)) : Jt && (Ke(m.currItem), (Jt = !1))), a(Lt, Yt.x, Yt.y, G))
        },
        ie = function (t) {
          t.container && a(t.container.style, t.initialPosition.x, t.initialPosition.y, t.initialZoomLevel, t)
        },
        ne = function (t, e) {
          e[at] = $ + t + 'px, 0px' + K
        },
        se = null,
        re = function () {
          se && (p.unbind(document, 'mousemove', re), p.addClass(f, 'pswp--has_mouse'), (g.mouseUsed = !0), v('mouseUsed')),
            (se = setTimeout(function () {
              se = null
            }, 100))
        },
        oe = {},
        ae = 0,
        e = {
          shout: v,
          listen: r,
          viewportSize: qt,
          options: g,
          isMainScrollAnimating: function () {
            return Rt
          },
          getZoomLevel: function () {
            return G
          },
          getCurrentIndex: function () {
            return W
          },
          isDragging: function () {
            return St
          },
          isZooming: function () {
            return Dt
          },
          setScrollOffset: function (t, e) {
            ;(Zt.x = t), (mt = Zt.y = e), v('updateScrollOffset', Zt)
          },
          applyZoomPan: function (t, e, i, n) {
            ;(Yt.x = e), (Yt.y = i), (G = t), ee(n)
          },
          init: function () {
            if (!j && !B) {
              var t
              ;(m.framework = p),
                (m.template = f),
                (m.bg = p.getChildByClass(f, 'pswp__bg')),
                (dt = f.className),
                (j = !0),
                (gt = p.detectFeatures()),
                (ct = gt.raf),
                (ut = gt.caf),
                (at = gt.transform),
                (pt = gt.oldIE),
                (m.scrollWrap = p.getChildByClass(f, 'pswp__scroll-wrap')),
                (m.container = p.getChildByClass(m.scrollWrap, 'pswp__container')),
                (Y = m.container.style),
                (m.itemHolders = et =
                  [
                    { el: m.container.children[0], wrap: 0, index: -1 },
                    { el: m.container.children[1], wrap: 0, index: -1 },
                    { el: m.container.children[2], wrap: 0, index: -1 },
                  ]),
                (et[0].el.style.display = et[2].el.style.display = 'none'),
                (function () {
                  if (at) {
                    var t = gt.perspective && !ht
                    return ($ = 'translate' + (t ? '3d(' : '(')), (K = gt.perspective ? ', 0px)' : ')')
                  }
                  ;(at = 'left'),
                    p.addClass(f, 'pswp--ie'),
                    (ne = function (t, e) {
                      e.left = t + 'px'
                    }),
                    (ie = function (t) {
                      var e = 1 < t.fitRatio ? 1 : t.fitRatio,
                        i = t.container.style,
                        n = e * t.w,
                        e = e * t.h
                      ;(i.width = n + 'px'), (i.height = e + 'px'), (i.left = t.initialPosition.x + 'px'), (i.top = t.initialPosition.y + 'px')
                    }),
                    (ee = function () {
                      var t, e, i, n
                      Lt && ((t = Lt), (i = (e = 1 < (n = m.currItem).fitRatio ? 1 : n.fitRatio) * n.w), (n = e * n.h), (t.width = i + 'px'), (t.height = n + 'px'), (t.left = Yt.x + 'px'), (t.top = Yt.y + 'px'))
                    })
                })(),
                (V = {
                  resize: m.updateSize,
                  orientationchange: function () {
                    clearTimeout(vt),
                      (vt = setTimeout(function () {
                        qt.x !== m.scrollWrap.clientWidth && m.updateSize()
                      }, 500))
                  },
                  scroll: P,
                  keydown: T,
                  click: S,
                })
              var e = gt.isOldIOSPhone || gt.isOldAndroid || gt.isMobileOpera
              for ((gt.animationName && gt.transform && !e) || (g.showAnimationDuration = g.hideAnimationDuration = 0), t = 0; t < $t.length; t++) m['init' + $t[t]]()
              i && (m.ui = new i(m, p)).init(),
                v('firstUpdate'),
                (W = W || g.index || 0),
                (isNaN(W) || W < 0 || W >= He()) && (W = 0),
                (m.currItem = qe(W)),
                (gt.isOldIOSPhone || gt.isOldAndroid) && (Qt = !1),
                f.setAttribute('aria-hidden', 'false'),
                g.modal && (Qt ? (f.style.position = 'fixed') : ((f.style.position = 'absolute'), (f.style.top = p.getScrollY() + 'px'))),
                void 0 === mt && (v('initialLayout'), (mt = ft = p.getScrollY()))
              e = 'pswp--open '
              for (
                g.mainClass && (e += g.mainClass + ' '), g.showHideOpacity && (e += 'pswp--animate_opacity '), e += ht ? 'pswp--touch' : 'pswp--notouch', e += gt.animationName ? ' pswp--css_animation' : '', e += gt.svg ? ' pswp--svg' : '', p.addClass(f, e), m.updateSize(), q = -1, Gt = null, t = 0;
                t < 3;
                t++
              )
                ne((t + q) * Vt.x, et[t].el.style)
              pt || p.bind(m.scrollWrap, Z, m),
                r('initialZoomInEnd', function () {
                  m.setContent(et[0], W - 1),
                    m.setContent(et[2], W + 1),
                    (et[0].el.style.display = et[2].el.style.display = 'block'),
                    g.focus && f.focus(),
                    p.bind(document, 'keydown', m),
                    gt.transform && p.bind(m.scrollWrap, 'click', m),
                    g.mouseUsed || p.bind(document, 'mousemove', re),
                    p.bind(window, 'resize scroll orientationchange', m),
                    v('bindEvents')
                }),
                m.setContent(et[1], W),
                m.updateCurrItem(),
                v('afterInit'),
                Qt ||
                  (J = setInterval(function () {
                    ae || St || Dt || G !== m.currItem.initialZoomLevel || m.updateSize()
                  }, 1e3)),
                p.addClass(f, 'pswp--visible')
            }
          },
          close: function () {
            j &&
              ((B = !(j = !1)),
              v('close'),
              p.unbind(window, 'resize scroll orientationchange', m),
              p.unbind(window, 'scroll', V.scroll),
              p.unbind(document, 'keydown', m),
              p.unbind(document, 'mousemove', re),
              gt.transform && p.unbind(m.scrollWrap, 'click', m),
              St && p.unbind(window, H, m),
              clearTimeout(vt),
              v('unbindEvents'),
              Ze(m.currItem, null, !0, m.destroy))
          },
          destroy: function () {
            v('destroy'), Be && clearTimeout(Be), f.setAttribute('aria-hidden', 'true'), (f.className = dt), J && clearInterval(J), p.unbind(m.scrollWrap, Z, m), p.unbind(window, 'scroll', m), Te(), E(), (te = null)
          },
          panTo: function (t, e, i) {
            i || (t > zt.min.x ? (t = zt.min.x) : t < zt.max.x && (t = zt.max.x), e > zt.min.y ? (e = zt.min.y) : e < zt.max.y && (e = zt.max.y)), (Yt.x = t), (Yt.y = e), ee()
          },
          handleEvent: function (t) {
            ;(t = t || window.event), V[t.type] && V[t.type](t)
          },
          goTo: function (t) {
            var e = (t = o(t)) - W
            ;(Gt = e), (W = t), (m.currItem = qe(W)), (Ht -= e), u(Vt.x * Ht), E(), (Rt = !1), m.updateCurrItem()
          },
          next: function () {
            m.goTo(W + 1)
          },
          prev: function () {
            m.goTo(W - 1)
          },
          updateCurrZoomItem: function (t) {
            var e
            t && v('beforeChange', 0), (Lt = et[1].el.children.length ? ((e = et[1].el.children[0]), p.hasClass(e, 'pswp__zoom-wrap') ? e.style : null) : null), (zt = m.currItem.bounds), (Q = G = m.currItem.initialZoomLevel), (Yt.x = zt.center.x), (Yt.y = zt.center.y), t && v('afterChange')
          },
          invalidateCurrItems: function () {
            tt = !0
            for (var t = 0; t < 3; t++) et[t].item && (et[t].item.needsUpdate = !0)
          },
          updateCurrItem: function (t) {
            if (0 !== Gt) {
              var e,
                i = Math.abs(Gt)
              if (!(t && i < 2)) {
                ;(m.currItem = qe(W)), (Jt = !1), v('beforeChange', Gt), 3 <= i && ((q += Gt + (0 < Gt ? -3 : 3)), (i = 3))
                for (var n = 0; n < i; n++) 0 < Gt ? ((e = et.shift()), (et[2] = e), ne((++q + 2) * Vt.x, e.el.style), m.setContent(e, W - i + n + 1 + 1)) : ((e = et.pop()), et.unshift(e), ne(--q * Vt.x, e.el.style), m.setContent(e, W + i - n - 1 - 1))
                !Lt || 1 !== Math.abs(Gt) || ((t = qe(it)).initialZoomLevel !== G && ($e(t, qt), Ke(t), ie(t))), (Gt = 0), m.updateCurrZoomItem(), (it = W), v('afterChange')
              }
            }
          },
          updateSize: function (t) {
            if (!Qt && g.modal) {
              var e = p.getScrollY()
              if ((mt !== e && ((f.style.top = e + 'px'), (mt = e)), !t && Kt.x === window.innerWidth && Kt.y === window.innerHeight)) return
              ;(Kt.x = window.innerWidth), (Kt.y = window.innerHeight), (f.style.height = Kt.y + 'px')
            }
            if (((qt.x = m.scrollWrap.clientWidth), (qt.y = m.scrollWrap.clientHeight), P(), (Vt.x = qt.x + Math.round(qt.x * g.spacing)), (Vt.y = qt.y), u(Vt.x * Ht), v('beforeResize'), void 0 !== q)) {
              for (var i, n, s, r = 0; r < 3; r++)
                (i = et[r]),
                  ne((r + q) * Vt.x, i.el.style),
                  (s = W + r - 1),
                  g.loop && 2 < He() && (s = o(s)),
                  (n = qe(s)) && (tt || n.needsUpdate || !n.bounds) ? (m.cleanSlide(n), m.setContent(i, s), 1 === r && ((m.currItem = n), m.updateCurrZoomItem(!0)), (n.needsUpdate = !1)) : -1 === i.index && 0 <= s && m.setContent(i, s),
                  n && n.container && ($e(n, qt), Ke(n), ie(n))
              tt = !1
            }
            ;(Q = G = m.currItem.initialZoomLevel), (zt = m.currItem.bounds) && ((Yt.x = zt.center.x), (Yt.y = zt.center.y), ee(!0)), v('resize')
          },
          zoomTo: function (e, t, i, n, s) {
            t && ((Q = G), (we.x = Math.abs(t.x) - Yt.x), (we.y = Math.abs(t.y) - Yt.y), y(Wt, Yt))
            var t = d(e, !1),
              r = {}
            b('x', t, r, e), b('y', t, r, e)
            var o = G,
              a = Yt.x,
              l = Yt.y
            h(r)
            t = function (t) {
              1 === t ? ((G = e), (Yt.x = r.x), (Yt.y = r.y)) : ((G = (e - o) * t + o), (Yt.x = (r.x - a) * t + a), (Yt.y = (r.y - l) * t + l)), s && s(t), ee(1 === t)
            }
            i ? O('customZoomTo', 0, 1, i, n || p.easing.sine.inOut, t) : t(1)
          },
        },
        le = {},
        he = {},
        ce = {},
        ue = {},
        de = {},
        fe = [],
        pe = {},
        me = [],
        ge = {},
        ve = 0,
        _e = n(),
        ye = 0,
        xe = n(),
        we = n(),
        be = n(),
        Te = function () {
          Et && (ut(Et), (Et = null))
        },
        Se = function () {
          St && ((Et = ct(Se)), Ae())
        },
        Pe = function (t, e) {
          return !(!t || t === document) && !(t.getAttribute('class') && -1 < t.getAttribute('class').indexOf('pswp__scroll-wrap')) && (e(t) ? t : Pe(t.parentNode, e))
        },
        Ce = {},
        ke = {},
        Ee = {},
        Oe = [],
        Ae = function () {
          if (At) {
            var t = At.length
            if (0 !== t)
              if ((y(le, At[0]), (ce.x = le.x - ue.x), (ce.y = le.y - ue.y), Dt && 1 < t))
                (ue.x = le.x),
                  (ue.y = le.y),
                  (ce.x || ce.y || ((r = At[1]), (o = he), r.x !== o.x || r.y !== o.y)) &&
                    (y(he, At[1]),
                    Ct || ((Ct = !0), v('zoomGestureStarted')),
                    (n = A(le, he)),
                    (s = Le(n)) > m.currItem.initialZoomLevel + m.currItem.initialZoomLevel / 15 && (jt = !0),
                    (i = 1),
                    (t = x()),
                    (r = w()),
                    s < t ? (g.pinchToClose && !jt && Q <= m.currItem.initialZoomLevel ? (_((o = 1 - (t - s) / (t / 1.2))), v('onPinchClose', o), (Nt = !0)) : (1 < (i = (t - s) / t) && (i = 1), (s = t - i * (t / 3)))) : r < s && (1 < (i = (s - r) / (6 * t)) && (i = 1), (s = r + i * t)),
                    i < 0 && (i = 0),
                    z(le, he, _e),
                    (Ut.x += _e.x - be.x),
                    (Ut.y += _e.y - be.y),
                    y(be, _e),
                    (Yt.x = l('x', s)),
                    (Yt.y = l('y', s)),
                    (wt = G < s),
                    (G = s),
                    ee())
              else if (It && (Ft && ((Ft = !1), 10 <= Math.abs(ce.x) && (ce.x -= At[0].x - de.x), 10 <= Math.abs(ce.y) && (ce.y -= At[0].y - de.y)), (ue.x = le.x), (ue.y = le.y), 0 !== ce.x || 0 !== ce.y)) {
                if ('v' === It && g.closeOnVerticalDrag && 'fit' === g.scaleMode && G === m.currItem.initialZoomLevel) {
                  ;(Ut.y += ce.y), (Yt.y += ce.y)
                  var e = L()
                  return (bt = !0), v('onVerticalDrag', e), _(e), void ee()
                }
                ;(i = c()), (n = le.x), (s = le.y), 50 < i - yt && (((e = 2 < me.length ? me.shift() : {}).x = n), (e.y = s), me.push(e), (yt = i)), (kt = !0), (zt = m.currItem.bounds), I('x', ce) || (I('y', ce), h(Yt), ee())
              }
          }
          var i, n, s, r, o
        },
        De = function () {
          var e,
            i,
            n = {
              lastFlickOffset: {},
              lastFlickDist: {},
              lastFlickSpeed: {},
              slowDownRatio: {},
              slowDownRatioReverse: {},
              speedDecelerationRatio: {},
              speedDecelerationRatioAbs: {},
              distanceOffset: {},
              backAnimDestination: {},
              backAnimStarted: {},
              calculateSwipeSpeed: function (t) {
                ;(i = 1 < me.length ? ((e = c() - yt + 50), me[me.length - 2][t]) : ((e = c() - _t), de[t])),
                  (n.lastFlickOffset[t] = ue[t] - i),
                  (n.lastFlickDist[t] = Math.abs(n.lastFlickOffset[t])),
                  20 < n.lastFlickDist[t] ? (n.lastFlickSpeed[t] = n.lastFlickOffset[t] / e) : (n.lastFlickSpeed[t] = 0),
                  Math.abs(n.lastFlickSpeed[t]) < 0.1 && (n.lastFlickSpeed[t] = 0),
                  (n.slowDownRatio[t] = 0.95),
                  (n.slowDownRatioReverse[t] = 1 - n.slowDownRatio[t]),
                  (n.speedDecelerationRatio[t] = 1)
              },
              calculateOverBoundsAnimOffset: function (e, t) {
                n.backAnimStarted[e] ||
                  (Yt[e] > zt.min[e] ? (n.backAnimDestination[e] = zt.min[e]) : Yt[e] < zt.max[e] && (n.backAnimDestination[e] = zt.max[e]),
                  void 0 !== n.backAnimDestination[e] &&
                    ((n.slowDownRatio[e] = 0.7),
                    (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                    n.speedDecelerationRatioAbs[e] < 0.05 &&
                      ((n.lastFlickSpeed[e] = 0),
                      (n.backAnimStarted[e] = !0),
                      O('bounceZoomPan' + e, Yt[e], n.backAnimDestination[e], t || 300, p.easing.sine.out, function (t) {
                        ;(Yt[e] = t), ee()
                      }))))
              },
              calculateAnimOffset: function (t) {
                n.backAnimStarted[t] ||
                  ((n.speedDecelerationRatio[t] = n.speedDecelerationRatio[t] * (n.slowDownRatio[t] + n.slowDownRatioReverse[t] - (n.slowDownRatioReverse[t] * n.timeDiff) / 10)),
                  (n.speedDecelerationRatioAbs[t] = Math.abs(n.lastFlickSpeed[t] * n.speedDecelerationRatio[t])),
                  (n.distanceOffset[t] = n.lastFlickSpeed[t] * n.speedDecelerationRatio[t] * n.timeDiff),
                  (Yt[t] += n.distanceOffset[t]))
              },
              panAnimLoop: function () {
                if (
                  oe.zoomPan &&
                  ((oe.zoomPan.raf = ct(n.panAnimLoop)),
                  (n.now = c()),
                  (n.timeDiff = n.now - n.lastNow),
                  (n.lastNow = n.now),
                  n.calculateAnimOffset('x'),
                  n.calculateAnimOffset('y'),
                  ee(),
                  n.calculateOverBoundsAnimOffset('x'),
                  n.calculateOverBoundsAnimOffset('y'),
                  n.speedDecelerationRatioAbs.x < 0.05 && n.speedDecelerationRatioAbs.y < 0.05)
                )
                  return (Yt.x = Math.round(Yt.x)), (Yt.y = Math.round(Yt.y)), ee(), void C('zoomPan')
              },
            }
          return n
        },
        Me = function (t) {
          return (
            t.calculateSwipeSpeed('y'),
            (zt = m.currItem.bounds),
            (t.backAnimDestination = {}),
            (t.backAnimStarted = {}),
            Math.abs(t.lastFlickSpeed.x) <= 0.05 && Math.abs(t.lastFlickSpeed.y) <= 0.05 ? ((t.speedDecelerationRatioAbs.x = t.speedDecelerationRatioAbs.y = 0), t.calculateOverBoundsAnimOffset('x'), t.calculateOverBoundsAnimOffset('y'), !0) : (k('zoomPan'), (t.lastNow = c()), void t.panAnimLoop())
          )
        },
        ze = function (t, e) {
          var i, n
          Rt || (ve = W),
            'swipe' === t && ((n = ue.x - de.x), (t = e.lastFlickDist.x < 10), 30 < n && (t || 20 < e.lastFlickOffset.x) ? (r = -1) : n < -30 && (t || e.lastFlickOffset.x < -20) && (r = 1)),
            r && ((W += r) < 0 ? ((W = g.loop ? He() - 1 : 0), (s = !0)) : W >= He() && ((W = g.loop ? 0 : He() - 1), (s = !0)), (s && !g.loop) || ((Gt += r), (Ht -= r), (i = !0)))
          var s = Vt.x * Ht,
            r = Math.abs(s - xe.x),
            o = i || s > xe.x == 0 < e.lastFlickSpeed.x ? ((o = 0 < Math.abs(e.lastFlickSpeed.x) ? r / Math.abs(e.lastFlickSpeed.x) : 333), (o = Math.min(o, 400)), Math.max(o, 250)) : 333
          return (
            ve === W && (i = !1),
            (Rt = !0),
            v('mainScrollAnimStart'),
            O('mainScroll', xe.x, s, o, p.easing.cubic.out, u, function () {
              E(), (Rt = !1), (ve = -1), (!i && ve === W) || m.updateCurrItem(), v('mainScrollAnimComplete')
            }),
            i && m.updateCurrItem(!0),
            i
          )
        },
        Le = function (t) {
          return (1 / Mt) * t * Q
        },
        Re = function () {
          var t = G,
            e = x(),
            i = w()
          G < e ? (t = e) : i < G && (t = i)
          var n,
            s = Xt
          return (
            Nt && !wt && !jt && G < e
              ? m.close()
              : (Nt &&
                  (n = function (t) {
                    _((1 - s) * t + s)
                  }),
                m.zoomTo(t, 0, 200, p.easing.cubic.out, n)),
            !0
          )
        }
      s('Gestures', {
        publicMethods: {
          initGestures: function () {
            function t(t, e, i, n, s) {
              ;(nt = t + e), (st = t + i), (rt = t + n), (ot = s ? t + s : '')
            }
            ;(lt = gt.pointerEvent) && gt.touch && (gt.touch = !1),
              lt ? (navigator.pointerEnabled ? t('pointer', 'down', 'move', 'up', 'cancel') : t('MSPointer', 'Down', 'Move', 'Up', 'Cancel')) : gt.touch ? (t('touch', 'start', 'move', 'end', 'cancel'), (ht = !0)) : t('mouse', 'down', 'move', 'up'),
              (H = st + ' ' + rt + ' ' + ot),
              (Z = nt),
              lt && !ht && (ht = 1 < navigator.maxTouchPoints || 1 < navigator.msMaxTouchPoints),
              (m.likelyTouchDevice = ht),
              (V[nt] = F),
              (V[st] = N),
              (V[rt] = X),
              ot && (V[ot] = V[rt]),
              gt.touch && ((Z += ' mousedown'), (H += ' mousemove mouseup'), (V.mousedown = V[nt]), (V.mousemove = V[st]), (V.mouseup = V[rt])),
              ht || (g.allowPanToNext = !1)
          },
        },
      })
      function Ie() {
        return { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } }
      }
      function Fe(t, e, i, n, s, r) {
        e.loadError ||
          (n &&
            ((e.imageAppended = !0),
            Ke(e, n, e === m.currItem && Jt),
            i.appendChild(n),
            r &&
              setTimeout(function () {
                e && e.loaded && e.placeholder && ((e.placeholder.style.display = 'none'), (e.placeholder = null))
              }, 500)))
      }
      function Ne(t) {
        function e() {
          ;(t.loading = !1), (t.loaded = !0), t.loadComplete ? t.loadComplete(t) : (t.img = null), (i.onload = i.onerror = null), (i = null)
        }
        ;(t.loading = !0), (t.loaded = !1)
        var i = (t.img = p.createEl('pswp__img', 'img'))
        return (
          (i.onload = e),
          (i.onerror = function () {
            ;(t.loadError = !0), e()
          }),
          (i.src = t.src),
          i
        )
      }
      function Xe(t, e) {
        return t.src && t.loadError && t.container && (e && (t.container.innerHTML = ''), (t.container.innerHTML = g.errorMsg.replace('%url%', t.src)), 1)
      }
      function je() {
        if (Ge.length) {
          for (var t, e = 0; e < Ge.length; e++) (t = Ge[e]).holder.index === t.index && Fe(t.index, t.item, t.baseDiv, t.img, 0, t.clearPlaceholder)
          Ge = []
        }
      }
      var Be,
        Ue,
        We,
        Ye,
        qe,
        He,
        Ze = function (o, t, a, e) {
          var l
          Be && clearTimeout(Be), (We = Ye = !0), o.initialLayout ? ((l = o.initialLayout), (o.initialLayout = null)) : (l = g.getThumbBoundsFn && g.getThumbBoundsFn(W))
          function h() {
            C('initialZoom'), a ? (m.template.removeAttribute('style'), m.bg.removeAttribute('style')) : (_(1), t && (t.style.display = 'block'), p.addClass(f, 'pswp--animated-in'), v('initialZoom' + (a ? 'OutEnd' : 'InEnd'))), e && e(), (Ye = !1)
          }
          var c = a ? g.hideAnimationDuration : g.showAnimationDuration
          if (!c || !l || void 0 === l.x)
            return (
              v('initialZoom' + (a ? 'Out' : 'In')),
              (G = o.initialZoomLevel),
              y(Yt, o.initialPosition),
              ee(),
              (f.style.opacity = a ? 0 : 1),
              _(1),
              void (c
                ? setTimeout(function () {
                    h()
                  }, c)
                : h())
            )
          var u, d
          ;(u = U),
            (d = !m.currItem.src || m.currItem.loadError || g.showHideOpacity),
            o.miniImg && (o.miniImg.style.webkitBackfaceVisibility = 'hidden'),
            a || ((G = l.w / o.w), (Yt.x = l.x), (Yt.y = l.y - ft), (m[d ? 'template' : 'bg'].style.opacity = 0.001), ee()),
            k('initialZoom'),
            a && !u && p.removeClass(f, 'pswp--animated-in'),
            d &&
              (a
                ? p[(u ? 'remove' : 'add') + 'Class'](f, 'pswp--animate_opacity')
                : setTimeout(function () {
                    p.addClass(f, 'pswp--animate_opacity')
                  }, 30)),
            (Be = setTimeout(
              function () {
                var e, i, n, s, r, t
                v('initialZoom' + (a ? 'Out' : 'In')),
                  a
                    ? ((e = l.w / o.w),
                      (i = Yt.x),
                      (n = Yt.y),
                      (s = G),
                      (r = Xt),
                      (t = function (t) {
                        1 === t ? ((G = e), (Yt.x = l.x), (Yt.y = l.y - mt)) : ((G = (e - s) * t + s), (Yt.x = (l.x - i) * t + i), (Yt.y = (l.y - mt - n) * t + n)), ee(), d ? (f.style.opacity = 1 - t) : _(r - t * r)
                      }),
                      u ? O('initialZoom', 0, 1, c, p.easing.cubic.out, t, h) : (t(1), (Be = setTimeout(h, c + 20))))
                    : ((G = o.initialZoomLevel), y(Yt, o.initialPosition), ee(), _(1), d ? (f.style.opacity = 1) : _(1), (Be = setTimeout(h, c + 20)))
              },
              a ? 25 : 90
            ))
        },
        Ve = {},
        Ge = [],
        Qe = {
          index: 0,
          errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
          forceProgressiveLoading: !1,
          preload: [1, 1],
          getNumItemsFn: function () {
            return Ue.length
          },
        },
        $e = function (t, e, i) {
          if (!t.src || t.loadError) return (t.w = t.h = 0), (t.initialZoomLevel = t.fitRatio = 1), (t.bounds = Ie()), (t.initialPosition = t.bounds.center), t.bounds
          var n,
            s,
            r,
            o = !i
          return (
            o && (t.vGap || (t.vGap = { top: 0, bottom: 0 }), v('parseVerticalMargin', t)),
            (Ve.x = e.x),
            (Ve.y = e.y - t.vGap.top - t.vGap.bottom),
            o &&
              ((n = Ve.x / t.w), (s = Ve.y / t.h), (t.fitRatio = n < s ? n : s), 'orig' === (r = g.scaleMode) ? (i = 1) : 'fit' === r ? (i = t.fitRatio) : 'zoom' === r && (i = Math.max(t.initialZoomLevel || 1, t.fitRatio)), 1 < i && (i = 1), (t.initialZoomLevel = i), t.bounds || (t.bounds = Ie())),
            i
              ? ((n = (e = t).w * i),
                (s = t.h * i),
                ((r = e.bounds).center.x = Math.round((Ve.x - n) / 2)),
                (r.center.y = Math.round((Ve.y - s) / 2) + e.vGap.top),
                (r.max.x = n > Ve.x ? Math.round(Ve.x - n) : r.center.x),
                (r.max.y = s > Ve.y ? Math.round(Ve.y - s) + e.vGap.top : r.center.y),
                (r.min.x = n > Ve.x ? 0 : r.center.x),
                (r.min.y = s > Ve.y ? e.vGap.top : r.center.y),
                o && i === t.initialZoomLevel && (t.initialPosition = t.bounds.center),
                t.bounds)
              : void 0
          )
        },
        Ke = function (t, e, i) {
          var n
          t.src &&
            ((e = e || t.container.lastChild),
            (n = i ? t.w : Math.round(t.w * t.fitRatio)),
            (i = i ? t.h : Math.round(t.h * t.fitRatio)),
            t.placeholder && !t.loaded && ((t.placeholder.style.width = n + 'px'), (t.placeholder.style.height = i + 'px')),
            (e.style.width = n + 'px'),
            (e.style.height = i + 'px'))
        }
      s('Controller', {
        publicMethods: {
          lazyLoadItem: function (t) {
            t = o(t)
            var e = qe(t)
            e && ((!e.loaded && !e.loading) || tt) && (v('gettingData', t, e), e.src && Ne(e))
          },
          initController: function () {
            p.extend(g, Qe, !0),
              (m.items = Ue = t),
              (qe = m.getItemAt),
              (He = g.getNumItemsFn),
              g.loop,
              He() < 3 && (g.loop = !1),
              r('beforeChange', function (t) {
                for (var e = g.preload, i = null === t || 0 <= t, n = Math.min(e[0], He()), s = Math.min(e[1], He()), r = 1; r <= (i ? s : n); r++) m.lazyLoadItem(W + r)
                for (r = 1; r <= (i ? n : s); r++) m.lazyLoadItem(W - r)
              }),
              r('initialLayout', function () {
                m.currItem.initialLayout = g.getThumbBoundsFn && g.getThumbBoundsFn(W)
              }),
              r('mainScrollAnimComplete', je),
              r('initialZoomInEnd', je),
              r('destroy', function () {
                for (var t, e = 0; e < Ue.length; e++) (t = Ue[e]).container && (t.container = null), t.placeholder && (t.placeholder = null), t.img && (t.img = null), t.preloader && (t.preloader = null), t.loadError && (t.loaded = t.loadError = !1)
                Ge = null
              })
          },
          getItemAt: function (t) {
            return 0 <= t && void 0 !== Ue[t] && Ue[t]
          },
          allowProgressiveImg: function () {
            return g.forceProgressiveLoading || !ht || g.mouseUsed || 1200 < screen.width
          },
          setContent: function (e, i) {
            g.loop && (i = o(i))
            var t = m.getItemAt(e.index)
            t && (t.container = null)
            var n,
              s,
              r = m.getItemAt(i)
            r
              ? (v('gettingData', i, r),
                (e.index = i),
                (s = (e.item = r).container = p.createEl('pswp__zoom-wrap')),
                !r.src && r.html && (r.html.tagName ? s.appendChild(r.html) : (s.innerHTML = r.html)),
                Xe(r),
                $e(r, qt),
                !r.src || r.loadError || r.loaded
                  ? r.src && !r.loadError && (((n = p.createEl('pswp__img', 'img')).style.opacity = 1), (n.src = r.src), Ke(r, n), Fe(0, r, s, n))
                  : ((r.loadComplete = function (t) {
                      if (j) {
                        if (e && e.index === i) {
                          if (Xe(t, !0)) return (t.loadComplete = t.img = null), $e(t, qt), ie(t), void (e.index === W && m.updateCurrZoomItem())
                          t.imageAppended ? !Ye && t.placeholder && ((t.placeholder.style.display = 'none'), (t.placeholder = null)) : gt.transform && (Rt || Ye) ? Ge.push({ item: t, baseDiv: s, img: t.img, index: i, holder: e, clearPlaceholder: !0 }) : Fe(0, t, s, t.img, 0, !0)
                        }
                        ;(t.loadComplete = null), (t.img = null), v('imageLoadComplete', i, t)
                      }
                    }),
                    p.features.transform && ((t = 'pswp__img pswp__img--placeholder'), (t += r.msrc ? '' : ' pswp__img--placeholder--blank'), (t = p.createEl(t, r.msrc ? 'img' : '')), r.msrc && (t.src = r.msrc), Ke(r, t), s.appendChild(t), (r.placeholder = t)),
                    r.loading || Ne(r),
                    m.allowProgressiveImg() && (!We && gt.transform ? Ge.push({ item: r, baseDiv: s, img: r.img, index: i, holder: e }) : Fe(0, r, s, r.img, 0, !0))),
                We || i !== W ? ie(r) : ((Lt = s.style), Ze(r, n || r.img)),
                (e.el.innerHTML = ''),
                e.el.appendChild(s))
              : (e.el.innerHTML = '')
          },
          cleanSlide: function (t) {
            t.img && (t.img.onload = t.img.onerror = null), (t.loaded = t.loading = t.img = t.imageAppended = !1)
          },
        },
      })
      function Je(t, e, i) {
        var n = document.createEvent('CustomEvent'),
          i = { origEvent: t, target: t.target, releasePoint: e, pointerType: i || 'touch' }
        n.initCustomEvent('pswpTap', !0, !0, i), t.target.dispatchEvent(n)
      }
      var ti,
        ei,
        ii = {}
      s('Tap', {
        publicMethods: {
          initTap: function () {
            r('firstTouchStart', m.onTapStart),
              r('touchRelease', m.onTapRelease),
              r('destroy', function () {
                ;(ii = {}), (ti = null)
              })
          },
          onTapStart: function (t) {
            1 < t.length && (clearTimeout(ti), (ti = null))
          },
          onTapRelease: function (t, e) {
            var i, n, s
            !e ||
              kt ||
              Pt ||
              ae ||
              ((i = e),
              ti && (clearTimeout(ti), (ti = null), (n = i), (s = ii), Math.abs(n.x - s.x) < 25 && Math.abs(n.y - s.y) < 25)
                ? v('doubleTap', i)
                : 'mouse' !== e.type
                ? 'BUTTON' === t.target.tagName.toUpperCase() || p.hasClass(t.target, 'pswp__single-tap')
                  ? Je(t, e)
                  : (y(ii, i),
                    (ti = setTimeout(function () {
                      Je(t, e), (ti = null)
                    }, 300)))
                : Je(t, e, 'mouse'))
          },
        },
      }),
        s('DesktopZoom', {
          publicMethods: {
            initDesktopZoom: function () {
              pt ||
                (ht
                  ? r('mouseUsed', function () {
                      m.setupDesktopZoom()
                    })
                  : m.setupDesktopZoom(!0))
            },
            setupDesktopZoom: function (t) {
              ei = {}
              var e = 'wheel mousewheel DOMMouseScroll'
              r('bindEvents', function () {
                p.bind(f, e, m.handleMouseWheel)
              }),
                r('unbindEvents', function () {
                  ei && p.unbind(f, e, m.handleMouseWheel)
                }),
                (m.mouseZoomedIn = !1)
              function i() {
                m.mouseZoomedIn && (p.removeClass(f, 'pswp--zoomed-in'), (m.mouseZoomedIn = !1)), G < 1 ? p.addClass(f, 'pswp--zoom-allowed') : p.removeClass(f, 'pswp--zoom-allowed'), s()
              }
              var n,
                s = function () {
                  n && (p.removeClass(f, 'pswp--dragging'), (n = !1))
                }
              r('resize', i),
                r('afterChange', i),
                r('pointerDown', function () {
                  m.mouseZoomedIn && ((n = !0), p.addClass(f, 'pswp--dragging'))
                }),
                r('pointerUp', s),
                t || i()
            },
            handleMouseWheel: function (t) {
              if (G <= m.currItem.fitRatio) return g.modal && (!g.closeOnScroll || ae || St ? t.preventDefault() : at && 2 < Math.abs(t.deltaY) && ((U = !0), m.close())), !0
              if ((t.stopPropagation(), (ei.x = 0), 'deltaX' in t)) 1 === t.deltaMode ? ((ei.x = 18 * t.deltaX), (ei.y = 18 * t.deltaY)) : ((ei.x = t.deltaX), (ei.y = t.deltaY))
              else if ('wheelDelta' in t) t.wheelDeltaX && (ei.x = -0.16 * t.wheelDeltaX), t.wheelDeltaY ? (ei.y = -0.16 * t.wheelDeltaY) : (ei.y = -0.16 * t.wheelDelta)
              else {
                if (!('detail' in t)) return
                ei.y = t.detail
              }
              d(G, !0)
              var e = Yt.x - ei.x,
                i = Yt.y - ei.y
              ;(g.modal || (e <= zt.min.x && e >= zt.max.x && i <= zt.min.y && i >= zt.max.y)) && t.preventDefault(), m.panTo(e, i)
            },
            toggleDesktopZoom: function (t) {
              t = t || { x: qt.x / 2 + Zt.x, y: qt.y / 2 + Zt.y }
              var e = g.getDoubleTapZoom(!0, m.currItem),
                i = G === e
              ;(m.mouseZoomedIn = !i), m.zoomTo(i ? m.currItem.initialZoomLevel : e, t, 333), p[(i ? 'remove' : 'add') + 'Class'](f, 'pswp--zoomed-in')
            },
          },
        }),
        p.extend(m, e)
    }
  }),
  (function (t, e) {
    'function' == typeof define && define.amd ? define([], e) : 'object' == typeof module && module.exports ? (module.exports = e()) : (t.Rellax = e())
  })(this, function () {
    var m = function (t, e) {
      'use strict'
      function h(t, e, i) {
        return t <= e ? e : i <= t ? i : t
      }
      var c = Object.create(m.prototype),
        n = 0,
        u = 0,
        s = [],
        i = !1,
        r =
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          function (t) {
            setTimeout(t, 1e3 / 60)
          },
        o =
          window.transformProp ||
          (function () {
            var t = document.createElement('div')
            if (null == t.style.transform) {
              var e,
                i = ['Webkit', 'Moz', 'ms']
              for (e in i) if (void 0 !== t.style[i[e] + 'Transform']) return i[e] + 'Transform'
            }
            return 'transform'
          })()
      ;(c.options = { speed: -2, center: !1, round: !0, callback: function () {} }),
        e &&
          Object.keys(e).forEach(function (t) {
            c.options[t] = e[t]
          }),
        (c.options.speed = h(c.options.speed, -10, 10)),
        (t = t || '.rellax')
      t = document.querySelectorAll(t)
      if (!(0 < t.length)) throw new Error("The elements you're trying to select don't exist.")
      c.elems = t
      var a = function (t) {
          var e = t.getAttribute('data-rellax-percentage'),
            i = t.getAttribute('data-rellax-speed'),
            n = t.getAttribute('data-rellax-zindex') || 0,
            s = e || c.options.center ? window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop : 0,
            r = s + t.getBoundingClientRect().top,
            o = t.clientHeight || t.offsetHeight || t.scrollHeight,
            a = e || (s - r + u) / (o + u)
          c.options.center && (a = 0.5)
          var l = i ? h(i, -10, 10) : c.options.speed
          ;(e || c.options.center) && (l = h(i || c.options.speed, -5, 5))
          ;(s = d(a, l)), (e = t.style.cssText), (i = '')
          return 0 <= e.indexOf('transform') && ((a = e.indexOf('transform')), (i = (a = (t = e.slice(a)).indexOf(';')) ? ' ' + t.slice(11, a).replace(/\s/g, '') : ' ' + t.slice(11).replace(/\s/g, ''))), { base: s, top: r, height: o, speed: l, style: e, transform: i, zindex: n }
        },
        l = function () {
          return n != (n = void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop)
        },
        d = function (t, e) {
          t = e * (100 * (1 - t))
          return c.options.round ? Math.round(t) : Math.round(100 * t) / 100
        },
        f = function () {
          l() && !1 === i && p(), r(f)
        },
        p = function () {
          for (var t = 0; t < c.elems.length; t++) {
            var e = (n - s[t].top + u) / (s[t].height + u),
              i = d(e, s[t].speed) - s[t].base,
              e = 'translate3d(0,' + i + 'px,' + s[t].zindex + 'px) ' + s[t].transform
            c.elems[t].style[o] = e
          }
          c.options.callback(i)
        }
      return (
        (c.destroy = function () {
          for (var t = 0; t < c.elems.length; t++) c.elems[t].style.cssText = s[t].style
          i = !0
        }),
        (function () {
          ;(u = window.innerHeight), l()
          for (var t = 0; t < c.elems.length; t++) {
            var e = a(c.elems[t])
            s.push(e)
          }
          window.addEventListener('resize', function () {
            p()
          }),
            f(),
            p()
        })(),
        c
      )
    }
    return m
  }),
  (function () {
    'use strict'
    function t() {
      function a(t, e) {
        ;(this.scrollLeft = t), (this.scrollTop = e)
      }
      function n(t) {
        if (null === t || 'object' != typeof t || void 0 === t.behavior || 'auto' === t.behavior || 'instant' === t.behavior) return !0
        if ('object' == typeof t && 'smooth' === t.behavior) return !1
        throw new TypeError('behavior member of ScrollOptions ' + t.behavior + ' is not a valid value for enumeration ScrollBehavior.')
      }
      function s(t, e) {
        return 'Y' === e ? t.clientHeight + i < t.scrollHeight : 'X' === e ? t.clientWidth + i < t.scrollWidth : void 0
      }
      function r(t, e) {
        e = f.getComputedStyle(t, null)['overflow' + e]
        return 'auto' === e || 'scroll' === e
      }
      function o(t) {
        for (var e, i, n; (t = t.parentNode), (e = t === p.body), !1 === e && !1 === ((i = t), (n = void 0), (n = s(i, 'Y') && r(i, 'Y')), (i = s(i, 'X') && r(i, 'X')), n || i); );
        return (e = null), t
      }
      function l(t) {
        var e,
          i = (d() - t.startTime) / c
        ;(e = i = 1 < i ? 1 : i), (i = 0.5 * (1 - Math.cos(Math.PI * e))), (e = t.startX + (t.x - t.startX) * i), (i = t.startY + (t.y - t.startY) * i), t.method.call(t.scrollable, e, i), (e === t.x && i === t.y) || f.requestAnimationFrame(l.bind(f, t))
      }
      function h(t, e, i) {
        var n,
          s,
          r,
          o = d(),
          t = t === p.body ? ((s = (n = f).scrollX || f.pageXOffset), (r = f.scrollY || f.pageYOffset), u.scroll) : ((s = (n = t).scrollLeft), (r = t.scrollTop), a)
        l({ scrollable: n, method: t, startTime: o, startX: s, startY: r, x: e, y: i })
      }
      var t, c, i, u, d, e
      ;('scrollBehavior' in p.documentElement.style && !0 !== f.__forceSmoothScrollPolyfill__) ||
        ((t = f.HTMLElement || f.Element),
        (c = 468),
        (e = f.navigator.userAgent),
        (i = new RegExp(['MSIE ', 'Trident/', 'Edge/'].join('|')).test(e) ? 1 : 0),
        (u = { scroll: f.scroll || f.scrollTo, scrollBy: f.scrollBy, elementScroll: t.prototype.scroll || a, scrollIntoView: t.prototype.scrollIntoView }),
        (d = f.performance && f.performance.now ? f.performance.now.bind(f.performance) : Date.now),
        (f.scroll = f.scrollTo =
          function () {
            if (void 0 !== arguments[0])
              return !0 === n(arguments[0])
                ? void u.scroll.call(f, void 0 !== arguments[0].left ? arguments[0].left : 'object' != typeof arguments[0] ? arguments[0] : f.scrollX || f.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : f.scrollY || f.pageYOffset)
                : void h.call(f, p.body, void 0 !== arguments[0].left ? ~~arguments[0].left : f.scrollX || f.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : f.scrollY || f.pageYOffset)
          }),
        (f.scrollBy = function () {
          if (void 0 !== arguments[0])
            return n(arguments[0])
              ? void u.scrollBy.call(f, void 0 !== arguments[0].left ? arguments[0].left : 'object' != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0)
              : void h.call(f, p.body, ~~arguments[0].left + (f.scrollX || f.pageXOffset), ~~arguments[0].top + (f.scrollY || f.pageYOffset))
        }),
        (t.prototype.scroll = t.prototype.scrollTo =
          function () {
            if (void 0 !== arguments[0])
              if (!0 !== n(arguments[0])) {
                var t = arguments[0].left,
                  e = arguments[0].top
                h.call(this, this, void 0 === t ? this.scrollLeft : ~~t, void 0 === e ? this.scrollTop : ~~e)
              } else {
                if ('number' == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError("Value couldn't be converted")
                u.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : 'object' != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop)
              }
          }),
        (t.prototype.scrollBy = function () {
          if (void 0 !== arguments[0])
            return !0 === n(arguments[0])
              ? void u.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop)
              : void this.scroll({ left: ~~arguments[0].left + this.scrollLeft, top: ~~arguments[0].top + this.scrollTop, behavior: arguments[0].behavior })
        }),
        (t.prototype.scrollIntoView = function () {
          var t, e, i
          !0 !== n(arguments[0])
            ? ((e = (t = o(this)).getBoundingClientRect()),
              (i = this.getBoundingClientRect()),
              t !== p.body ? (h.call(this, t, t.scrollLeft + i.left - e.left, t.scrollTop + i.top - e.top), 'fixed' !== f.getComputedStyle(t).position && f.scrollBy({ left: e.left, top: e.top, behavior: 'smooth' })) : f.scrollBy({ left: i.left, top: i.top, behavior: 'smooth' }))
            : u.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0])
        }))
    }
    var f = window,
      p = document
    'object' == typeof exports ? (module.exports = { polyfill: t }) : t()
  })(),
  (function (l, h) {
    'use strict'
    function c(t, e) {
      for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
    }
    function u(t) {
      return parseFloat(t) || 0
    }
    function d(t) {
      for (var e = 0; t; ) (e += t.offsetTop), (t = t.offsetParent)
      return e
    }
    var e,
      t = function (t, e, i) {
        return e && n(t.prototype, e), i && n(t, i), t
      },
      f = !1
    function n(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i]
        ;(n.enumerable = n.enumerable || !1), (n.configurable = !0), 'value' in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
      }
    }
    l.getComputedStyle
      ? ((e = h.createElement('div')),
        ['', '-webkit-', '-moz-', '-ms-'].some(function (t) {
          try {
            e.style.position = t + 'sticky'
          } catch (t) {}
          return '' != e.style.position
        }) && (f = !0))
      : (f = !0)
    var p = 'undefined' != typeof ShadowRoot,
      r = { top: null, left: null },
      o = [],
      s =
        (t(i, [
          {
            key: 'refresh',
            value: function () {
              var t, e, i, n, s, r, o, a
              f ||
                this._removed ||
                (this._active && this._deactivate(),
                (t = this._node),
                (e = { top: (r = getComputedStyle(t)).top, display: r.display, marginTop: r.marginTop, marginBottom: r.marginBottom, marginLeft: r.marginLeft, marginRight: r.marginRight, cssFloat: r.cssFloat }),
                isNaN(parseFloat(e.top)) ||
                  'table-cell' == e.display ||
                  'none' == e.display ||
                  ((this._active = !0),
                  (i = t.parentNode),
                  (a = p && i instanceof ShadowRoot ? i.host : i),
                  (n = t.getBoundingClientRect()),
                  (s = a.getBoundingClientRect()),
                  (o = getComputedStyle(a)),
                  (this._parent = { node: a, styles: { position: a.style.position }, offsetHeight: a.offsetHeight }),
                  (this._offsetToWindow = { left: n.left, right: h.documentElement.clientWidth - n.right }),
                  (this._offsetToParent = { top: n.top - s.top - u(o.borderTopWidth), left: n.left - s.left - u(o.borderLeftWidth), right: -n.right + s.right - u(o.borderRightWidth) }),
                  (this._styles = { position: t.style.position, top: t.style.top, bottom: t.style.bottom, left: t.style.left, right: t.style.right, width: t.style.width, marginTop: t.style.marginTop, marginLeft: t.style.marginLeft, marginRight: t.style.marginRight }),
                  (r = u(e.top)),
                  (this._limits = { start: n.top + l.pageYOffset - r, end: s.top + l.pageYOffset + a.offsetHeight - u(o.borderBottomWidth) - t.offsetHeight - r - u(e.marginBottom) }),
                  'absolute' != (o = o.position) && 'relative' != o && (a.style.position = 'relative'),
                  this._recalcPosition(),
                  ((a = this._clone = {}).node = h.createElement('div')),
                  c(a.node.style, {
                    width: n.right - n.left + 'px',
                    height: n.bottom - n.top + 'px',
                    marginTop: e.marginTop,
                    marginBottom: e.marginBottom,
                    marginLeft: e.marginLeft,
                    marginRight: e.marginRight,
                    cssFloat: e.cssFloat,
                    padding: 0,
                    border: 0,
                    borderSpacing: 0,
                    fontSize: '1em',
                    position: 'static',
                  }),
                  i.insertBefore(a.node, t),
                  (a.docOffsetTop = d(a.node))))
            },
          },
          {
            key: '_recalcPosition',
            value: function () {
              if (this._active && !this._removed) {
                var t = r.top <= this._limits.start ? 'start' : r.top >= this._limits.end ? 'end' : 'middle'
                if (this._stickyMode != t) {
                  switch (t) {
                    case 'start':
                      c(this._node.style, { position: 'absolute', left: this._offsetToParent.left + 'px', right: this._offsetToParent.right + 'px', top: this._offsetToParent.top + 'px', bottom: 'auto', width: 'auto', marginLeft: 0, marginRight: 0, marginTop: 0 })
                      break
                    case 'middle':
                      c(this._node.style, { position: 'fixed', left: this._offsetToWindow.left + 'px', right: this._offsetToWindow.right + 'px', top: this._styles.top, bottom: 'auto', width: 'auto', marginLeft: 0, marginRight: 0, marginTop: 0 })
                      break
                    case 'end':
                      c(this._node.style, { position: 'absolute', left: this._offsetToParent.left + 'px', right: this._offsetToParent.right + 'px', top: 'auto', bottom: 0, width: 'auto', marginLeft: 0, marginRight: 0 })
                  }
                  this._stickyMode = t
                }
              }
            },
          },
          {
            key: '_fastCheck',
            value: function () {
              this._active && !this._removed && (1 < Math.abs(d(this._clone.node) - this._clone.docOffsetTop) || 1 < Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight)) && this.refresh()
            },
          },
          {
            key: '_deactivate',
            value: function () {
              var e = this
              this._active &&
                !this._removed &&
                (this._clone.node.parentNode.removeChild(this._clone.node),
                delete this._clone,
                c(this._node.style, this._styles),
                delete this._styles,
                o.some(function (t) {
                  return t !== e && t._parent && t._parent.node === e._parent.node
                }) || c(this._parent.node.style, this._parent.styles),
                delete this._parent,
                (this._stickyMode = null),
                (this._active = !1),
                delete this._offsetToWindow,
                delete this._offsetToParent,
                delete this._limits)
            },
          },
          {
            key: 'remove',
            value: function () {
              var i = this
              this._deactivate(),
                o.some(function (t, e) {
                  if (t._node === i._node) return o.splice(e, 1), !0
                }),
                (this._removed = !0)
            },
          },
        ]),
        i),
      a = {
        stickies: o,
        Sticky: s,
        addOne: function (t) {
          if (!(t instanceof HTMLElement)) {
            if (!t.length || !t[0]) return
            t = t[0]
          }
          for (var e = 0; e < o.length; e++) if (o[e]._node === t) return o[e]
          return new s(t)
        },
        add: function (t) {
          if ((t instanceof HTMLElement && (t = [t]), t.length)) {
            for (var i = [], n = 0; n < t.length; n++)
              !(function () {
                var e = t[n]
                e instanceof HTMLElement
                  ? o.some(function (t) {
                      if (t._node === e) return i.push(t), !0
                    }) || i.push(new s(e))
                  : i.push(void 0)
              })()
            return i
          }
        },
        refreshAll: function () {
          o.forEach(function (t) {
            return t.refresh()
          })
        },
        removeOne: function (e) {
          if (!(e instanceof HTMLElement)) {
            if (!e.length || !e[0]) return
            e = e[0]
          }
          o.some(function (t) {
            if (t._node === e) return t.remove(), !0
          })
        },
        remove: function (t) {
          if ((t instanceof HTMLElement && (t = [t]), t.length))
            for (var i = 0; i < t.length; i++)
              !(function () {
                var e = t[i]
                o.some(function (t) {
                  if (t._node === e) return t.remove(), !0
                })
              })()
        },
        removeAll: function () {
          for (; o.length; ) o[0].remove()
        },
      }
    function i(e) {
      if (
        ((function (t, e) {
          if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function')
        })(this, i),
        !(e instanceof HTMLElement))
      )
        throw new Error('First argument must be HTMLElement')
      if (
        o.some(function (t) {
          return t._node === e
        })
      )
        throw new Error('Stickyfill is already applied to this node')
      ;(this._node = e), (this._stickyMode = null), (this._active = !1), o.push(this), this.refresh()
    }
    f ||
      (function () {
        function t() {
          l.pageXOffset != r.left
            ? ((r.top = l.pageYOffset), (r.left = l.pageXOffset), a.refreshAll())
            : l.pageYOffset != r.top &&
              ((r.top = l.pageYOffset),
              (r.left = l.pageXOffset),
              o.forEach(function (t) {
                return t._recalcPosition()
              }))
        }
        function e() {
          i = setInterval(function () {
            o.forEach(function (t) {
              return t._fastCheck()
            })
          }, 500)
        }
        t(), l.addEventListener('scroll', t), l.addEventListener('resize', a.refreshAll), l.addEventListener('orientationchange', a.refreshAll)
        var i = void 0,
          n = void 0,
          s = void 0
        'hidden' in h ? ((n = 'hidden'), (s = 'visibilitychange')) : 'webkitHidden' in h && ((n = 'webkitHidden'), (s = 'webkitvisibilitychange')),
          s
            ? (h[n] || e(),
              h.addEventListener(s, function () {
                h[n] ? clearInterval(i) : e()
              }))
            : e()
      })(),
      'undefined' != typeof module && module.exports ? (module.exports = a) : (l.Stickyfill = a)
  })(window, document),
  (function (d, f) {
    'use strict'
    var e,
      i,
      p = {},
      m = d.document,
      g = (d.GreenSockGlobals = d.GreenSockGlobals || d)
    if (!g.TweenLite) {
      var v,
        _ = function (t) {
          for (var e = t.split('.'), i = g, n = 0; n < e.length; n++) i[e[n]] = i = i[e[n]] || {}
          return i
        },
        u = _('com.greensock'),
        y = 1e-10,
        a = function (t) {
          for (var e = [], i = t.length, n = 0; n !== i; e.push(t[n++]));
          return e
        },
        x = function () {},
        w =
          ((e = Object.prototype.toString),
          (i = e.call([])),
          function (t) {
            return null != t && (t instanceof Array || ('object' == typeof t && !!t.push && e.call(t) === i))
          }),
        b = {},
        T = function (a, l, h, c) {
          ;(this.sc = b[a] ? b[a].sc : []), ((b[a] = this).gsClass = null), (this.func = h)
          var u = []
          ;(this.check = function (t) {
            for (var e, i, n, s, r = l.length, o = r; -1 < --r; ) (e = b[l[r]] || new T(l[r], [])).gsClass ? ((u[r] = e.gsClass), o--) : t && e.sc.push(this)
            if (0 === o && h) {
              if (((n = (i = ('com.greensock.' + a).split('.')).pop()), (s = _(i.join('.'))[n] = this.gsClass = h.apply(h, u)), c))
                if (((g[n] = p[n] = s), 'undefined' != typeof module && module.exports))
                  if (a === f) for (r in ((module.exports = p[f] = s), p)) s[r] = p[r]
                  else p[f] && (p[f][n] = s)
                else
                  'function' == typeof define &&
                    define.amd &&
                    define((d.GreenSockAMDPath ? d.GreenSockAMDPath + '/' : '') + a.split('.').pop(), [], function () {
                      return s
                    })
              for (r = 0; r < this.sc.length; r++) this.sc[r].check()
            }
          }),
            this.check(!0)
        },
        n = (d._gsDefine = function (t, e, i, n) {
          return new T(t, e, i, n)
        }),
        S = (u._class = function (t, e, i) {
          return (
            (e = e || function () {}),
            n(
              t,
              [],
              function () {
                return e
              },
              i
            ),
            e
          )
        })
      n.globals = g
      var t,
        s = [0, 0, 1, 1],
        P = S(
          'easing.Ease',
          function (t, e, i, n) {
            ;(this._func = t), (this._type = i || 0), (this._power = n || 0), (this._params = e ? s.concat(e) : s)
          },
          !0
        ),
        C = (P.map = {}),
        r = (P.register = function (t, e, i, n) {
          for (var s, r, o, a, l = e.split(','), h = l.length, c = (i || 'easeIn,easeOut,easeInOut').split(','); -1 < --h; )
            for (r = l[h], s = n ? S('easing.' + r, null, !0) : u.easing[r] || {}, o = c.length; -1 < --o; ) (a = c[o]), (C[r + '.' + a] = C[a + r] = s[a] = t.getRatio ? t : t[a] || new t())
        })
      for (
        (t = P.prototype)._calcEnd = !1,
          t.getRatio = function (t) {
            if (this._func) return (this._params[0] = t), this._func.apply(null, this._params)
            var e = this._type,
              i = this._power,
              n = 1 === e ? 1 - t : 2 === e ? t : t < 0.5 ? 2 * t : 2 * (1 - t)
            return 1 === i ? (n *= n) : 2 === i ? (n *= n * n) : 3 === i ? (n *= n * n * n) : 4 === i && (n *= n * n * n * n), 1 === e ? 1 - n : 2 === e ? n : t < 0.5 ? n / 2 : 1 - n / 2
          },
          l = (o = ['Linear', 'Quad', 'Cubic', 'Quart', 'Quint,Strong']).length;
        -1 < --l;

      )
        (t = o[l] + ',Power' + l), r(new P(null, null, 1, l), t, 'easeOut', !0), r(new P(null, null, 2, l), t, 'easeIn' + (0 === l ? ',easeNone' : '')), r(new P(null, null, 3, l), t, 'easeInOut')
      ;(C.linear = u.easing.Linear.easeIn), (C.swing = u.easing.Quad.easeInOut)
      var k = S('events.EventDispatcher', function (t) {
        ;(this._listeners = {}), (this._eventTarget = t || this)
      })
      ;((t = k.prototype).addEventListener = function (t, e, i, n, s) {
        s = s || 0
        var r,
          o,
          a = this._listeners[t],
          l = 0
        for (this !== M || v || M.wake(), null == a && (this._listeners[t] = a = []), o = a.length; -1 < --o; ) (r = a[o]).c === e && r.s === i ? a.splice(o, 1) : 0 === l && r.pr < s && (l = o + 1)
        a.splice(l, 0, { c: e, s: i, up: n, pr: s })
      }),
        (t.removeEventListener = function (t, e) {
          var i,
            n = this._listeners[t]
          if (n) for (i = n.length; -1 < --i; ) if (n[i].c === e) return void n.splice(i, 1)
        }),
        (t.dispatchEvent = function (t) {
          var e,
            i,
            n,
            s = this._listeners[t]
          if (s) for (1 < (e = s.length) && (s = s.slice(0)), i = this._eventTarget; -1 < --e; ) (n = s[e]) && (n.up ? n.c.call(n.s || i, { type: t, target: i }) : n.c.call(n.s || i))
        })
      for (
        var o,
          E = d.requestAnimationFrame,
          O = d.cancelAnimationFrame,
          A =
            Date.now ||
            function () {
              return new Date().getTime()
            },
          D = A(),
          l = (o = ['ms', 'moz', 'webkit', 'o']).length;
        -1 < --l && !E;

      )
        (E = d[o[l] + 'RequestAnimationFrame']), (O = d[o[l] + 'CancelAnimationFrame'] || d[o[l] + 'CancelRequestAnimationFrame'])
      S('Ticker', function (t, e) {
        var n,
          s,
          r,
          o,
          a,
          l = this,
          h = A(),
          i = !(!1 === e || !E) && 'auto',
          c = 500,
          u = 33,
          d = function (t) {
            var e,
              i = A() - D
            c < i && (h += i - u), (D += i), (l.time = (D - h) / 1e3), (i = l.time - a), (!n || 0 < i || !0 === t) && (l.frame++, (a += i + (o <= i ? 0.004 : o - i)), (e = !0)), !0 !== t && (r = s(d)), e && l.dispatchEvent('tick')
          }
        k.call(l),
          (l.time = l.frame = 0),
          (l.tick = function () {
            d(!0)
          }),
          (l.lagSmoothing = function (t, e) {
            return arguments.length ? ((c = t || 1e10), void (u = Math.min(e, c, 0))) : c < 1e10
          }),
          (l.sleep = function () {
            null != r && ((i && O ? O : clearTimeout)(r), (s = x), (r = null), l === M && (v = !1))
          }),
          (l.wake = function (t) {
            null !== r ? l.sleep() : t ? (h += -D + (D = A())) : 10 < l.frame && (D = A() - c + 5),
              (s =
                0 === n
                  ? x
                  : i && E
                  ? E
                  : function (t) {
                      return setTimeout(t, (1e3 * (a - l.time) + 1) | 0)
                    }),
              l === M && (v = !0),
              d(2)
          }),
          (l.fps = function (t) {
            return arguments.length ? ((o = 1 / ((n = t) || 60)), (a = this.time + o), void l.wake()) : n
          }),
          (l.useRAF = function (t) {
            return arguments.length ? (l.sleep(), (i = t), void l.fps(n)) : i
          }),
          l.fps(t),
          setTimeout(function () {
            'auto' === i && l.frame < 5 && 'hidden' !== m.visibilityState && l.useRAF(!1)
          }, 1500)
      }),
        ((t = u.Ticker.prototype = new u.events.EventDispatcher()).constructor = u.Ticker)
      var h = S('core.Animation', function (t, e) {
          ;(this.vars = e = e || {}),
            (this._duration = this._totalDuration = t || 0),
            (this._delay = Number(e.delay) || 0),
            (this._timeScale = 1),
            (this._active = !0 === e.immediateRender),
            (this.data = e.data),
            (this._reversed = !0 === e.reversed),
            Q && (v || M.wake(), (e = this.vars.useFrames ? G : Q).add(this, e._time), this.vars.paused && this.paused(!0))
        }),
        M = (h.ticker = new u.Ticker())
      ;((t = h.prototype)._dirty = t._gc = t._initted = t._paused = !1), (t._totalTime = t._time = 0), (t._rawPrevTime = -1), (t._next = t._last = t._onUpdate = t._timeline = t.timeline = null), (t._paused = !1)
      var c = function () {
        v && 2e3 < A() - D && ('hidden' !== m.visibilityState || !M.lagSmoothing()) && M.wake()
        var t = setTimeout(c, 2e3)
        t.unref && t.unref()
      }
      c(),
        (t.play = function (t, e) {
          return null != t && this.seek(t, e), this.reversed(!1).paused(!1)
        }),
        (t.pause = function (t, e) {
          return null != t && this.seek(t, e), this.paused(!0)
        }),
        (t.resume = function (t, e) {
          return null != t && this.seek(t, e), this.paused(!1)
        }),
        (t.seek = function (t, e) {
          return this.totalTime(Number(t), !1 !== e)
        }),
        (t.restart = function (t, e) {
          return this.reversed(!1)
            .paused(!1)
            .totalTime(t ? -this._delay : 0, !1 !== e, !0)
        }),
        (t.reverse = function (t, e) {
          return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1)
        }),
        (t.render = function (t, e, i) {}),
        (t.invalidate = function () {
          return (this._time = this._totalTime = 0), (this._initted = this._gc = !1), (this._rawPrevTime = -1), (!this._gc && this.timeline) || this._enabled(!0), this
        }),
        (t.isActive = function () {
          var t,
            e = this._timeline,
            i = this._startTime
          return !e || (!this._gc && !this._paused && e.isActive() && (t = e.rawTime(!0)) >= i && t < i + this.totalDuration() / this._timeScale - 1e-7)
        }),
        (t._enabled = function (t, e) {
          return v || M.wake(), (this._gc = !t), (this._active = this.isActive()), !0 !== e && (t && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !t && this.timeline && this._timeline._remove(this, !0)), !1
        }),
        (t._kill = function (t, e) {
          return this._enabled(!1, !1)
        }),
        (t.kill = function (t, e) {
          return this._kill(t, e), this
        }),
        (t._uncache = function (t) {
          for (var e = t ? this : this.timeline; e; ) (e._dirty = !0), (e = e.timeline)
          return this
        }),
        (t._swapSelfInParams = function (t) {
          for (var e = t.length, i = t.concat(); -1 < --e; ) '{self}' === t[e] && (i[e] = this)
          return i
        }),
        (t._callback = function (t) {
          var e = this.vars,
            i = e[t],
            n = e[t + 'Params'],
            s = e[t + 'Scope'] || e.callbackScope || this
          switch (n ? n.length : 0) {
            case 0:
              i.call(s)
              break
            case 1:
              i.call(s, n[0])
              break
            case 2:
              i.call(s, n[0], n[1])
              break
            default:
              i.apply(s, n)
          }
        }),
        (t.eventCallback = function (t, e, i, n) {
          if ('on' === (t || '').substr(0, 2)) {
            var s = this.vars
            if (1 === arguments.length) return s[t]
            null == e ? delete s[t] : ((s[t] = e), (s[t + 'Params'] = w(i) && -1 !== i.join('').indexOf('{self}') ? this._swapSelfInParams(i) : i), (s[t + 'Scope'] = n)), 'onUpdate' === t && (this._onUpdate = e)
          }
          return this
        }),
        (t.delay = function (t) {
          return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + t - this._delay), (this._delay = t), this) : this._delay
        }),
        (t.duration = function (t) {
          return arguments.length ? ((this._duration = this._totalDuration = t), this._uncache(!0), this._timeline.smoothChildTiming && 0 < this._time && this._time < this._duration && 0 !== t && this.totalTime(this._totalTime * (t / this._duration), !0), this) : ((this._dirty = !1), this._duration)
        }),
        (t.totalDuration = function (t) {
          return (this._dirty = !1), arguments.length ? this.duration(t) : this._totalDuration
        }),
        (t.time = function (t, e) {
          return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(t > this._duration ? this._duration : t, e)) : this._time
        }),
        (t.totalTime = function (t, e, i) {
          if ((v || M.wake(), !arguments.length)) return this._totalTime
          if (this._timeline) {
            if ((t < 0 && !i && (t += this.totalDuration()), this._timeline.smoothChildTiming)) {
              this._dirty && this.totalDuration()
              var n = this._totalDuration,
                s = this._timeline
              if ((n < t && !i && (t = n), (this._startTime = (this._paused ? this._pauseTime : s._time) - (this._reversed ? n - t : t) / this._timeScale), s._dirty || this._uncache(!1), s._timeline))
                for (; s._timeline; ) s._timeline._time !== (s._startTime + s._totalTime) / s._timeScale && s.totalTime(s._totalTime, !0), (s = s._timeline)
            }
            this._gc && this._enabled(!0, !1), (this._totalTime === t && 0 !== this._duration) || (I.length && K(), this.render(t, e, !1), I.length && K())
          }
          return this
        }),
        (t.progress = t.totalProgress =
          function (t, e) {
            var i = this.duration()
            return arguments.length ? this.totalTime(i * t, e) : i ? this._time / i : this.ratio
          }),
        (t.startTime = function (t) {
          return arguments.length ? (t !== this._startTime && ((this._startTime = t), this.timeline && this.timeline._sortChildren && this.timeline.add(this, t - this._delay)), this) : this._startTime
        }),
        (t.endTime = function (t) {
          return this._startTime + (0 != t ? this.totalDuration() : this.duration()) / this._timeScale
        }),
        (t.timeScale = function (t) {
          if (!arguments.length) return this._timeScale
          var e, i
          for (t = t || y, this._timeline && this._timeline.smoothChildTiming && ((i = (e = this._pauseTime) || 0 === e ? e : this._timeline.totalTime()), (this._startTime = i - ((i - this._startTime) * this._timeScale) / t)), this._timeScale = t, i = this.timeline; i && i.timeline; )
            (i._dirty = !0), i.totalDuration(), (i = i.timeline)
          return this
        }),
        (t.reversed = function (t) {
          return arguments.length ? (t != this._reversed && ((this._reversed = t), this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed
        }),
        (t.paused = function (t) {
          if (!arguments.length) return this._paused
          var e,
            i,
            n = this._timeline
          return (
            t != this._paused &&
              n &&
              (v || t || M.wake(),
              (i = (e = n.rawTime()) - this._pauseTime),
              !t && n.smoothChildTiming && ((this._startTime += i), this._uncache(!1)),
              (this._pauseTime = t ? e : null),
              (this._paused = t),
              (this._active = this.isActive()),
              !t && 0 != i && this._initted && this.duration() && ((e = n.smoothChildTiming ? this._totalTime : (e - this._startTime) / this._timeScale), this.render(e, e === this._totalTime, !0))),
            this._gc && !t && this._enabled(!0, !1),
            this
          )
        })
      var z = S('core.SimpleTimeline', function (t) {
        h.call(this, 0, t), (this.autoRemoveChildren = this.smoothChildTiming = !0)
      })
      ;((t = z.prototype = new h()).constructor = z),
        (t.kill()._gc = !1),
        (t._first = t._last = t._recent = null),
        (t._sortChildren = !1),
        (t.add = t.insert =
          function (t, e, i, n) {
            var s, r
            if (
              ((t._startTime = Number(e || 0) + t._delay),
              t._paused && this !== t._timeline && (t._pauseTime = t._startTime + (this.rawTime() - t._startTime) / t._timeScale),
              t.timeline && t.timeline._remove(t, !0),
              (t.timeline = t._timeline = this),
              t._gc && t._enabled(!0, !0),
              (s = this._last),
              this._sortChildren)
            )
              for (r = t._startTime; s && s._startTime > r; ) s = s._prev
            return s ? ((t._next = s._next), (s._next = t)) : ((t._next = this._first), (this._first = t)), t._next ? (t._next._prev = t) : (this._last = t), (t._prev = s), (this._recent = t), this._timeline && this._uncache(!0), this
          }),
        (t._remove = function (t, e) {
          return (
            t.timeline === this &&
              (e || t._enabled(!1, !0),
              t._prev ? (t._prev._next = t._next) : this._first === t && (this._first = t._next),
              t._next ? (t._next._prev = t._prev) : this._last === t && (this._last = t._prev),
              (t._next = t._prev = t.timeline = null),
              t === this._recent && (this._recent = this._last),
              this._timeline && this._uncache(!0)),
            this
          )
        }),
        (t.render = function (t, e, i) {
          var n,
            s = this._first
          for (this._totalTime = this._time = this._rawPrevTime = t; s; )
            (n = s._next), (s._active || (t >= s._startTime && !s._paused && !s._gc)) && (s._reversed ? s.render((s._dirty ? s.totalDuration() : s._totalDuration) - (t - s._startTime) * s._timeScale, e, i) : s.render((t - s._startTime) * s._timeScale, e, i)), (s = n)
        }),
        (t.rawTime = function () {
          return v || M.wake(), this._totalTime
        })
      var L = S(
          'TweenLite',
          function (t, e, i) {
            if ((h.call(this, e, i), (this.render = L.prototype.render), null == t)) throw 'Cannot tween a null target.'
            this.target = t = ('string' == typeof t && L.selector(t)) || t
            var n,
              s,
              r,
              i = t.jquery || (t.length && t !== d && t[0] && (t[0] === d || (t[0].nodeType && t[0].style && !t.nodeType))),
              o = this.vars.overwrite
            if (((this._overwrite = o = null == o ? V[L.defaultOverwrite] : 'number' == typeof o ? o >> 0 : V[o]), (i || t instanceof Array || (t.push && w(t))) && 'number' != typeof t[0]))
              for (this._targets = r = a(t), this._propLookup = [], this._siblings = [], n = 0; n < r.length; n++)
                (s = r[n])
                  ? 'string' != typeof s
                    ? s.length && s !== d && s[0] && (s[0] === d || (s[0].nodeType && s[0].style && !s.nodeType))
                      ? (r.splice(n--, 1), (this._targets = r = r.concat(a(s))))
                      : ((this._siblings[n] = J(s, this, !1)), 1 === o && 1 < this._siblings[n].length && et(s, this, null, 1, this._siblings[n]))
                    : 'string' == typeof (s = r[n--] = L.selector(s)) && r.splice(n + 1, 1)
                  : r.splice(n--, 1)
            else (this._propLookup = {}), (this._siblings = J(t, this, !1)), 1 === o && 1 < this._siblings.length && et(t, this, null, 1, this._siblings)
            ;(this.vars.immediateRender || (0 === e && 0 === this._delay && !1 !== this.vars.immediateRender)) && ((this._time = -y), this.render(Math.min(0, -this._delay)))
          },
          !0
        ),
        R = function (t) {
          return t && t.length && t !== d && t[0] && (t[0] === d || (t[0].nodeType && t[0].style && !t.nodeType))
        }
      ;((t = L.prototype = new h()).constructor = L),
        (t.kill()._gc = !1),
        (t.ratio = 0),
        (t._firstPT = t._targets = t._overwrittenProps = t._startAt = null),
        (t._notifyPluginsOfEnabled = t._lazy = !1),
        (L.version = '1.20.3'),
        (L.defaultEase = t._ease = new P(null, null, 1, 1)),
        (L.defaultOverwrite = 'auto'),
        (L.ticker = M),
        (L.autoSleep = 120),
        (L.lagSmoothing = function (t, e) {
          M.lagSmoothing(t, e)
        }),
        (L.selector =
          d.$ ||
          d.jQuery ||
          function (t) {
            var e = d.$ || d.jQuery
            return e ? (L.selector = e)(t) : void 0 === m ? t : m.querySelectorAll ? m.querySelectorAll(t) : m.getElementById('#' === t.charAt(0) ? t.substr(1) : t)
          })
      var I = [],
        F = {},
        N = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
        X = /[\+-]=-?[\.\d]/,
        j = function (t) {
          for (var e, i = this._firstPT; i; )
            (e = i.blob ? (1 === t && null != this.end ? this.end : t ? this.join('') : this.start) : i.c * t + i.s), i.m ? (e = i.m(e, this._target || i.t)) : e < 1e-6 && -1e-6 < e && !i.blob && (e = 0), i.f ? (i.fp ? i.t[i.p](i.fp, e) : i.t[i.p](e)) : (i.t[i.p] = e), (i = i._next)
        },
        B = function (t, e, i, n) {
          var s,
            r,
            o,
            a,
            l,
            h,
            c = [],
            u = 0,
            d = '',
            f = 0
          for (c.start = t, c.end = e, t = c[0] = t + '', e = c[1] = e + '', i && (i(c), (t = c[0]), (e = c[1])), c.length = 0, s = t.match(N) || [], r = e.match(N) || [], n && ((n._next = null), (n.blob = 1), (c._firstPT = c._applyPT = n)), a = r.length, o = 0; o < a; o++)
            (h = r[o]),
              (d += (l = e.substr(u, e.indexOf(h, u) - u)) || !o ? l : ','),
              (u += l.length),
              f ? (f = (f + 1) % 5) : 'rgba(' === l.substr(-5) && (f = 1),
              h === s[o] || s.length <= o
                ? (d += h)
                : (d && (c.push(d), (d = '')), (l = parseFloat(s[o])), c.push(l), (c._firstPT = { _next: c._firstPT, t: c, p: c.length - 1, s: l, c: ('=' === h.charAt(1) ? parseInt(h.charAt(0) + '1', 10) * parseFloat(h.substr(2)) : parseFloat(h) - l) || 0, f: 0, m: f && f < 4 ? Math.round : 0 })),
              (u += h.length)
          return (d += e.substr(u)) && c.push(d), (c.setRatio = j), X.test(e) && (c.end = null), c
        },
        U = function (t, e, i, n, s, r, o, a, l) {
          'function' == typeof n && (n = n(l || 0, t))
          var h = typeof t[e],
            l = 'function' != h ? '' : e.indexOf('set') || 'function' != typeof t['get' + e.substr(3)] ? e : 'get' + e.substr(3),
            i = 'get' !== i ? i : l ? (o ? t[l](o) : t[l]()) : t[e],
            l = 'string' == typeof n && '=' === n.charAt(1),
            r = { t: t, p: e, s: i, f: 'function' == h, pg: 0, n: s || e, m: r ? ('function' == typeof r ? r : Math.round) : 0, pr: 0, c: l ? parseInt(n.charAt(0) + '1', 10) * parseFloat(n.substr(2)) : parseFloat(n) - i || 0 }
          if (
            (('number' == typeof i && ('number' == typeof n || l)) ||
              (o || isNaN(i) || (!l && isNaN(n)) || 'boolean' == typeof i || 'boolean' == typeof n
                ? ((r.fp = o), (r = { t: B(i, l ? parseFloat(r.s) + r.c : n, a || L.defaultStringFilter, r), p: 'setRatio', s: 0, c: 1, f: 2, pg: 0, n: s || e, pr: 0, m: 0 }))
                : ((r.s = parseFloat(i)), l || (r.c = parseFloat(n) - r.s || 0))),
            r.c)
          )
            return (r._next = this._firstPT) && (r._next._prev = r), (this._firstPT = r)
        },
        W = (L._internals = { isArray: w, isSelector: R, lazyTweens: I, blobDif: B }),
        Y = (L._plugins = {}),
        q = (W.tweenLookup = {}),
        H = 0,
        Z = (W.reservedProps = {
          ease: 1,
          delay: 1,
          overwrite: 1,
          onComplete: 1,
          onCompleteParams: 1,
          onCompleteScope: 1,
          useFrames: 1,
          runBackwards: 1,
          startAt: 1,
          onUpdate: 1,
          onUpdateParams: 1,
          onUpdateScope: 1,
          onStart: 1,
          onStartParams: 1,
          onStartScope: 1,
          onReverseComplete: 1,
          onReverseCompleteParams: 1,
          onReverseCompleteScope: 1,
          onRepeat: 1,
          onRepeatParams: 1,
          onRepeatScope: 1,
          easeParams: 1,
          yoyo: 1,
          immediateRender: 1,
          repeat: 1,
          repeatDelay: 1,
          data: 1,
          paused: 1,
          reversed: 1,
          autoCSS: 1,
          lazy: 1,
          onOverwrite: 1,
          callbackScope: 1,
          stringFilter: 1,
          id: 1,
          yoyoEase: 1,
        }),
        V = { none: 0, all: 1, auto: 2, concurrent: 3, allOnStart: 4, preexisting: 5, true: 1, false: 0 },
        G = (h._rootFramesTimeline = new z()),
        Q = (h._rootTimeline = new z()),
        $ = 30,
        K = (W.lazyRender = function () {
          var t,
            e = I.length
          for (F = {}; -1 < --e; ) (t = I[e]) && !1 !== t._lazy && (t.render(t._lazy[0], t._lazy[1], !0), (t._lazy = !1))
          I.length = 0
        })
      ;(Q._startTime = M.time),
        (G._startTime = M.frame),
        (Q._active = G._active = !0),
        setTimeout(K, 1),
        (h._updateRoot = L.render =
          function () {
            var t, e, i
            if ((I.length && K(), Q.render((M.time - Q._startTime) * Q._timeScale, !1, !1), G.render((M.frame - G._startTime) * G._timeScale, !1, !1), I.length && K(), M.frame >= $)) {
              for (i in (($ = M.frame + (parseInt(L.autoSleep, 10) || 120)), q)) {
                for (t = (e = q[i].tweens).length; -1 < --t; ) e[t]._gc && e.splice(t, 1)
                0 === e.length && delete q[i]
              }
              if ((!(i = Q._first) || i._paused) && L.autoSleep && !G._first && 1 === M._listeners.tick.length) {
                for (; i && i._paused; ) i = i._next
                i || M.sleep()
              }
            }
          }),
        M.addEventListener('tick', h._updateRoot)
      var J = function (t, e, i) {
          var n,
            s,
            r = t._gsTweenID
          if ((q[r || (t._gsTweenID = r = 't' + H++)] || (q[r] = { target: t, tweens: [] }), e && (((n = q[r].tweens)[(s = n.length)] = e), i))) for (; -1 < --s; ) n[s] === e && n.splice(s, 1)
          return q[r].tweens
        },
        tt = function (t, e, i, n) {
          var s,
            r,
            o = t.vars.onOverwrite
          return o && (s = o(t, e, i, n)), (o = L.onOverwrite) && (r = o(t, e, i, n)), !1 !== s && !1 !== r
        },
        et = function (t, e, i, n, s) {
          var r, o, a
          if (1 === n || 4 <= n) {
            for (a = s.length, f = 0; f < a; f++)
              if ((o = s[f]) !== e) o._gc || (o._kill(null, t, e) && (r = !0))
              else if (5 === n) break
            return r
          }
          for (var l, h = e._startTime + y, c = [], u = 0, d = 0 === e._duration, f = s.length; -1 < --f; )
            (o = s[f]) === e || o._gc || o._paused || (o._timeline !== e._timeline ? ((l = l || it(e, 0, d)), 0 === it(o, l, d) && (c[u++] = o)) : o._startTime <= h && o._startTime + o.totalDuration() / o._timeScale > h && (((d || !o._initted) && h - o._startTime <= 2e-10) || (c[u++] = o)))
          for (f = u; -1 < --f; )
            if (((o = c[f]), 2 === n && o._kill(i, t, e) && (r = !0), 2 !== n || (!o._firstPT && o._initted))) {
              if (2 !== n && !tt(o, e)) continue
              o._enabled(!1, !1) && (r = !0)
            }
          return r
        },
        it = function (t, e, i) {
          for (var n = t._timeline, s = n._timeScale, r = t._startTime; n._timeline; ) {
            if (((r += n._startTime), (s *= n._timeScale), n._paused)) return -100
            n = n._timeline
          }
          return e < (r /= s) ? r - e : (i && r === e) || (!t._initted && r - e < 2 * y) ? y : (r += t.totalDuration() / t._timeScale / s) > e + y ? 0 : r - e - y
        }
      ;(t._init = function () {
        var t,
          e,
          i,
          n,
          s,
          r,
          o = this.vars,
          a = this._overwrittenProps,
          l = this._duration,
          h = !!o.immediateRender,
          c = o.ease
        if (o.startAt) {
          for (n in (this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), (s = {}), o.startAt)) s[n] = o.startAt[n]
          if (
            ((s.data = 'isStart'),
            (s.overwrite = !1),
            (s.immediateRender = !0),
            (s.lazy = h && !1 !== o.lazy),
            (s.startAt = s.delay = null),
            (s.onUpdate = o.onUpdate),
            (s.onUpdateParams = o.onUpdateParams),
            (s.onUpdateScope = o.onUpdateScope || o.callbackScope || this),
            (this._startAt = L.to(this.target, 0, s)),
            h)
          )
            if (0 < this._time) this._startAt = null
            else if (0 !== l) return
        } else if (o.runBackwards && 0 !== l)
          if (this._startAt) this._startAt.render(-1, !0), this._startAt.kill(), (this._startAt = null)
          else {
            for (n in (0 !== this._time && (h = !1), (i = {}), o)) (Z[n] && 'autoCSS' !== n) || (i[n] = o[n])
            if (((i.overwrite = 0), (i.data = 'isFromStart'), (i.lazy = h && !1 !== o.lazy), (i.immediateRender = h), (this._startAt = L.to(this.target, 0, i)), h)) {
              if (0 === this._time) return
            } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null)
          }
        if (
          ((this._ease = c = c ? (c instanceof P ? c : 'function' == typeof c ? new P(c, o.easeParams) : C[c] || L.defaultEase) : L.defaultEase),
          o.easeParams instanceof Array && c.config && (this._ease = c.config.apply(c, o.easeParams)),
          (this._easeType = this._ease._type),
          (this._easePower = this._ease._power),
          (this._firstPT = null),
          this._targets)
        )
          for (r = this._targets.length, t = 0; t < r; t++) this._initProps(this._targets[t], (this._propLookup[t] = {}), this._siblings[t], a ? a[t] : null, t) && (e = !0)
        else e = this._initProps(this.target, this._propLookup, this._siblings, a, 0)
        if ((e && L._onPluginEvent('_onInitAllProps', this), a && (this._firstPT || ('function' != typeof this.target && this._enabled(!1, !1))), o.runBackwards)) for (i = this._firstPT; i; ) (i.s += i.c), (i.c = -i.c), (i = i._next)
        ;(this._onUpdate = o.onUpdate), (this._initted = !0)
      }),
        (t._initProps = function (t, e, i, n, s) {
          var r, o, a, l, h, c
          if (null == t) return !1
          for (r in (F[t._gsTweenID] && K(),
          this.vars.css ||
            (t.style &&
              t !== d &&
              t.nodeType &&
              Y.css &&
              !1 !== this.vars.autoCSS &&
              (function (t, e) {
                var i,
                  n = {}
                for (i in t) Z[i] || (i in e && 'transform' !== i && 'x' !== i && 'y' !== i && 'width' !== i && 'height' !== i && 'className' !== i && 'border' !== i) || !(!Y[i] || (Y[i] && Y[i]._autoCSS)) || ((n[i] = t[i]), delete t[i])
                t.css = n
              })(this.vars, t)),
          this.vars))
            if (((c = this.vars[r]), Z[r])) c && (c instanceof Array || (c.push && w(c))) && -1 !== c.join('').indexOf('{self}') && (this.vars[r] = c = this._swapSelfInParams(c, this))
            else if (Y[r] && (l = new Y[r]())._onInitTween(t, this.vars[r], this, s)) {
              for (this._firstPT = h = { _next: this._firstPT, t: l, p: 'setRatio', s: 0, c: 1, f: 1, n: r, pg: 1, pr: l._priority, m: 0 }, o = l._overwriteProps.length; -1 < --o; ) e[l._overwriteProps[o]] = this._firstPT
              ;(l._priority || l._onInitAllProps) && (a = !0), (l._onDisable || l._onEnable) && (this._notifyPluginsOfEnabled = !0), h._next && (h._next._prev = h)
            } else e[r] = U.call(this, t, r, 'get', c, r, 0, null, this.vars.stringFilter, s)
          return n && this._kill(n, t)
            ? this._initProps(t, e, i, n, s)
            : 1 < this._overwrite && this._firstPT && 1 < i.length && et(t, this, e, this._overwrite, i)
            ? (this._kill(e, t), this._initProps(t, e, i, n, s))
            : (this._firstPT && ((!1 !== this.vars.lazy && this._duration) || (this.vars.lazy && !this._duration)) && (F[t._gsTweenID] = !0), a)
        }),
        (t.render = function (t, e, i) {
          var n,
            s,
            r,
            o,
            a,
            l,
            h,
            c = this._time,
            u = this._duration,
            d = this._rawPrevTime
          if (
            (u - 1e-7 <= t && 0 <= t
              ? ((this._totalTime = this._time = u),
                (this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1),
                this._reversed || ((n = !0), (s = 'onComplete'), (i = i || this._timeline.autoRemoveChildren)),
                0 !== u ||
                  (!this._initted && this.vars.lazy && !i) ||
                  (this._startTime === this._timeline._duration && (t = 0), (d < 0 || (t <= 0 && -1e-7 <= t) || (d === y && 'isPause' !== this.data)) && d !== t && ((i = !0), y < d && (s = 'onReverseComplete')), (this._rawPrevTime = o = !e || t || d === t ? t : y)))
              : t < 1e-7
              ? ((this._totalTime = this._time = 0),
                (this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0),
                (0 !== c || (0 === u && 0 < d)) && ((s = 'onReverseComplete'), (n = this._reversed)),
                t < 0 && ((this._active = !1), 0 !== u || (!this._initted && this.vars.lazy && !i) || (0 <= d && (d !== y || 'isPause' !== this.data) && (i = !0), (this._rawPrevTime = o = !e || t || d === t ? t : y))),
                (!this._initted || (this._startAt && this._startAt.progress())) && (i = !0))
              : ((this._totalTime = this._time = t),
                this._easeType
                  ? ((a = t / u),
                    (1 === (l = this._easeType) || (3 === l && 0.5 <= a)) && (a = 1 - a),
                    3 === l && (a *= 2),
                    1 === (h = this._easePower) ? (a *= a) : 2 === h ? (a *= a * a) : 3 === h ? (a *= a * a * a) : 4 === h && (a *= a * a * a * a),
                    (this.ratio = 1 === l ? 1 - a : 2 === l ? a : t / u < 0.5 ? a / 2 : 1 - a / 2))
                  : (this.ratio = this._ease.getRatio(t / u))),
            this._time !== c || i)
          ) {
            if (!this._initted) {
              if ((this._init(), !this._initted || this._gc)) return
              if (!i && this._firstPT && ((!1 !== this.vars.lazy && this._duration) || (this.vars.lazy && !this._duration))) return (this._time = this._totalTime = c), (this._rawPrevTime = d), I.push(this), void (this._lazy = [t, e])
              this._time && !n ? (this.ratio = this._ease.getRatio(this._time / u)) : n && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
            }
            for (
              !1 !== this._lazy && (this._lazy = !1),
                this._active || (!this._paused && this._time !== c && 0 <= t && (this._active = !0)),
                0 === c && (this._startAt && (0 <= t ? this._startAt.render(t, !0, i) : (s = s || '_dummyGS')), this.vars.onStart && ((0 === this._time && 0 !== u) || e || this._callback('onStart'))),
                r = this._firstPT;
              r;

            )
              r.f ? r.t[r.p](r.c * this.ratio + r.s) : (r.t[r.p] = r.c * this.ratio + r.s), (r = r._next)
            this._onUpdate && (t < 0 && this._startAt && -1e-4 !== t && this._startAt.render(t, !0, i), e || ((this._time !== c || n || i) && this._callback('onUpdate'))),
              s &&
                ((this._gc && !i) ||
                  (t < 0 && this._startAt && !this._onUpdate && -1e-4 !== t && this._startAt.render(t, !0, i),
                  n && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)),
                  !e && this.vars[s] && this._callback(s),
                  0 === u && this._rawPrevTime === y && o !== y && (this._rawPrevTime = 0)))
          }
        }),
        (t._kill = function (t, e, i) {
          if (('all' === t && (t = null), null == t && (null == e || e === this.target))) return (this._lazy = !1), this._enabled(!1, !1)
          e = 'string' != typeof e ? e || this._targets || this.target : L.selector(e) || e
          var n,
            s,
            r,
            o,
            a,
            l,
            h,
            c,
            u,
            d = i && this._time && i._startTime === this._startTime && this._timeline === i._timeline
          if ((w(e) || R(e)) && 'number' != typeof e[0]) for (n = e.length; -1 < --n; ) this._kill(t, e[n], i) && (l = !0)
          else {
            if (this._targets) {
              for (n = this._targets.length; -1 < --n; )
                if (e === this._targets[n]) {
                  ;(a = this._propLookup[n] || {}), (this._overwrittenProps = this._overwrittenProps || []), (s = this._overwrittenProps[n] = t ? this._overwrittenProps[n] || {} : 'all')
                  break
                }
            } else {
              if (e !== this.target) return !1
              ;(a = this._propLookup), (s = this._overwrittenProps = t ? this._overwrittenProps || {} : 'all')
            }
            if (a) {
              if (((h = t || a), (c = t !== s && 'all' !== s && t !== a && ('object' != typeof t || !t._tempKill)), i && (L.onOverwrite || this.vars.onOverwrite))) {
                for (r in h) a[r] && ((u = u || []), u.push(r))
                if ((u || !t) && !tt(this, i, e, u)) return !1
              }
              for (r in h)
                (o = a[r]) &&
                  (d && (o.f ? o.t[o.p](o.s) : (o.t[o.p] = o.s), (l = !0)),
                  o.pg && o.t._kill(h) && (l = !0),
                  (o.pg && 0 !== o.t._overwriteProps.length) || (o._prev ? (o._prev._next = o._next) : o === this._firstPT && (this._firstPT = o._next), o._next && (o._next._prev = o._prev), (o._next = o._prev = null)),
                  delete a[r]),
                  c && (s[r] = 1)
              !this._firstPT && this._initted && this._enabled(!1, !1)
            }
          }
          return l
        }),
        (t.invalidate = function () {
          return (
            this._notifyPluginsOfEnabled && L._onPluginEvent('_onDisable', this),
            (this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null),
            (this._notifyPluginsOfEnabled = this._active = this._lazy = !1),
            (this._propLookup = this._targets ? {} : []),
            h.prototype.invalidate.call(this),
            this.vars.immediateRender && ((this._time = -y), this.render(Math.min(0, -this._delay))),
            this
          )
        }),
        (t._enabled = function (t, e) {
          if ((v || M.wake(), t && this._gc)) {
            var i,
              n = this._targets
            if (n) for (i = n.length; -1 < --i; ) this._siblings[i] = J(n[i], this, !0)
            else this._siblings = J(this.target, this, !0)
          }
          return h.prototype._enabled.call(this, t, e), !(!this._notifyPluginsOfEnabled || !this._firstPT) && L._onPluginEvent(t ? '_onEnable' : '_onDisable', this)
        }),
        (L.to = function (t, e, i) {
          return new L(t, e, i)
        }),
        (L.from = function (t, e, i) {
          return (i.runBackwards = !0), (i.immediateRender = 0 != i.immediateRender), new L(t, e, i)
        }),
        (L.fromTo = function (t, e, i, n) {
          return (n.startAt = i), (n.immediateRender = 0 != n.immediateRender && 0 != i.immediateRender), new L(t, e, n)
        }),
        (L.delayedCall = function (t, e, i, n, s) {
          return new L(e, 0, { delay: t, onComplete: e, onCompleteParams: i, callbackScope: n, onReverseComplete: e, onReverseCompleteParams: i, immediateRender: !1, lazy: !1, useFrames: s, overwrite: 0 })
        }),
        (L.set = function (t, e) {
          return new L(t, 0, e)
        }),
        (L.getTweensOf = function (t, e) {
          if (null == t) return []
          var i, n, s, r
          if (((t = ('string' == typeof t && L.selector(t)) || t), (w(t) || R(t)) && 'number' != typeof t[0])) {
            for (i = t.length, n = []; -1 < --i; ) n = n.concat(L.getTweensOf(t[i], e))
            for (i = n.length; -1 < --i; ) for (r = n[i], s = i; -1 < --s; ) r === n[s] && n.splice(i, 1)
          } else if (t._gsTweenID) for (i = (n = J(t).concat()).length; -1 < --i; ) (n[i]._gc || (e && !n[i].isActive())) && n.splice(i, 1)
          return n || []
        }),
        (L.killTweensOf = L.killDelayedCallsTo =
          function (t, e, i) {
            'object' == typeof e && ((i = e), (e = !1))
            for (var n = L.getTweensOf(t, e), s = n.length; -1 < --s; ) n[s]._kill(i, t)
          })
      var nt = S(
        'plugins.TweenPlugin',
        function (t, e) {
          ;(this._overwriteProps = (t || '').split(',')), (this._propName = this._overwriteProps[0]), (this._priority = e || 0), (this._super = nt.prototype)
        },
        !0
      )
      if (
        ((t = nt.prototype),
        (nt.version = '1.19.0'),
        (nt.API = 2),
        (t._firstPT = null),
        (t._addTween = U),
        (t.setRatio = j),
        (t._kill = function (t) {
          var e,
            i = this._overwriteProps,
            n = this._firstPT
          if (null != t[this._propName]) this._overwriteProps = []
          else for (e = i.length; -1 < --e; ) null != t[i[e]] && i.splice(e, 1)
          for (; n; ) null != t[n.n] && (n._next && (n._next._prev = n._prev), n._prev ? ((n._prev._next = n._next), (n._prev = null)) : this._firstPT === n && (this._firstPT = n._next)), (n = n._next)
          return !1
        }),
        (t._mod = t._roundProps =
          function (t) {
            for (var e, i = this._firstPT; i; ) (e = t[this._propName] || (null != i.n && t[i.n.split(this._propName + '_').join('')])) && 'function' == typeof e && (2 === i.f ? (i.t._applyPT.m = e) : (i.m = e)), (i = i._next)
          }),
        (L._onPluginEvent = function (t, e) {
          var i,
            n,
            s,
            r,
            o,
            a = e._firstPT
          if ('_onInitAllProps' === t) {
            for (; a; ) {
              for (o = a._next, n = s; n && n.pr > a.pr; ) n = n._next
              ;(a._prev = n ? n._prev : r) ? (a._prev._next = a) : (s = a), (a._next = n) ? (n._prev = a) : (r = a), (a = o)
            }
            a = e._firstPT = s
          }
          for (; a; ) a.pg && 'function' == typeof a.t[t] && a.t[t]() && (i = !0), (a = a._next)
          return i
        }),
        (nt.activate = function (t) {
          for (var e = t.length; -1 < --e; ) t[e].API === nt.API && (Y[new t[e]()._propName] = t[e])
          return !0
        }),
        (n.plugin = function (t) {
          if (!(t && t.propName && t.init && t.API)) throw 'illegal plugin definition.'
          var e,
            i = t.propName,
            n = t.priority || 0,
            s = t.overwriteProps,
            r = { init: '_onInitTween', set: 'setRatio', kill: '_kill', round: '_mod', mod: '_mod', initAll: '_onInitAllProps' },
            o = S(
              'plugins.' + i.charAt(0).toUpperCase() + i.substr(1) + 'Plugin',
              function () {
                nt.call(this, i, n), (this._overwriteProps = s || [])
              },
              !0 === t.global
            ),
            a = (o.prototype = new nt(i))
          for (e in (((a.constructor = o).API = t.API), r)) 'function' == typeof t[e] && (a[r[e]] = t[e])
          return (o.version = t.version), nt.activate([o]), o
        }),
        (o = d._gsQueue))
      ) {
        for (l = 0; l < o.length; l++) o[l]()
        for (t in b) b[t].func || d.console.log('GSAP encountered missing dependency: ' + t)
      }
      v = !1
    }
  })('undefined' != typeof module && module.exports && 'undefined' != typeof global ? global : this || window, 'TweenLite')
var _gsScope = 'undefined' != typeof module && module.exports && 'undefined' != typeof global ? global : this || window
;(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
  'use strict'
  _gsScope._gsDefine(
    'TimelineLite',
    ['core.Animation', 'core.SimpleTimeline', 'TweenLite'],
    function (c, u, d) {
      function f(t) {
        u.call(this, t), (this._labels = {}), (this.autoRemoveChildren = !0 === this.vars.autoRemoveChildren), (this.smoothChildTiming = !0 === this.vars.smoothChildTiming), (this._sortChildren = !0), (this._onUpdate = this.vars.onUpdate)
        var e,
          i,
          n = this.vars
        for (i in n) (e = n[i]), y(e) && -1 !== e.join('').indexOf('{self}') && (n[i] = this._swapSelfInParams(e))
        y(n.tweens) && this.add(n.tweens, 0, n.align, n.stagger)
      }
      function p(t) {
        var e,
          i = {}
        for (e in t) i[e] = t[e]
        return i
      }
      function m(t, e, i) {
        var n,
          s,
          r = t.cycle
        for (n in r) (s = r[n]), (t[n] = 'function' == typeof s ? s(i, e[i]) : s[i % s.length])
        delete t.cycle
      }
      function g(t) {
        for (var e = [], i = t.length, n = 0; n !== i; e.push(t[n++]));
        return e
      }
      var v = 1e-10,
        t = d._internals,
        e = (f._internals = {}),
        _ = t.isSelector,
        y = t.isArray,
        x = t.lazyTweens,
        w = t.lazyRender,
        o = _gsScope._gsDefine.globals,
        s = (e.pauseCallback = function () {}),
        e = (f.prototype = new u())
      return (
        (f.version = '1.20.3'),
        (e.constructor = f),
        (e.kill()._gc = e._forcingPlayhead = e._hasPause = !1),
        (e.to = function (t, e, i, n) {
          var s = (i.repeat && o.TweenMax) || d
          return e ? this.add(new s(t, e, i), n) : this.set(t, i, n)
        }),
        (e.from = function (t, e, i, n) {
          return this.add(((i.repeat && o.TweenMax) || d).from(t, e, i), n)
        }),
        (e.fromTo = function (t, e, i, n, s) {
          var r = (n.repeat && o.TweenMax) || d
          return e ? this.add(r.fromTo(t, e, i, n), s) : this.set(t, n, s)
        }),
        (e.staggerTo = function (t, e, i, n, s, r, o, a) {
          var l,
            h,
            c = new f({ onComplete: r, onCompleteParams: o, callbackScope: a, smoothChildTiming: this.smoothChildTiming }),
            u = i.cycle
          for ('string' == typeof t && (t = d.selector(t) || t), _((t = t || [])) && (t = g(t)), (n = n || 0) < 0 && ((t = g(t)).reverse(), (n *= -1)), h = 0; h < t.length; h++)
            (l = p(i)).startAt && ((l.startAt = p(l.startAt)), l.startAt.cycle && m(l.startAt, t, h)), u && (m(l, t, h), null != l.duration && ((e = l.duration), delete l.duration)), c.to(t[h], e, l, h * n)
          return this.add(c, s)
        }),
        (e.staggerFrom = function (t, e, i, n, s, r, o, a) {
          return (i.immediateRender = 0 != i.immediateRender), (i.runBackwards = !0), this.staggerTo(t, e, i, n, s, r, o, a)
        }),
        (e.staggerFromTo = function (t, e, i, n, s, r, o, a, l) {
          return (n.startAt = i), (n.immediateRender = 0 != n.immediateRender && 0 != i.immediateRender), this.staggerTo(t, e, n, s, r, o, a, l)
        }),
        (e.call = function (t, e, i, n) {
          return this.add(d.delayedCall(0, t, e, i), n)
        }),
        (e.set = function (t, e, i) {
          return (i = this._parseTimeOrLabel(i, 0, !0)), null == e.immediateRender && (e.immediateRender = i === this._time && !this._paused), this.add(new d(t, 0, e), i)
        }),
        (f.exportRoot = function (t, e) {
          null == (t = t || {}).smoothChildTiming && (t.smoothChildTiming = !0)
          var i,
            n,
            s,
            r,
            o = new f(t),
            t = o._timeline
          for (null == e && (e = !0), t._remove(o, !0), o._startTime = 0, o._rawPrevTime = o._time = o._totalTime = t._time, s = t._first; s; ) (r = s._next), (e && s instanceof d && s.target === s.vars.onComplete) || ((n = s._startTime - s._delay) < 0 && (i = 1), o.add(s, n)), (s = r)
          return t.add(o, 0), i && o.totalDuration(), o
        }),
        (e.add = function (t, e, i, n) {
          var s, r, o, a, l, h
          if (('number' != typeof e && (e = this._parseTimeOrLabel(e, 0, !0, t)), !(t instanceof c))) {
            if (t instanceof Array || (t && t.push && y(t))) {
              for (i = i || 'normal', n = n || 0, s = e, r = t.length, o = 0; o < r; o++)
                y((a = t[o])) && (a = new f({ tweens: a })), this.add(a, s), 'string' != typeof a && 'function' != typeof a && ('sequence' === i ? (s = a._startTime + a.totalDuration() / a._timeScale) : 'start' === i && (a._startTime -= a.delay())), (s += n)
              return this._uncache(!0)
            }
            if ('string' == typeof t) return this.addLabel(t, e)
            if ('function' != typeof t) throw 'Cannot add ' + t + ' into the timeline; it is not a tween, timeline, function, or string.'
            t = d.delayedCall(0, t)
          }
          if ((u.prototype.add.call(this, t, e), t._time && t.render((this.rawTime() - t._startTime) * t._timeScale, !1, !1), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration()))
            for (h = (l = this).rawTime() > t._startTime; l._timeline; ) h && l._timeline.smoothChildTiming ? l.totalTime(l._totalTime, !0) : l._gc && l._enabled(!0, !1), (l = l._timeline)
          return this
        }),
        (e.remove = function (t) {
          if (t instanceof c) {
            this._remove(t, !1)
            var e = (t._timeline = t.vars.useFrames ? c._rootFramesTimeline : c._rootTimeline)
            return (t._startTime = (t._paused ? t._pauseTime : e._time) - (t._reversed ? t.totalDuration() - t._totalTime : t._totalTime) / t._timeScale), this
          }
          if (t instanceof Array || (t && t.push && y(t))) {
            for (var i = t.length; -1 < --i; ) this.remove(t[i])
            return this
          }
          return 'string' == typeof t ? this.removeLabel(t) : this.kill(null, t)
        }),
        (e._remove = function (t, e) {
          return u.prototype._remove.call(this, t, e), this._last ? this._time > this.duration() && ((this._time = this._duration), (this._totalTime = this._totalDuration)) : (this._time = this._totalTime = this._duration = this._totalDuration = 0), this
        }),
        (e.append = function (t, e) {
          return this.add(t, this._parseTimeOrLabel(null, e, !0, t))
        }),
        (e.insert = e.insertMultiple =
          function (t, e, i, n) {
            return this.add(t, e || 0, i, n)
          }),
        (e.appendMultiple = function (t, e, i, n) {
          return this.add(t, this._parseTimeOrLabel(null, e, !0, t), i, n)
        }),
        (e.addLabel = function (t, e) {
          return (this._labels[t] = this._parseTimeOrLabel(e)), this
        }),
        (e.addPause = function (t, e, i, n) {
          n = d.delayedCall(0, s, i, n || this)
          return (n.vars.onComplete = n.vars.onReverseComplete = e), (n.data = 'isPause'), (this._hasPause = !0), this.add(n, t)
        }),
        (e.removeLabel = function (t) {
          return delete this._labels[t], this
        }),
        (e.getLabelTime = function (t) {
          return null != this._labels[t] ? this._labels[t] : -1
        }),
        (e._parseTimeOrLabel = function (t, e, i, n) {
          var s, r
          if (n instanceof c && n.timeline === this) this.remove(n)
          else if (n && (n instanceof Array || (n.push && y(n)))) for (r = n.length; -1 < --r; ) n[r] instanceof c && n[r].timeline === this && this.remove(n[r])
          if (((s = 'number' != typeof t || e ? (99999999999 < this.duration() ? this.recent().endTime(!1) : this._duration) : 0), 'string' == typeof e)) return this._parseTimeOrLabel(e, i && 'number' == typeof t && null == this._labels[e] ? t - s : 0, i)
          if (((e = e || 0), 'string' != typeof t || (!isNaN(t) && null == this._labels[t]))) null == t && (t = s)
          else {
            if (-1 === (r = t.indexOf('='))) return null == this._labels[t] ? (i ? (this._labels[t] = s + e) : e) : this._labels[t] + e
            ;(e = parseInt(t.charAt(r - 1) + '1', 10) * Number(t.substr(r + 1))), (t = 1 < r ? this._parseTimeOrLabel(t.substr(0, r - 1), 0, i) : s)
          }
          return Number(t) + e
        }),
        (e.seek = function (t, e) {
          return this.totalTime('number' == typeof t ? t : this._parseTimeOrLabel(t), !1 !== e)
        }),
        (e.stop = function () {
          return this.paused(!0)
        }),
        (e.gotoAndPlay = function (t, e) {
          return this.play(t, e)
        }),
        (e.gotoAndStop = function (t, e) {
          return this.pause(t, e)
        }),
        (e.render = function (t, e, i) {
          this._gc && this._enabled(!0, !1)
          var n,
            s,
            r,
            o,
            a,
            l,
            h,
            c = this._time,
            u = this._dirty ? this.totalDuration() : this._totalDuration,
            d = this._startTime,
            f = this._timeScale,
            p = this._paused
          if ((c !== this._time && (t += this._time - c), u - 1e-7 <= t && 0 <= t))
            (this._totalTime = this._time = u),
              this._reversed ||
                this._hasPausedChild() ||
                ((s = !0), (o = 'onComplete'), (a = !!this._timeline.autoRemoveChildren), 0 === this._duration && ((t <= 0 && -1e-7 <= t) || this._rawPrevTime < 0 || this._rawPrevTime === v) && this._rawPrevTime !== t && this._first && ((a = !0), this._rawPrevTime > v && (o = 'onReverseComplete'))),
              (this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : v),
              (t = u + 1e-4)
          else if (t < 1e-7)
            if ((((this._totalTime = this._time = 0) !== c || (0 === this._duration && this._rawPrevTime !== v && (0 < this._rawPrevTime || (t < 0 && 0 <= this._rawPrevTime)))) && ((o = 'onReverseComplete'), (s = this._reversed)), t < 0))
              (this._active = !1), this._timeline.autoRemoveChildren && this._reversed ? ((a = s = !0), (o = 'onReverseComplete')) : 0 <= this._rawPrevTime && this._first && (a = !0), (this._rawPrevTime = t)
            else {
              if (((this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : v), 0 === t && s)) for (n = this._first; n && 0 === n._startTime; ) n._duration || (s = !1), (n = n._next)
              ;(t = 0), this._initted || (a = !0)
            }
          else {
            if (this._hasPause && !this._forcingPlayhead && !e) {
              if (c <= t) for (n = this._first; n && n._startTime <= t && !l; ) n._duration || 'isPause' !== n.data || n.ratio || (0 === n._startTime && 0 === this._rawPrevTime) || (l = n), (n = n._next)
              else for (n = this._last; n && n._startTime >= t && !l; ) n._duration || ('isPause' === n.data && 0 < n._rawPrevTime && (l = n)), (n = n._prev)
              l && ((this._time = t = l._startTime), (this._totalTime = t + this._cycle * (this._totalDuration + this._repeatDelay)))
            }
            this._totalTime = this._time = this._rawPrevTime = t
          }
          if ((this._time !== c && this._first) || i || a || l) {
            if ((this._initted || (this._initted = !0), this._active || (!this._paused && this._time !== c && 0 < t && (this._active = !0)), 0 === c && this.vars.onStart && ((0 === this._time && this._duration) || e || this._callback('onStart')), c <= (h = this._time)))
              for (n = this._first; n && ((r = n._next), h === this._time && (!this._paused || p)); )
                (n._active || (n._startTime <= h && !n._paused && !n._gc)) && (l === n && this.pause(), n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (t - n._startTime) * n._timeScale, e, i) : n.render((t - n._startTime) * n._timeScale, e, i)), (n = r)
            else
              for (n = this._last; n && ((r = n._prev), h === this._time && (!this._paused || p)); ) {
                if (n._active || (n._startTime <= c && !n._paused && !n._gc)) {
                  if (l === n) {
                    for (l = n._prev; l && l.endTime() > this._time; ) l.render(l._reversed ? l.totalDuration() - (t - l._startTime) * l._timeScale : (t - l._startTime) * l._timeScale, e, i), (l = l._prev)
                    ;(l = null), this.pause()
                  }
                  n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (t - n._startTime) * n._timeScale, e, i) : n.render((t - n._startTime) * n._timeScale, e, i)
                }
                n = r
              }
            this._onUpdate && (e || (x.length && w(), this._callback('onUpdate'))),
              o && (this._gc || (d !== this._startTime && f === this._timeScale) || ((0 === this._time || u >= this.totalDuration()) && (s && (x.length && w(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)), !e && this.vars[o] && this._callback(o))))
          }
        }),
        (e._hasPausedChild = function () {
          for (var t = this._first; t; ) {
            if (t._paused || (t instanceof f && t._hasPausedChild())) return !0
            t = t._next
          }
          return !1
        }),
        (e.getChildren = function (t, e, i, n) {
          n = n || -9999999999
          for (var s = [], r = this._first, o = 0; r; ) r._startTime < n || (r instanceof d ? !1 !== e && (s[o++] = r) : (!1 !== i && (s[o++] = r), !1 !== t && (o = (s = s.concat(r.getChildren(!0, e, i))).length))), (r = r._next)
          return s
        }),
        (e.getTweensOf = function (t, e) {
          var i,
            n,
            s = this._gc,
            r = [],
            o = 0
          for (s && this._enabled(!0, !0), n = (i = d.getTweensOf(t)).length; -1 < --n; ) (i[n].timeline === this || (e && this._contains(i[n]))) && (r[o++] = i[n])
          return s && this._enabled(!1, !0), r
        }),
        (e.recent = function () {
          return this._recent
        }),
        (e._contains = function (t) {
          for (var e = t.timeline; e; ) {
            if (e === this) return !0
            e = e.timeline
          }
          return !1
        }),
        (e.shiftChildren = function (t, e, i) {
          i = i || 0
          for (var n, s = this._first, r = this._labels; s; ) s._startTime >= i && (s._startTime += t), (s = s._next)
          if (e) for (n in r) r[n] >= i && (r[n] += t)
          return this._uncache(!0)
        }),
        (e._kill = function (t, e) {
          if (!t && !e) return this._enabled(!1, !1)
          for (var i = e ? this.getTweensOf(e) : this.getChildren(!0, !0, !1), n = i.length, s = !1; -1 < --n; ) i[n]._kill(t, e) && (s = !0)
          return s
        }),
        (e.clear = function (t) {
          var e = this.getChildren(!1, !0, !0),
            i = e.length
          for (this._time = this._totalTime = 0; -1 < --i; ) e[i]._enabled(!1, !1)
          return !1 !== t && (this._labels = {}), this._uncache(!0)
        }),
        (e.invalidate = function () {
          for (var t = this._first; t; ) t.invalidate(), (t = t._next)
          return c.prototype.invalidate.call(this)
        }),
        (e._enabled = function (t, e) {
          if (t === this._gc) for (var i = this._first; i; ) i._enabled(t, !0), (i = i._next)
          return u.prototype._enabled.call(this, t, e)
        }),
        (e.totalTime = function (t, e, i) {
          this._forcingPlayhead = !0
          var n = c.prototype.totalTime.apply(this, arguments)
          return (this._forcingPlayhead = !1), n
        }),
        (e.duration = function (t) {
          return arguments.length ? (0 !== this.duration() && 0 !== t && this.timeScale(this._duration / t), this) : (this._dirty && this.totalDuration(), this._duration)
        }),
        (e.totalDuration = function (t) {
          if (arguments.length) return t && this.totalDuration() ? this.timeScale(this._totalDuration / t) : this
          if (this._dirty) {
            for (var e, i, n = 0, s = this._last, r = 999999999999; s; )
              (e = s._prev),
                s._dirty && s.totalDuration(),
                s._startTime > r && this._sortChildren && !s._paused && !this._calculatingDuration ? ((this._calculatingDuration = 1), this.add(s, s._startTime - s._delay), (this._calculatingDuration = 0)) : (r = s._startTime),
                s._startTime < 0 &&
                  !s._paused &&
                  ((n -= s._startTime), this._timeline.smoothChildTiming && ((this._startTime += s._startTime / this._timeScale), (this._time -= s._startTime), (this._totalTime -= s._startTime), (this._rawPrevTime -= s._startTime)), this.shiftChildren(-s._startTime, !1, -9999999999), (r = 0)),
                n < (i = s._startTime + s._totalDuration / s._timeScale) && (n = i),
                (s = e)
            ;(this._duration = this._totalDuration = n), (this._dirty = !1)
          }
          return this._totalDuration
        }),
        (e.paused = function (t) {
          if (!t) for (var e = this._first, i = this._time; e; ) e._startTime === i && 'isPause' === e.data && (e._rawPrevTime = 0), (e = e._next)
          return c.prototype.paused.apply(this, arguments)
        }),
        (e.usesFrames = function () {
          for (var t = this._timeline; t._timeline; ) t = t._timeline
          return t === c._rootFramesTimeline
        }),
        (e.rawTime = function (t) {
          return t && (this._paused || (this._repeat && 0 < this.time() && this.totalProgress() < 1)) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(t) - this._startTime) * this._timeScale
        }),
        f
      )
    },
    !0
  )
}),
  _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
  (function () {
    'use strict'
    function t() {
      return (_gsScope.GreenSockGlobals || _gsScope).TimelineLite
    }
    'undefined' != typeof module && module.exports ? (require('./TweenLite.js'), (module.exports = t())) : 'function' == typeof define && define.amd && define(['TweenLite'], t)
  })(),
  ((_gsScope = 'undefined' != typeof module && module.exports && 'undefined' != typeof global ? global : this || window)._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    'use strict'
    _gsScope._gsDefine(
      'plugins.CSSPlugin',
      ['plugins.TweenPlugin', 'TweenLite'],
      function (r, A) {
        var d,
          b,
          S,
          u,
          D = function () {
            r.call(this, 'css'), (this._overwriteProps.length = 0), (this.setRatio = D.prototype.setRatio)
          },
          h = _gsScope._gsDefine.globals,
          f = {},
          t = (D.prototype = new r('css'))
        ;((t.constructor = D).version = '1.20.3'),
          (D.API = 2),
          (D.defaultTransformPerspective = 0),
          (D.defaultSkewType = 'compensated'),
          (D.defaultSmoothOrigin = !0),
          (t = 'px'),
          (D.suffixMap = { top: t, right: t, bottom: t, left: t, width: t, height: t, fontSize: t, padding: t, margin: t, perspective: t, lineHeight: '' })
        function o(t, e) {
          return e.toUpperCase()
        }
        function a(t, e) {
          return K.createElementNS ? K.createElementNS(e || 'http://www.w3.org/1999/xhtml', t) : K.createElement(t)
        }
        function l(t) {
          return N.test('string' == typeof t ? t : (t.currentStyle || t.style).filter || '') ? parseFloat(RegExp.$1) / 100 : 1
        }
        function p(t) {
          _gsScope.console && console.log(t)
        }
        function T(t, e) {
          var i,
            n,
            s = (e = e || J).style
          if (void 0 !== s[t]) return t
          for (t = t.charAt(0).toUpperCase() + t.substr(1), i = ['O', 'Moz', 'ms', 'Ms', 'Webkit'], n = 5; -1 < --n && void 0 === s[i[n] + t]; );
          return 0 <= n ? ((nt = '-' + (st = 3 === n ? 'ms' : i[n]).toLowerCase() + '-'), st + t) : null
        }
        function m(t, e) {
          var i,
            n,
            s = {}
          if ((e = e || rt(t, null)))
            if ((i = e.length)) for (; -1 < --i; ) (-1 !== (n = e[i]).indexOf('-transform') && Mt !== n) || (s[n.replace(U, o)] = e.getPropertyValue(n))
            else for (i in e) (-1 !== i.indexOf('Transform') && Dt !== i) || (s[i] = e[i])
          else if ((e = t.currentStyle || t.style)) for (i in e) 'string' == typeof i && void 0 === s[i] && (s[i.replace(U, o)] = e[i])
          return (
            it || (s.opacity = l(t)),
            (t = Yt(t, e, !1)),
            (s.rotation = t.rotation),
            (s.skewX = t.skewX),
            (s.scaleX = t.scaleX),
            (s.scaleY = t.scaleY),
            (s.x = t.x),
            (s.y = t.y),
            Lt && ((s.z = t.z), (s.rotationX = t.rotationX), (s.rotationY = t.rotationY), (s.scaleZ = t.scaleZ)),
            s.filters && delete s.filters,
            s
          )
        }
        function g(t, e, i, n, s) {
          var r,
            o,
            a,
            l = {},
            h = t.style
          for (o in i)
            'cssText' !== o &&
              'length' !== o &&
              isNaN(o) &&
              (e[o] !== (r = i[o]) || (s && s[o])) &&
              -1 === o.indexOf('Origin') &&
              (('number' != typeof r && 'string' != typeof r) || ((l[o] = 'auto' !== r || ('left' !== o && 'top' !== o) ? (('' !== r && 'auto' !== r && 'none' !== r) || 'string' != typeof e[o] || '' === e[o].replace(I, '') ? r : 0) : lt(t, o)), void 0 !== h[o] && (a = new _t(h, o, h[o], a))))
          if (n) for (o in n) 'className' !== o && (l[o] = n[o])
          return { difs: l, firstMPT: a }
        }
        function C(t, e) {
          return 'function' == typeof t && (t = t(M, O)), 'string' == typeof t && '=' === t.charAt(1) ? parseInt(t.charAt(0) + '1', 10) * parseFloat(t.substr(2)) : parseFloat(t) - parseFloat(e) || 0
        }
        function P(t, e) {
          return 'function' == typeof t && (t = t(M, O)), null == t ? e : 'string' == typeof t && '=' === t.charAt(1) ? parseInt(t.charAt(0) + '1', 10) * parseFloat(t.substr(2)) + e : parseFloat(t) || 0
        }
        function k(t, e, i, n) {
          var s, r, o
          return (
            'function' == typeof t && (t = t(M, O)),
            (o =
              null == t
                ? e
                : 'number' == typeof t
                ? t
                : ((s = 360),
                  (r = t.split('_')),
                  (o = ((o = '=' === t.charAt(1)) ? parseInt(t.charAt(0) + '1', 10) * parseFloat(r[0].substr(2)) : parseFloat(r[0])) * (-1 === t.indexOf('rad') ? 1 : Q) - (o ? 0 : e)),
                  r.length &&
                    (n && (n[i] = e + o),
                    -1 !== t.indexOf('short') && (o %= s) !== o % 180 && (o = o < 0 ? o + s : o - s),
                    -1 !== t.indexOf('_cw') && o < 0 ? (o = ((o + 3599999999640) % s) - ((o / s) | 0) * s) : -1 !== t.indexOf('ccw') && 0 < o && (o = ((o - 3599999999640) % s) - ((o / s) | 0) * s)),
                  e + o)) < 1e-6 &&
              -1e-6 < o &&
              (o = 0),
            o
          )
        }
        function c(t, e, i) {
          return (255 * (6 * (t = t < 0 ? t + 1 : 1 < t ? t - 1 : t) < 1 ? e + (i - e) * t * 6 : t < 0.5 ? i : 3 * t < 2 ? e + (i - e) * (2 / 3 - t) * 6 : e) + 0.5) | 0
        }
        function i(t, e) {
          var i,
            n,
            s,
            r = t.match(pt) || [],
            o = 0,
            a = ''
          if (!r.length) return t
          for (i = 0; i < r.length; i++) (n = r[i]), (o += (s = t.substr(o, t.indexOf(n, o) - o)).length + n.length), 3 === (n = ft(n, e)).length && n.push(1), (a += s + (e ? 'hsla(' + n[0] + ',' + n[1] + '%,' + n[2] + '%,' + n[3] : 'rgba(' + n.join(',')) + ')')
          return a + t.substr(o)
        }
        var E,
          v,
          _,
          z,
          y,
          w,
          O,
          M,
          L = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
          R = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
          x = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
          I = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
          F = /(?:\d|\-|\+|=|#|\.)*/g,
          N = /opacity *= *([^)]*)/i,
          X = /opacity:([^;]*)/i,
          s = /alpha\(opacity *=.+?\)/i,
          j = /^(rgb|hsl)/,
          B = /([A-Z])/g,
          U = /-([a-z])/gi,
          W = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
          Y = /(?:Left|Right|Width)/i,
          q = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
          H = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
          Z = /,(?=[^\)]*(?:\(|$))/gi,
          V = /[\s,\(]/i,
          G = Math.PI / 180,
          Q = 180 / Math.PI,
          $ = {},
          e = { style: {} },
          K = _gsScope.document || {
            createElement: function () {
              return e
            },
          },
          J = a('div'),
          tt = a('img'),
          n = (D._internals = { _specialProps: f }),
          et = (_gsScope.navigator || {}).userAgent || '',
          it =
            ((Ot = et.indexOf('Android')),
            (Et = a('a')),
            (_ = -1 !== et.indexOf('Safari') && -1 === et.indexOf('Chrome') && (-1 === Ot || 3 < parseFloat(et.substr(Ot + 8, 2)))),
            (y = _ && parseFloat(et.substr(et.indexOf('Version/') + 8, 2)) < 6),
            (z = -1 !== et.indexOf('Firefox')),
            (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(et) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(et)) && (w = parseFloat(RegExp.$1)),
            !!Et && ((Et.style.cssText = 'top:1px;opacity:.55;'), /^0.55/.test(Et.style.opacity))),
          nt = '',
          st = '',
          rt = K.defaultView ? K.defaultView.getComputedStyle : function () {},
          ot = (D.getStyle = function (t, e, i, n, s) {
            var r
            return it || 'opacity' !== e
              ? (!n && t.style[e] ? (r = t.style[e]) : (i = i || rt(t)) ? (r = i[e] || i.getPropertyValue(e) || i.getPropertyValue(e.replace(B, '-$1').toLowerCase())) : t.currentStyle && (r = t.currentStyle[e]), null == s || (r && 'none' !== r && 'auto' !== r && 'auto auto' !== r) ? r : s)
              : l(t)
          }),
          at = (n.convertToPixels = function (t, e, i, n, s) {
            if ('px' === n || (!n && 'lineHeight' !== e)) return i
            if ('auto' === n || !i) return 0
            var r,
              o,
              a,
              l = Y.test(e),
              h = t,
              c = J.style,
              u = i < 0,
              d = 1 === i
            if ((u && (i = -i), d && (i *= 100), 'lineHeight' !== e || n))
              if ('%' === n && -1 !== e.indexOf('border')) r = (i / 100) * (l ? t.clientWidth : t.clientHeight)
              else {
                if (((c.cssText = 'border:0 solid red;position:' + ot(t, 'position') + ';line-height:0;'), '%' !== n && h.appendChild && 'v' !== n.charAt(0) && 'rem' !== n)) c[l ? 'borderLeftWidth' : 'borderTopWidth'] = i + n
                else {
                  if (((h = t.parentNode || K.body), -1 !== ot(h, 'display').indexOf('flex') && (c.position = 'absolute'), (o = h._gsCache), (a = A.ticker.frame), o && l && o.time === a)) return (o.width * i) / 100
                  c[l ? 'width' : 'height'] = i + n
                }
                h.appendChild(J), (r = parseFloat(J[l ? 'offsetWidth' : 'offsetHeight'])), h.removeChild(J), l && '%' === n && !1 !== D.cacheWidths && (((o = h._gsCache = h._gsCache || {}).time = a), (o.width = (r / i) * 100)), 0 !== r || s || (r = at(t, e, i, n, !0))
              }
            else (o = rt(t).lineHeight), (t.style.lineHeight = i), (r = parseFloat(rt(t).lineHeight)), (t.style.lineHeight = o)
            return d && (r /= 100), u ? -r : r
          }),
          lt = (n.calculateOffset = function (t, e, i) {
            if ('absolute' !== ot(t, 'position', i)) return 0
            var n = 'left' === e ? 'Left' : 'Top',
              i = ot(t, 'margin' + n, i)
            return t['offset' + n] - (at(t, e, parseFloat(i), i.replace(F, '')) || 0)
          }),
          ht = { width: ['Left', 'Right'], height: ['Top', 'Bottom'] },
          ct = ['marginLeft', 'marginRight', 'marginTop', 'marginBottom'],
          ut = function (t, e) {
            if ('contain' === t || 'auto' === t || 'auto auto' === t) return t + ' '
            ;(null != t && '' !== t) || (t = '0 0')
            var i,
              n = t.split(' '),
              s = -1 !== t.indexOf('left') ? '0%' : -1 !== t.indexOf('right') ? '100%' : n[0],
              r = -1 !== t.indexOf('top') ? '0%' : -1 !== t.indexOf('bottom') ? '100%' : n[1]
            if (3 < n.length && !e) {
              for (n = t.split(', ').join(',').split(','), t = [], i = 0; i < n.length; i++) t.push(ut(n[i]))
              return t.join(',')
            }
            return (
              null == r ? (r = 'center' === s ? '50%' : '0') : 'center' === r && (r = '50%'),
              ('center' === s || (isNaN(parseFloat(s)) && -1 === (s + '').indexOf('='))) && (s = '50%'),
              (t = s + ' ' + r + (2 < n.length ? ' ' + n[2] : '')),
              e && ((e.oxp = -1 !== s.indexOf('%')), (e.oyp = -1 !== r.indexOf('%')), (e.oxr = '=' === s.charAt(1)), (e.oyr = '=' === r.charAt(1)), (e.ox = parseFloat(s.replace(I, ''))), (e.oy = parseFloat(r.replace(I, ''))), (e.v = t)),
              e || t
            )
          },
          dt = {
            aqua: [0, 255, 255],
            lime: [0, 255, 0],
            silver: [192, 192, 192],
            black: [0, 0, 0],
            maroon: [128, 0, 0],
            teal: [0, 128, 128],
            blue: [0, 0, 255],
            navy: [0, 0, 128],
            white: [255, 255, 255],
            fuchsia: [255, 0, 255],
            olive: [128, 128, 0],
            yellow: [255, 255, 0],
            orange: [255, 165, 0],
            gray: [128, 128, 128],
            purple: [128, 0, 128],
            green: [0, 128, 0],
            red: [255, 0, 0],
            pink: [255, 192, 203],
            cyan: [0, 255, 255],
            transparent: [255, 255, 255, 0],
          },
          ft = (D.parseColor = function (t, e) {
            var i, n, s, r, o, a, l, h
            if (t)
              if ('number' == typeof t) i = [t >> 16, (t >> 8) & 255, 255 & t]
              else {
                if ((',' === t.charAt(t.length - 1) && (t = t.substr(0, t.length - 1)), dt[t])) i = dt[t]
                else if ('#' === t.charAt(0)) 4 === t.length && (t = '#' + (n = t.charAt(1)) + n + (s = t.charAt(2)) + s + (r = t.charAt(3)) + r), (i = [(t = parseInt(t.substr(1), 16)) >> 16, (t >> 8) & 255, 255 & t])
                else if ('hsl' === t.substr(0, 3))
                  if (((i = h = t.match(L)), e)) {
                    if (-1 !== t.indexOf('=')) return t.match(R)
                  } else (o = (Number(i[0]) % 360) / 360), (a = Number(i[1]) / 100), (n = 2 * (l = Number(i[2]) / 100) - (s = l <= 0.5 ? l * (a + 1) : l + a - l * a)), 3 < i.length && (i[3] = Number(i[3])), (i[0] = c(o + 1 / 3, n, s)), (i[1] = c(o, n, s)), (i[2] = c(o - 1 / 3, n, s))
                else i = t.match(L) || dt.transparent
                ;(i[0] = Number(i[0])), (i[1] = Number(i[1])), (i[2] = Number(i[2])), 3 < i.length && (i[3] = Number(i[3]))
              }
            else i = dt.black
            return (
              e &&
                !h &&
                ((n = i[0] / 255),
                (s = i[1] / 255),
                (r = i[2] / 255),
                (l = ((t = Math.max(n, s, r)) + (e = Math.min(n, s, r))) / 2),
                t === e ? (o = a = 0) : ((h = t - e), (a = 0.5 < l ? h / (2 - t - e) : h / (t + e)), (o = t === n ? (s - r) / h + (s < r ? 6 : 0) : t === s ? (r - n) / h + 2 : (n - s) / h + 4), (o *= 60)),
                (i[0] = (o + 0.5) | 0),
                (i[1] = (100 * a + 0.5) | 0),
                (i[2] = (100 * l + 0.5) | 0)),
              i
            )
          }),
          pt = '(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b'
        for (t in dt) pt += '|' + t + '\\b'
        ;(pt = new RegExp(pt + ')', 'gi')),
          (D.colorStringFilter = function (t) {
            var e = t[0] + ' ' + t[1]
            pt.test(e) && ((e = -1 !== e.indexOf('hsl(') || -1 !== e.indexOf('hsla(')), (t[0] = i(t[0], e)), (t[1] = i(t[1], e))), (pt.lastIndex = 0)
          }),
          A.defaultStringFilter || (A.defaultStringFilter = D.colorStringFilter)
        function mt(t, e, r, o) {
          if (null == t)
            return function (t) {
              return t
            }
          var a,
            l = e ? (t.match(pt) || [''])[0] : '',
            h = t.split(l).join('').match(x) || [],
            c = t.substr(0, t.indexOf(h[0])),
            u = ')' === t.charAt(t.length - 1) ? ')' : '',
            d = -1 !== t.indexOf(' ') ? ' ' : ',',
            f = h.length,
            p = 0 < f ? h[0].replace(L, '') : ''
          return f
            ? (a = e
                ? function (t) {
                    var e, i, n, s
                    if ('number' == typeof t) t += p
                    else if (o && Z.test(t)) {
                      for (s = t.replace(Z, '|').split('|'), n = 0; n < s.length; n++) s[n] = a(s[n])
                      return s.join(',')
                    }
                    if (((e = (t.match(pt) || [l])[0]), (n = (i = t.split(e).join('').match(x) || []).length), f > n--)) for (; ++n < f; ) i[n] = r ? i[((n - 1) / 2) | 0] : h[n]
                    return c + i.join(d) + d + e + u + (-1 !== t.indexOf('inset') ? ' inset' : '')
                  }
                : function (t) {
                    var e, i, n
                    if ('number' == typeof t) t += p
                    else if (o && Z.test(t)) {
                      for (i = t.replace(Z, '|').split('|'), n = 0; n < i.length; n++) i[n] = a(i[n])
                      return i.join(',')
                    }
                    if (((n = (e = t.match(x) || []).length), f > n--)) for (; ++n < f; ) e[n] = r ? e[((n - 1) / 2) | 0] : h[n]
                    return c + e.join(d) + u
                  })
            : function (t) {
                return t
              }
        }
        function gt(h) {
          return (
            (h = h.split(',')),
            function (t, e, i, n, s, r, o) {
              var a,
                l = (e + '').split(' ')
              for (o = {}, a = 0; a < 4; a++) o[h[a]] = l[a] = l[a] || l[((a - 1) / 2) >> 0]
              return n.parse(t, o, s, r)
            }
          )
        }
        function vt(t, e, i, n, s, r) {
          return ((r = new yt(t, e, i, n - i, s, -1, r)).b = i), (r.e = r.xs0 = n), r
        }
        var _t =
            ((n._setPluginRatio = function (t) {
              this.plugin.setRatio(t)
              for (var e, i, n, s, r, o = this.data, a = o.proxy, l = o.firstMPT; l; ) (e = a[l.v]), l.r ? (e = Math.round(e)) : e < 1e-6 && -1e-6 < e && (e = 0), (l.t[l.p] = e), (l = l._next)
              if ((o.autoRotate && (o.autoRotate.rotation = o.mod ? o.mod(a.rotation, this.t) : a.rotation), 1 === t || 0 === t))
                for (l = o.firstMPT, r = 1 === t ? 'e' : 'b'; l; ) {
                  if ((i = l.t).type) {
                    if (1 === i.type) {
                      for (s = i.xs0 + i.s + i.xs1, n = 1; n < i.l; n++) s += i['xn' + n] + i['xs' + (n + 1)]
                      i[r] = s
                    }
                  } else i[r] = i.s + i.xs0
                  l = l._next
                }
            }),
            function (t, e, i, n, s) {
              ;(this.t = t), (this.p = e), (this.v = i), (this.r = s), n && ((n._prev = this)._next = n)
            }),
          yt =
            ((n._parseToProxy = function (t, e, i, n, s, r) {
              var o,
                a,
                l,
                h,
                c = n,
                u = {},
                d = {},
                f = i._transform,
                p = $
              for (i._transform = null, $ = e, n = s = i.parse(t, e, n, s), $ = p, r && ((i._transform = f), c && ((c._prev = null), c._prev && (c._prev._next = null))); n && n !== c; ) {
                if (n.type <= 1 && ((d[(a = n.p)] = n.s + n.c), (u[a] = n.s), r || ((h = new _t(n, 's', a, h, n.r)), (n.c = 0)), 1 === n.type)) for (o = n.l; 0 < --o; ) (l = 'xn' + o), (d[(a = n.p + '_' + l)] = n.data[l]), (u[a] = n[l]), r || (h = new _t(n, l, a, h, n.rxp[l]))
                n = n._next
              }
              return { proxy: u, end: d, firstMPT: h, pt: s }
            }),
            (n.CSSPropTween = function (t, e, i, n, s, r, o, a, l, h, c) {
              ;(this.t = t), (this.p = e), (this.s = i), (this.c = n), (this.n = o || e), t instanceof yt || u.push(this.n), (this.r = a), (this.type = r || 0), l && ((this.pr = l), (d = !0)), (this.b = void 0 === h ? i : h), (this.e = void 0 === c ? i + n : c), s && ((this._next = s)._prev = this)
            })),
          xt = (D.parseComplex = function (t, e, i, n, s, r, o, a, l, h) {
            ;(i = i || r || ''), 'function' == typeof n && (n = n(M, O)), (o = new yt(t, e, 0, 0, o, h ? 2 : 1, null, !1, a, i, n)), (n += ''), s && pt.test(n + i) && ((n = [i, n]), D.colorStringFilter(n), (i = n[0]), (n = n[1]))
            var c,
              u,
              d,
              f,
              p,
              m,
              g,
              v,
              _,
              y,
              x,
              w,
              b = i.split(', ').join(',').split(' '),
              T = n.split(', ').join(',').split(' '),
              S = b.length,
              P = !1 !== E
            for (
              (-1 === n.indexOf(',') && -1 === i.indexOf(',')) ||
                ((T = -1 !== (n + i).indexOf('rgb') || -1 !== (n + i).indexOf('hsl') ? ((b = b.join(' ').replace(Z, ', ').split(' ')), T.join(' ').replace(Z, ', ').split(' ')) : ((b = b.join(' ').split(',').join(', ').split(' ')), T.join(' ').split(',').join(', ').split(' '))), (S = b.length)),
                S !== T.length && (S = (b = (r || '').split(' ')).length),
                o.plugin = l,
                o.setRatio = h,
                c = pt.lastIndex = 0;
              c < S;
              c++
            )
              if (((f = b[c]), (p = T[c]), (v = parseFloat(f)) || 0 === v)) o.appendXtra('', v, C(p, v), p.replace(R, ''), P && -1 !== p.indexOf('px'), !0)
              else if (s && pt.test(f))
                (x = ')' + ((x = p.indexOf(')') + 1) ? p.substr(x) : '')),
                  (w = -1 !== p.indexOf('hsl') && it),
                  (_ = p),
                  (f = ft(f, w)),
                  (p = ft(p, w)),
                  (v = 6 < f.length + p.length) && !it && 0 === p[3]
                    ? ((o['xs' + o.l] += o.l ? ' transparent' : 'transparent'), (o.e = o.e.split(T[c]).join('transparent')))
                    : (it || (v = !1),
                      w
                        ? o
                            .appendXtra(_.substr(0, _.indexOf('hsl')) + (v ? 'hsla(' : 'hsl('), f[0], C(p[0], f[0]), ',', !1, !0)
                            .appendXtra('', f[1], C(p[1], f[1]), '%,', !1)
                            .appendXtra('', f[2], C(p[2], f[2]), v ? '%,' : '%' + x, !1)
                        : o
                            .appendXtra(_.substr(0, _.indexOf('rgb')) + (v ? 'rgba(' : 'rgb('), f[0], p[0] - f[0], ',', !0, !0)
                            .appendXtra('', f[1], p[1] - f[1], ',', !0)
                            .appendXtra('', f[2], p[2] - f[2], v ? ',' : x, !0),
                      v && ((f = f.length < 4 ? 1 : f[3]), o.appendXtra('', f, (p.length < 4 ? 1 : p[3]) - f, x, !1))),
                  (pt.lastIndex = 0)
              else if ((m = f.match(L))) {
                if (!(g = p.match(R)) || g.length !== m.length) return o
                for (u = d = 0; u < m.length; u++) (y = m[u]), (_ = f.indexOf(y, d)), o.appendXtra(f.substr(d, _ - d), Number(y), C(g[u], y), '', P && 'px' === f.substr(_ + y.length, 2), 0 === u), (d = _ + y.length)
                o['xs' + o.l] += f.substr(d)
              } else o['xs' + o.l] += o.l || o['xs' + o.l] ? ' ' + p : p
            if (-1 !== n.indexOf('=') && o.data) {
              for (x = o.xs0 + o.data.s, c = 1; c < o.l; c++) x += o['xs' + c] + o.data['xn' + c]
              o.e = x + o['xs' + c]
            }
            return o.l || ((o.type = -1), (o.xs0 = o.e)), o.xfirst || o
          }),
          wt = 9
        for ((t = yt.prototype).l = t.pr = 0; 0 < --wt; ) (t['xn' + wt] = 0), (t['xs' + wt] = '')
        ;(t.xs0 = ''),
          (t._next = t._prev = t.xfirst = t.data = t.plugin = t.setRatio = t.rxp = null),
          (t.appendXtra = function (t, e, i, n, s, r) {
            var o = this,
              a = o.l
            return (
              (o['xs' + a] += r && (a || o['xs' + a]) ? ' ' + t : t || ''),
              i || 0 === a || o.plugin
                ? (o.l++,
                  (o.type = o.setRatio ? 2 : 1),
                  (o['xs' + o.l] = n || ''),
                  0 < a ? ((o.data['xn' + a] = e + i), (o.rxp['xn' + a] = s), (o['xn' + a] = e), o.plugin || ((o.xfirst = new yt(o, 'xn' + a, e, i, o.xfirst || o, 0, o.n, s, o.pr)), (o.xfirst.xs0 = 0))) : ((o.data = { s: e + i }), (o.rxp = {}), (o.s = e), (o.c = i), (o.r = s)))
                : (o['xs' + a] += e + (n || '')),
              o
            )
          })
        function bt(t, e) {
          ;(e = e || {}),
            (this.p = (e.prefix && T(t)) || t),
            ((f[t] = f[this.p] = this).format = e.formatter || mt(e.defaultValue, e.color, e.collapsible, e.multi)),
            e.parser && (this.parse = e.parser),
            (this.clrs = e.color),
            (this.multi = e.multi),
            (this.keyword = e.keyword),
            (this.dflt = e.defaultValue),
            (this.pr = e.priority || 0)
        }
        var Tt = (n._registerComplexSpecialProp = function (t, e, i) {
            'object' != typeof e && (e = { parser: i })
            var n,
              s = t.split(','),
              r = e.defaultValue
            for (i = i || [r], n = 0; n < s.length; n++) (e.prefix = 0 === n && e.prefix), (e.defaultValue = i[n] || r), new bt(s[n], e)
          }),
          St = (n._registerPluginProp = function (t) {
            var l
            f[t] ||
              ((l = t.charAt(0).toUpperCase() + t.substr(1) + 'Plugin'),
              Tt(t, {
                parser: function (t, e, i, n, s, r, o) {
                  var a = h.com.greensock.plugins[l]
                  return a ? (a._cssRegister(), f[i].parse(t, e, i, n, s, r, o)) : (p('Error: ' + l + ' js file not loaded.'), s)
                },
              }))
          })
        ;((t = bt.prototype).parseComplex = function (t, e, i, n, s, r) {
          var o,
            a,
            l,
            h,
            c,
            u,
            d = this.keyword
          if ((this.multi && (Z.test(i) || Z.test(e) ? ((a = e.replace(Z, '|').split('|')), (l = i.replace(Z, '|').split('|'))) : d && ((a = [e]), (l = [i]))), l)) {
            for (h = (l.length > a.length ? l : a).length, o = 0; o < h; o++) (e = a[o] = a[o] || this.dflt), (i = l[o] = l[o] || this.dflt), d && (c = e.indexOf(d)) !== (u = i.indexOf(d)) && (-1 === u ? (a[o] = a[o].split(d).join('')) : -1 === c && (a[o] += ' ' + d))
            ;(e = a.join(', ')), (i = l.join(', '))
          }
          return xt(t, this.p, e, i, this.clrs, this.dflt, n, this.pr, s, r)
        }),
          (t.parse = function (t, e, i, n, s, r, o) {
            return this.parseComplex(t.style, this.format(ot(t, this.p, S, !1, this.dflt)), this.format(e), s, r)
          }),
          (D.registerSpecialProp = function (t, a, l) {
            Tt(t, {
              parser: function (t, e, i, n, s, r, o) {
                s = new yt(t, i, 0, 0, s, 2, i, !1, l)
                return (s.plugin = r), (s.setRatio = a(t, e, n._tween, i)), s
              },
              priority: l,
            })
          }),
          (D.useSVGTransformAttr = !0)
        function Pt(t, e, i, n, s, r) {
          var o,
            a,
            l,
            h,
            c,
            u,
            d,
            f,
            p,
            m,
            g,
            v,
            _ = t._gsTransform,
            y = Wt(t, !0)
          _ && ((g = _.xOrigin), (v = _.yOrigin)),
            (!n || (o = n.split(' ')).length < 2) &&
              (0 === (d = t.getBBox()).x &&
                0 === d.y &&
                d.width + d.height === 0 &&
                (d = { x: parseFloat(t.hasAttribute('x') ? t.getAttribute('x') : t.hasAttribute('cx') ? t.getAttribute('cx') : 0) || 0, y: parseFloat(t.hasAttribute('y') ? t.getAttribute('y') : t.hasAttribute('cy') ? t.getAttribute('cy') : 0) || 0, width: 0, height: 0 }),
              (o = [(-1 !== (e = ut(e).split(' '))[0].indexOf('%') ? (parseFloat(e[0]) / 100) * d.width : parseFloat(e[0])) + d.x, (-1 !== e[1].indexOf('%') ? (parseFloat(e[1]) / 100) * d.height : parseFloat(e[1])) + d.y])),
            (i.xOrigin = h = parseFloat(o[0])),
            (i.yOrigin = c = parseFloat(o[1])),
            n && y !== Ut && ((u = y[0]), (d = y[1]), (f = y[2]), (p = y[3]), (m = y[4]), (e = y[5]), (n = u * p - d * f) && ((a = h * (p / n) + c * (-f / n) + (f * e - p * m) / n), (l = h * (-d / n) + c * (u / n) - (u * e - d * m) / n), (h = i.xOrigin = o[0] = a), (c = i.yOrigin = o[1] = l))),
            _ && (r && ((i.xOffset = _.xOffset), (i.yOffset = _.yOffset), (_ = i)), s || (!1 !== s && !1 !== D.defaultSmoothOrigin) ? ((a = h - g), (l = c - v), (_.xOffset += a * y[0] + l * y[2] - a), (_.yOffset += a * y[1] + l * y[3] - l)) : (_.xOffset = _.yOffset = 0)),
            r || t.setAttribute('data-svg-origin', o.join(' '))
        }
        function Ct(t) {
          var e,
            i,
            n = this.data,
            s = (m = -n.rotation * G) + n.skewX * G,
            r = 1e5,
            o = ((Math.cos(m) * n.scaleX * r) | 0) / r,
            a = ((Math.sin(m) * n.scaleX * r) | 0) / r,
            l = ((Math.sin(s) * -n.scaleY * r) | 0) / r,
            h = ((Math.cos(s) * n.scaleY * r) | 0) / r,
            c = this.t.style,
            u = this.t.currentStyle
          if (u) {
            ;(i = a), (a = -l), (l = -i), (e = u.filter), (c.filter = '')
            var d = this.t.offsetWidth,
              f = this.t.offsetHeight,
              p = 'absolute' !== u.position,
              m = 'progid:DXImageTransform.Microsoft.Matrix(M11=' + o + ', M12=' + a + ', M21=' + l + ', M22=' + h,
              s = n.x + (d * n.xPercent) / 100,
              r = n.y + (f * n.yPercent) / 100
            if (
              (null != n.ox && ((s += (y = (n.oxp ? d * n.ox * 0.01 : n.ox) - d / 2) - (y * o + (x = (n.oyp ? f * n.oy * 0.01 : n.oy) - f / 2) * a)), (r += x - (y * l + x * h))),
              p ? (m += ', Dx=' + ((y = d / 2) - (y * o + (x = f / 2) * a) + s) + ', Dy=' + (x - (y * l + x * h) + r) + ')') : (m += ", sizingMethod='auto expand')"),
              -1 !== e.indexOf('DXImageTransform.Microsoft.Matrix(') ? (c.filter = e.replace(H, m)) : (c.filter = m + ' ' + e),
              (0 !== t && 1 !== t) || (1 == o && 0 == a && 0 == l && 1 == h && ((p && -1 === m.indexOf('Dx=0, Dy=0')) || (N.test(e) && 100 !== parseFloat(RegExp.$1)) || (-1 === e.indexOf(e.indexOf('Alpha')) && c.removeAttribute('filter')))),
              !p)
            ) {
              var g,
                v,
                _ = w < 8 ? 1 : -1,
                y = n.ieOffsetX || 0,
                x = n.ieOffsetY || 0
              for (n.ieOffsetX = Math.round((d - ((o < 0 ? -o : o) * d + (a < 0 ? -a : a) * f)) / 2 + s), n.ieOffsetY = Math.round((f - ((h < 0 ? -h : h) * f + (l < 0 ? -l : l) * d)) / 2 + r), wt = 0; wt < 4; wt++)
                (v = (i = -1 !== (v = u[(g = ct[wt])]).indexOf('px') ? parseFloat(v) : at(this.t, g, parseFloat(v), v.replace(F, '')) || 0) !== n[g] ? (wt < 2 ? -n.ieOffsetX : -n.ieOffsetY) : wt < 2 ? y - n.ieOffsetX : x - n.ieOffsetY),
                  (c[g] = (n[g] = Math.round(i - v * (0 === wt || 2 === wt ? 1 : _))) + 'px')
            }
          }
        }
        var kt,
          Et,
          Ot,
          At = 'scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent'.split(','),
          Dt = T('transform'),
          Mt = nt + 'transform',
          zt = T('transformOrigin'),
          Lt = null !== T('perspective'),
          Rt = (n.Transform = function () {
            ;(this.perspective = parseFloat(D.defaultTransformPerspective) || 0), (this.force3D = !(!1 === D.defaultForce3D || !Lt) && (D.defaultForce3D || 'auto'))
          }),
          It = _gsScope.SVGElement,
          Ft = function (t, e, i) {
            var n,
              s = K.createElementNS('http://www.w3.org/2000/svg', t),
              r = /([a-z])([A-Z])/g
            for (n in i) s.setAttributeNS(null, n.replace(r, '$1-$2').toLowerCase(), i[n])
            return e.appendChild(s), s
          },
          Nt = K.documentElement || {},
          Xt =
            ((Ot = w || (/Android/i.test(et) && !_gsScope.chrome)),
            K.createElementNS &&
              !Ot &&
              ((Et = Ft('svg', Nt)), (Ft = (et = Ft('rect', Et, { width: 100, height: 50, x: 100 })).getBoundingClientRect().width), (et.style[zt] = '50% 50%'), (et.style[Dt] = 'scaleX(0.5)'), (Ot = Ft === et.getBoundingClientRect().width && !(z && Lt)), Nt.removeChild(Et)),
            Ot),
          jt = function (t) {
            var e,
              i = a('svg', (this.ownerSVGElement && this.ownerSVGElement.getAttribute('xmlns')) || 'http://www.w3.org/2000/svg'),
              n = this.parentNode,
              s = this.nextSibling,
              r = this.style.cssText
            if ((Nt.appendChild(i), i.appendChild(this), (this.style.display = 'block'), t))
              try {
                ;(e = this.getBBox()), (this._originalGetBBox = this.getBBox), (this.getBBox = jt)
              } catch (t) {}
            else this._originalGetBBox && (e = this._originalGetBBox())
            return s ? n.insertBefore(this, s) : n.appendChild(this), Nt.removeChild(i), (this.style.cssText = r), e
          },
          Bt = function (t) {
            return !(
              !It ||
              !t.getCTM ||
              (t.parentNode && !t.ownerSVGElement) ||
              !(function (e) {
                try {
                  return e.getBBox()
                } catch (t) {
                  return jt.call(e, !0)
                }
              })(t)
            )
          },
          Ut = [1, 0, 0, 1, 0, 0],
          Wt = function (t, e) {
            var i,
              n,
              s,
              r,
              o,
              a,
              l = t._gsTransform || new Rt(),
              h = t.style
            if (
              (Dt ? (n = ot(t, Mt, null, !0)) : t.currentStyle && (n = (n = t.currentStyle.filter.match(q)) && 4 === n.length ? [n[0].substr(4), Number(n[2].substr(4)), Number(n[1].substr(4)), n[3].substr(4), l.x || 0, l.y || 0].join(',') : ''),
              (i = !n || 'none' === n || 'matrix(1, 0, 0, 1, 0, 0)' === n),
              !Dt ||
                (!(a = !rt(t) || 'none' === rt(t).display) && t.parentNode) ||
                (a && ((r = h.display), (h.display = 'block')), t.parentNode || ((o = 1), Nt.appendChild(t)), (i = !(n = ot(t, Mt, null, !0)) || 'none' === n || 'matrix(1, 0, 0, 1, 0, 0)' === n), r ? (h.display = r) : a && Vt(h, 'display'), o && Nt.removeChild(t)),
              (l.svg || (t.getCTM && Bt(t))) &&
                (i && -1 !== (h[Dt] + '').indexOf('matrix') && ((n = h[Dt]), (i = 0)),
                (s = t.getAttribute('transform')),
                i && s && (-1 !== s.indexOf('matrix') ? ((n = s), (i = 0)) : -1 !== s.indexOf('translate') && ((n = 'matrix(1,0,0,1,' + s.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(',') + ')'), (i = 0)))),
              i)
            )
              return Ut
            for (s = (n || '').match(L) || [], wt = s.length; -1 < --wt; ) (r = Number(s[wt])), (s[wt] = (o = r - (r |= 0)) ? ((1e5 * o + (o < 0 ? -0.5 : 0.5)) | 0) / 1e5 + r : r)
            return e && 6 < s.length ? [s[0], s[1], s[4], s[5], s[12], s[13]] : s
          },
          Yt = (n.getTransform = function (t, e, i, n) {
            if (t._gsTransform && i && !n) return t._gsTransform
            var s,
              r,
              o,
              a,
              l,
              h,
              c,
              u,
              d,
              f,
              p,
              m,
              g,
              v,
              _,
              y,
              x,
              w,
              b,
              T,
              S,
              P,
              C = (i && t._gsTransform) || new Rt(),
              k = C.scaleX < 0,
              E = (Lt && (parseFloat(ot(t, zt, e, !1, '0 0 0').split(' ')[2]) || C.zOrigin)) || 0,
              O = parseFloat(D.defaultTransformPerspective) || 0
            if (((C.svg = !(!t.getCTM || !Bt(t))), C.svg && (Pt(t, ot(t, zt, e, !1, '50% 50%') + '', C, t.getAttribute('data-svg-origin')), (kt = D.useSVGTransformAttr || Xt)), (r = Wt(t)), r !== Ut))
              for (s in (16 === r.length
                ? ((T = r[0]),
                  (P = r[1]),
                  (u = r[2]),
                  (d = r[3]),
                  (S = r[4]),
                  (f = r[5]),
                  (p = r[6]),
                  (m = r[7]),
                  (g = r[8]),
                  (v = r[9]),
                  (_ = r[10]),
                  (y = r[12]),
                  (w = r[13]),
                  (b = r[14]),
                  (x = r[11]),
                  (e = Math.atan2(p, _)),
                  C.zOrigin && ((y = g * (b = -C.zOrigin) - r[12]), (w = v * b - r[13]), (b = _ * b + C.zOrigin - r[14])),
                  (C.rotationX = e * Q),
                  e && ((o = S * (h = Math.cos(-e)) + g * (c = Math.sin(-e))), (a = f * h + v * c), (l = p * h + _ * c), (g = S * -c + g * h), (v = f * -c + v * h), (_ = p * -c + _ * h), (x = m * -c + x * h), (S = o), (f = a), (p = l)),
                  (e = Math.atan2(-u, _)),
                  (C.rotationY = e * Q),
                  e && ((a = P * (h = Math.cos(-e)) - v * (c = Math.sin(-e))), (l = u * h - _ * c), (v = P * c + v * h), (_ = u * c + _ * h), (x = d * c + x * h), (T = o = T * h - g * c), (P = a), (u = l)),
                  (e = Math.atan2(P, T)),
                  (C.rotation = e * Q),
                  e && ((o = T * (h = Math.cos(e)) + P * (c = Math.sin(e))), (a = S * h + f * c), (l = g * h + v * c), (P = P * h - T * c), (f = f * h - S * c), (v = v * h - g * c), (T = o), (S = a), (g = l)),
                  C.rotationX && 359.9 < Math.abs(C.rotationX) + Math.abs(C.rotation) && ((C.rotationX = C.rotation = 0), (C.rotationY = 180 - C.rotationY)),
                  (e = Math.atan2(S, f)),
                  (C.scaleX = ((1e5 * Math.sqrt(T * T + P * P + u * u) + 0.5) | 0) / 1e5),
                  (C.scaleY = ((1e5 * Math.sqrt(f * f + p * p) + 0.5) | 0) / 1e5),
                  (C.scaleZ = ((1e5 * Math.sqrt(g * g + v * v + _ * _) + 0.5) | 0) / 1e5),
                  (T /= C.scaleX),
                  (S /= C.scaleY),
                  (P /= C.scaleX),
                  (f /= C.scaleY),
                  2e-5 < Math.abs(e) ? ((C.skewX = e * Q), (S = 0), 'simple' !== C.skewType && (C.scaleY *= 1 / Math.cos(e))) : (C.skewX = 0),
                  (C.perspective = x ? 1 / (x < 0 ? -x : x) : 0),
                  (C.x = y),
                  (C.y = w),
                  (C.z = b),
                  C.svg && ((C.x -= C.xOrigin - (C.xOrigin * T - C.yOrigin * S)), (C.y -= C.yOrigin - (C.yOrigin * P - C.xOrigin * f))))
                : (Lt && !n && r.length && C.x === r[4] && C.y === r[5] && (C.rotationX || C.rotationY)) ||
                  ((b = (w = 6 <= r.length) ? r[0] : 1),
                  (T = r[1] || 0),
                  (S = r[2] || 0),
                  (P = w ? r[3] : 1),
                  (C.x = r[4] || 0),
                  (C.y = r[5] || 0),
                  (f = Math.sqrt(b * b + T * T)),
                  (n = Math.sqrt(P * P + S * S)),
                  (w = b || T ? Math.atan2(T, b) * Q : C.rotation || 0),
                  (r = S || P ? Math.atan2(S, P) * Q + w : C.skewX || 0),
                  (C.scaleX = f),
                  (C.scaleY = n),
                  (C.rotation = w),
                  (C.skewX = r),
                  Lt && ((C.rotationX = C.rotationY = C.z = 0), (C.perspective = O), (C.scaleZ = 1)),
                  C.svg && ((C.x -= C.xOrigin - (C.xOrigin * b + C.yOrigin * S)), (C.y -= C.yOrigin - (C.xOrigin * T + C.yOrigin * P)))),
              90 < Math.abs(C.skewX) && Math.abs(C.skewX) < 270 && (k ? ((C.scaleX *= -1), (C.skewX += C.rotation <= 0 ? 180 : -180), (C.rotation += C.rotation <= 0 ? 180 : -180)) : ((C.scaleY *= -1), (C.skewX += C.skewX <= 0 ? 180 : -180))),
              (C.zOrigin = E),
              C))
                C[s] < 2e-5 && -2e-5 < C[s] && (C[s] = 0)
            return (
              i &&
                (t._gsTransform = C).svg &&
                (kt && t.style[Dt]
                  ? A.delayedCall(0.001, function () {
                      Vt(t.style, Dt)
                    })
                  : !kt &&
                    t.getAttribute('transform') &&
                    A.delayedCall(0.001, function () {
                      t.removeAttribute('transform')
                    })),
              C
            )
          }),
          qt =
            (n.set3DTransformRatio =
            n.setTransformRatio =
              function (t) {
                var e,
                  i,
                  n,
                  s,
                  r,
                  o,
                  a,
                  l,
                  h,
                  c,
                  u,
                  d,
                  f,
                  p,
                  m,
                  g,
                  v = this.data,
                  _ = this.t.style,
                  y = v.rotation,
                  x = v.rotationX,
                  w = v.rotationY,
                  b = v.scaleX,
                  T = v.scaleY,
                  S = v.scaleZ,
                  P = v.x,
                  C = v.y,
                  k = v.z,
                  E = v.svg,
                  O = v.perspective,
                  A = v.force3D,
                  D = v.skewY,
                  M = v.skewX
                if ((D && ((M += D), (y += D)), !((((1 !== t && 0 !== t) || 'auto' !== A || (this.tween._totalTime !== this.tween._totalDuration && this.tween._totalTime)) && A) || k || O || w || x || 1 !== S) || (kt && E) || !Lt))
                  y || M || E
                    ? ((y *= G),
                      (m = M * G),
                      (g = 1e5),
                      (i = Math.cos(y) * b),
                      (s = Math.sin(y) * b),
                      (n = Math.sin(y - m) * -T),
                      (r = Math.cos(y - m) * T),
                      m && 'simple' === v.skewType && ((e = Math.tan(m - D * G)), (n *= e = Math.sqrt(1 + e * e)), (r *= e), D && ((e = Math.tan(D * G)), (i *= e = Math.sqrt(1 + e * e)), (s *= e))),
                      E &&
                        ((P += v.xOrigin - (v.xOrigin * i + v.yOrigin * n) + v.xOffset),
                        (C += v.yOrigin - (v.xOrigin * s + v.yOrigin * r) + v.yOffset),
                        kt && (v.xPercent || v.yPercent) && ((u = this.t.getBBox()), (P += 0.01 * v.xPercent * u.width), (C += 0.01 * v.yPercent * u.height)),
                        P < (u = 1e-6) && -u < P && (P = 0),
                        C < u && -u < C && (C = 0)),
                      (p = ((i * g) | 0) / g + ',' + ((s * g) | 0) / g + ',' + ((n * g) | 0) / g + ',' + ((r * g) | 0) / g + ',' + P + ',' + C + ')'),
                      E && kt ? this.t.setAttribute('transform', 'matrix(' + p) : (_[Dt] = (v.xPercent || v.yPercent ? 'translate(' + v.xPercent + '%,' + v.yPercent + '%) matrix(' : 'matrix(') + p))
                    : (_[Dt] = (v.xPercent || v.yPercent ? 'translate(' + v.xPercent + '%,' + v.yPercent + '%) matrix(' : 'matrix(') + b + ',0,0,' + T + ',' + P + ',' + C + ')')
                else {
                  if ((z && (b < (u = 1e-4) && -u < b && (b = S = 2e-5), T < u && -u < T && (T = S = 2e-5), !O || v.z || v.rotationX || v.rotationY || (O = 0)), y || M))
                    (y *= G),
                      (d = i = Math.cos(y)),
                      (f = s = Math.sin(y)),
                      M && ((y -= M * G), (d = Math.cos(y)), (f = Math.sin(y)), 'simple' === v.skewType && ((e = Math.tan((M - D) * G)), (d *= e = Math.sqrt(1 + e * e)), (f *= e), v.skewY && ((e = Math.tan(D * G)), (i *= e = Math.sqrt(1 + e * e)), (s *= e)))),
                      (n = -f),
                      (r = d)
                  else {
                    if (!(w || x || 1 !== S || O || E)) return void (_[Dt] = (v.xPercent || v.yPercent ? 'translate(' + v.xPercent + '%,' + v.yPercent + '%) translate3d(' : 'translate3d(') + P + 'px,' + C + 'px,' + k + 'px)' + (1 !== b || 1 !== T ? ' scale(' + b + ',' + T + ')' : ''))
                    ;(i = r = 1), (n = s = 0)
                  }
                  ;(l = 1),
                    (A = t = o = a = h = c = 0),
                    (m = O ? -1 / O : 0),
                    (g = v.zOrigin),
                    (u = 1e-6),
                    (M = ','),
                    (D = '0'),
                    (y = w * G) && ((d = Math.cos(y)), (h = m * (o = -(f = Math.sin(y)))), (A = i * f), (t = s * f), (m *= l = d), (i *= d), (s *= d)),
                    (y = x * G) && ((e = n * (d = Math.cos(y)) + A * (f = Math.sin(y))), (y = r * d + t * f), (a = l * f), (c = m * f), (A = n * -f + A * d), (t = r * -f + t * d), (l *= d), (m *= d), (n = e), (r = y)),
                    1 !== S && ((A *= S), (t *= S), (l *= S), (m *= S)),
                    1 !== T && ((n *= T), (r *= T), (a *= T), (c *= T)),
                    1 !== b && ((i *= b), (s *= b), (o *= b), (h *= b)),
                    (g || E) &&
                      (g && ((P += A * -g), (C += t * -g), (k += l * -g + g)), E && ((P += v.xOrigin - (v.xOrigin * i + v.yOrigin * n) + v.xOffset), (C += v.yOrigin - (v.xOrigin * s + v.yOrigin * r) + v.yOffset)), P < u && -u < P && (P = D), C < u && -u < C && (C = D), k < u && -u < k && (k = 0)),
                    (p = v.xPercent || v.yPercent ? 'translate(' + v.xPercent + '%,' + v.yPercent + '%) matrix3d(' : 'matrix3d('),
                    (p += (i < u && -u < i ? D : i) + M + (s < u && -u < s ? D : s) + M + (o < u && -u < o ? D : o)),
                    (p += M + (h < u && -u < h ? D : h) + M + (n < u && -u < n ? D : n) + M + (r < u && -u < r ? D : r)),
                    x || w || 1 !== S ? ((p += M + (a < u && -u < a ? D : a) + M + (c < u && -u < c ? D : c) + M + (A < u && -u < A ? D : A)), (p += M + (t < u && -u < t ? D : t) + M + (l < u && -u < l ? D : l) + M + (m < u && -u < m ? D : m) + M)) : (p += ',0,0,0,0,1,0,'),
                    (p += P + M + C + M + k + M + (O ? 1 + -k / O : 1) + ')'),
                    (_[Dt] = p)
                }
              })
        ;((t = Rt.prototype).x = t.y = t.z = t.skewX = t.skewY = t.rotation = t.rotationX = t.rotationY = t.zOrigin = t.xPercent = t.yPercent = t.xOffset = t.yOffset = 0),
          (t.scaleX = t.scaleY = t.scaleZ = 1),
          Tt('transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin', {
            parser: function (t, e, i, n, s, r, o) {
              if (n._lastParsedTransform === o) return s
              var a,
                l = (n._lastParsedTransform = o).scale && 'function' == typeof o.scale ? o.scale : 0
              'function' == typeof o[i] && ((a = o[i]), (o[i] = e)), l && (o.scale = l(M, t))
              var h,
                c,
                u,
                d,
                f,
                p,
                m,
                g,
                v = t._gsTransform,
                _ = t.style,
                y = At.length,
                x = o,
                w = {},
                e = 'transformOrigin',
                b = Yt(t, S, !0, x.parseTransform),
                T = x.transform && ('function' == typeof x.transform ? x.transform(M, O) : x.transform)
              if (((b.skewType = x.skewType || b.skewType || D.defaultSkewType), (n._transform = b), T && 'string' == typeof T && Dt))
                ((c = J.style)[Dt] = T),
                  (c.display = 'block'),
                  (c.position = 'absolute'),
                  K.body.appendChild(J),
                  (h = Yt(J, null, !1)),
                  'simple' === b.skewType && (h.scaleY *= Math.cos(h.skewX * G)),
                  b.svg &&
                    ((f = b.xOrigin),
                    (p = b.yOrigin),
                    (h.x -= b.xOffset),
                    (h.y -= b.yOffset),
                    (x.transformOrigin || x.svgOrigin) && ((T = {}), Pt(t, ut(x.transformOrigin), T, x.svgOrigin, x.smoothOrigin, !0), (f = T.xOrigin), (p = T.yOrigin), (h.x -= T.xOffset - b.xOffset), (h.y -= T.yOffset - b.yOffset)),
                    (f || p) && ((m = Wt(J, !0)), (h.x -= f - (f * m[0] + p * m[2])), (h.y -= p - (f * m[1] + p * m[3])))),
                  K.body.removeChild(J),
                  h.perspective || (h.perspective = b.perspective),
                  null != x.xPercent && (h.xPercent = P(x.xPercent, b.xPercent)),
                  null != x.yPercent && (h.yPercent = P(x.yPercent, b.yPercent))
              else if ('object' == typeof x) {
                if (
                  ((h = {
                    scaleX: P(null != x.scaleX ? x.scaleX : x.scale, b.scaleX),
                    scaleY: P(null != x.scaleY ? x.scaleY : x.scale, b.scaleY),
                    scaleZ: P(x.scaleZ, b.scaleZ),
                    x: P(x.x, b.x),
                    y: P(x.y, b.y),
                    z: P(x.z, b.z),
                    xPercent: P(x.xPercent, b.xPercent),
                    yPercent: P(x.yPercent, b.yPercent),
                    perspective: P(x.transformPerspective, b.perspective),
                  }),
                  null != (d = x.directionalRotation))
                )
                  if ('object' == typeof d) for (c in d) x[c] = d[c]
                  else x.rotation = d
                'string' == typeof x.x && -1 !== x.x.indexOf('%') && ((h.x = 0), (h.xPercent = P(x.x, b.xPercent))),
                  'string' == typeof x.y && -1 !== x.y.indexOf('%') && ((h.y = 0), (h.yPercent = P(x.y, b.yPercent))),
                  (h.rotation = k('rotation' in x ? x.rotation : 'shortRotation' in x ? x.shortRotation + '_short' : 'rotationZ' in x ? x.rotationZ : b.rotation, b.rotation, 'rotation', w)),
                  Lt &&
                    ((h.rotationX = k('rotationX' in x ? x.rotationX : 'shortRotationX' in x ? x.shortRotationX + '_short' : b.rotationX || 0, b.rotationX, 'rotationX', w)),
                    (h.rotationY = k('rotationY' in x ? x.rotationY : 'shortRotationY' in x ? x.shortRotationY + '_short' : b.rotationY || 0, b.rotationY, 'rotationY', w))),
                  (h.skewX = k(x.skewX, b.skewX)),
                  (h.skewY = k(x.skewY, b.skewY))
              }
              for (Lt && null != x.force3D && ((b.force3D = x.force3D), (u = !0)), (m = b.force3D || b.z || b.rotationX || b.rotationY || h.z || h.rotationX || h.rotationY || h.perspective) || null == x.scale || (h.scaleZ = 1); -1 < --y; )
                (1e-6 < (T = h[(g = At[y])] - b[g]) || T < -1e-6 || null != x[g] || null != $[g]) && ((u = !0), (s = new yt(b, g, b[g], T, s)), g in w && (s.e = w[g]), (s.xs0 = 0), (s.plugin = r), n._overwriteProps.push(s.n))
              return (
                (T = x.transformOrigin),
                b.svg &&
                  (T || x.svgOrigin) &&
                  ((f = b.xOffset),
                  (p = b.yOffset),
                  Pt(t, ut(T), h, x.svgOrigin, x.smoothOrigin),
                  (s = vt(b, 'xOrigin', (v ? b : h).xOrigin, h.xOrigin, s, e)),
                  (s = vt(b, 'yOrigin', (v ? b : h).yOrigin, h.yOrigin, s, e)),
                  (f === b.xOffset && p === b.yOffset) || ((s = vt(b, 'xOffset', v ? f : b.xOffset, b.xOffset, s, e)), (s = vt(b, 'yOffset', v ? p : b.yOffset, b.yOffset, s, e))),
                  (T = '0px 0px')),
                (T || (Lt && m && b.zOrigin)) &&
                  (Dt
                    ? ((u = !0),
                      (g = zt),
                      (T = (T || ot(t, g, S, !1, '50% 50%')) + ''),
                      ((s = new yt(_, g, 0, 0, s, -1, e)).b = _[g]),
                      (s.plugin = r),
                      Lt
                        ? ((c = b.zOrigin), (T = T.split(' ')), (b.zOrigin = (2 < T.length && (0 === c || '0px' !== T[2]) ? parseFloat(T[2]) : c) || 0), (s.xs0 = s.e = T[0] + ' ' + (T[1] || '50%') + ' 0px'), ((s = new yt(b, 'zOrigin', 0, 0, s, -1, s.n)).b = c), (s.xs0 = s.e = b.zOrigin))
                        : (s.xs0 = s.e = T))
                    : ut(T + '', b)),
                u && (n._transformType = (b.svg && kt) || (!m && 3 !== this._transformType) ? 2 : 3),
                a && (o[i] = a),
                l && (o.scale = l),
                s
              )
            },
            prefix: !0,
          }),
          Tt('boxShadow', { defaultValue: '0px 0px 0px 0px #999', prefix: !0, color: !0, multi: !0, keyword: 'inset' }),
          Tt('borderRadius', {
            defaultValue: '0px',
            parser: function (t, e, i, n, s, r) {
              e = this.format(e)
              for (var o, a, l, h, c, u, d, f, p, m, g = ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'], v = t.style, _ = parseFloat(t.offsetWidth), y = parseFloat(t.offsetHeight), x = e.split(' '), w = 0; w < g.length; w++)
                this.p.indexOf('border') && (g[w] = T(g[w])),
                  -1 !== (l = a = ot(t, g[w], S, !1, '0px')).indexOf(' ') && ((l = (a = l.split(' '))[0]), (a = a[1])),
                  (h = o = x[w]),
                  (p = parseFloat(l)),
                  (m = l.substr((p + '').length)),
                  '' === (u = (d = '=' === h.charAt(1)) ? ((c = parseInt(h.charAt(0) + '1', 10)), (h = h.substr(2)), (c *= parseFloat(h)), h.substr((c + '').length - (c < 0 ? 1 : 0)) || '') : ((c = parseFloat(h)), h.substr((c + '').length))) && (u = b[i] || m),
                  u !== m &&
                    ((f = at(t, 'borderLeft', p, m)),
                    (p = at(t, 'borderTop', p, m)),
                    (a = '%' === u ? ((l = (f / _) * 100 + '%'), (p / y) * 100 + '%') : 'em' === u ? ((l = f / (m = at(t, 'borderLeft', 1, 'em')) + 'em'), p / m + 'em') : ((l = f + 'px'), p + 'px')),
                    d && ((h = parseFloat(l) + c + u), (o = parseFloat(a) + c + u))),
                  (s = xt(v, g[w], l + ' ' + a, h + ' ' + o, !1, '0px', s))
              return s
            },
            prefix: !0,
            formatter: mt('0px 0px 0px 0px', !1, !0),
          }),
          Tt('borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius', {
            defaultValue: '0px',
            parser: function (t, e, i, n, s, r) {
              return xt(t.style, i, this.format(ot(t, i, S, !1, '0px 0px')), this.format(e), !1, '0px', s)
            },
            prefix: !0,
            formatter: mt('0px 0px', !1, !0),
          }),
          Tt('backgroundPosition', {
            defaultValue: '0 0',
            parser: function (t, e, i, n, s, r) {
              var o,
                a,
                l,
                h,
                c,
                u,
                d = 'background-position',
                f = S || rt(t, null),
                p = this.format((f ? (w ? f.getPropertyValue(d + '-x') + ' ' + f.getPropertyValue(d + '-y') : f.getPropertyValue(d)) : t.currentStyle.backgroundPositionX + ' ' + t.currentStyle.backgroundPositionY) || '0 0'),
                e = this.format(e)
              if ((-1 !== p.indexOf('%')) != (-1 !== e.indexOf('%')) && e.split(',').length < 2 && (u = ot(t, 'backgroundImage').replace(W, '')) && 'none' !== u) {
                for (o = p.split(' '), a = e.split(' '), tt.setAttribute('src', u), l = 2; -1 < --l; )
                  (h = -1 !== (p = o[l]).indexOf('%')) != (-1 !== a[l].indexOf('%')) && ((c = 0 === l ? t.offsetWidth - tt.width : t.offsetHeight - tt.height), (o[l] = h ? (parseFloat(p) / 100) * c + 'px' : (parseFloat(p) / c) * 100 + '%'))
                p = o.join(' ')
              }
              return this.parseComplex(t.style, p, e, s, r)
            },
            formatter: ut,
          }),
          Tt('backgroundSize', {
            defaultValue: '0 0',
            formatter: function (t) {
              return ut(-1 === (t += '').indexOf(' ') ? t + ' ' + t : t)
            },
          }),
          Tt('perspective', { defaultValue: '0px', prefix: !0 }),
          Tt('perspectiveOrigin', { defaultValue: '50% 50%', prefix: !0 }),
          Tt('transformStyle', { prefix: !0 }),
          Tt('backfaceVisibility', { prefix: !0 }),
          Tt('userSelect', { prefix: !0 }),
          Tt('margin', { parser: gt('marginTop,marginRight,marginBottom,marginLeft') }),
          Tt('padding', { parser: gt('paddingTop,paddingRight,paddingBottom,paddingLeft') }),
          Tt('clip', {
            defaultValue: 'rect(0px,0px,0px,0px)',
            parser: function (t, e, i, n, s, r) {
              var o, a
              return (
                (e = w < 9 ? ((o = t.currentStyle), (a = w < 8 ? ' ' : ','), (o = 'rect(' + o.clipTop + a + o.clipRight + a + o.clipBottom + a + o.clipLeft + ')'), this.format(e).split(',').join(a)) : ((o = this.format(ot(t, this.p, S, !1, this.dflt))), this.format(e))),
                this.parseComplex(t.style, o, e, s, r)
              )
            },
          }),
          Tt('textShadow', { defaultValue: '0px 0px 0px #999', color: !0, multi: !0 }),
          Tt('autoRound,strictUnits', {
            parser: function (t, e, i, n, s) {
              return s
            },
          }),
          Tt('border', {
            defaultValue: '0px solid #000',
            parser: function (t, e, i, n, s, r) {
              var o = ot(t, 'borderTopWidth', S, !1, '0px'),
                a = this.format(e).split(' '),
                e = a[0].replace(F, '')
              return 'px' !== e && (o = parseFloat(o) / at(t, 'borderTopWidth', 1, e) + e), this.parseComplex(t.style, this.format(o + ' ' + ot(t, 'borderTopStyle', S, !1, 'solid') + ' ' + ot(t, 'borderTopColor', S, !1, '#000')), a.join(' '), s, r)
            },
            color: !0,
            formatter: function (t) {
              var e = t.split(' ')
              return e[0] + ' ' + (e[1] || 'solid') + ' ' + (t.match(pt) || ['#000'])[0]
            },
          }),
          Tt('borderWidth', { parser: gt('borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth') }),
          Tt('float,cssFloat,styleFloat', {
            parser: function (t, e, i, n, s, r) {
              var o = t.style,
                t = 'cssFloat' in o ? 'cssFloat' : 'styleFloat'
              return new yt(o, t, 0, 0, s, -1, i, !1, 0, o[t], e)
            },
          })
        function Ht(t) {
          var e,
            i = this.t,
            n = i.filter || ot(this.data, 'filter') || ''
          100 == (t = (this.s + this.c * t) | 0) && (e = -1 === n.indexOf('atrix(') && -1 === n.indexOf('radient(') && -1 === n.indexOf('oader(') ? (i.removeAttribute('filter'), !ot(this.data, 'filter')) : ((i.filter = n.replace(s, '')), !0)),
            e || (this.xn1 && (i.filter = n = n || 'alpha(opacity=' + t + ')'), -1 === n.indexOf('pacity') ? (0 == t && this.xn1) || (i.filter = n + ' alpha(opacity=' + t + ')') : (i.filter = n.replace(N, 'opacity=' + t)))
        }
        Tt('opacity,alpha,autoAlpha', {
          defaultValue: '1',
          parser: function (t, e, i, n, s, r) {
            var o = parseFloat(ot(t, 'opacity', S, !1, '1')),
              a = t.style,
              l = 'autoAlpha' === i
            return (
              'string' == typeof e && '=' === e.charAt(1) && (e = ('-' === e.charAt(0) ? -1 : 1) * parseFloat(e.substr(2)) + o),
              l && 1 === o && 'hidden' === ot(t, 'visibility', S) && 0 !== e && (o = 0),
              it ? (s = new yt(a, 'opacity', o, e - o, s)) : (((s = new yt(a, 'opacity', 100 * o, 100 * (e - o), s)).xn1 = l ? 1 : 0), (a.zoom = 1), (s.type = 2), (s.b = 'alpha(opacity=' + s.s + ')'), (s.e = 'alpha(opacity=' + (s.s + s.c) + ')'), (s.data = t), (s.plugin = r), (s.setRatio = Ht)),
              l && (((s = new yt(a, 'visibility', 0, 0, s, -1, null, !1, 0, 0 !== o ? 'inherit' : 'hidden', 0 === e ? 'hidden' : 'inherit')).xs0 = 'inherit'), n._overwriteProps.push(s.n), n._overwriteProps.push(i)),
              s
            )
          },
        })
        function Zt(t) {
          if (((this.t._gsClassPT = this), 1 === t || 0 === t)) {
            this.t.setAttribute('class', 0 === t ? this.b : this.e)
            for (var e = this.data, i = this.t.style; e; ) e.v ? (i[e.p] = e.v) : Vt(i, e.p), (e = e._next)
            1 === t && this.t._gsClassPT === this && (this.t._gsClassPT = null)
          } else this.t.getAttribute('class') !== this.e && this.t.setAttribute('class', this.e)
        }
        var Vt = function (t, e) {
          e && (t.removeProperty ? (('ms' !== e.substr(0, 2) && 'webkit' !== e.substr(0, 6)) || (e = '-' + e), t.removeProperty(e.replace(B, '-$1').toLowerCase())) : t.removeAttribute(e))
        }
        Tt('className', {
          parser: function (t, e, i, n, s, r, o) {
            var a,
              l,
              h,
              c = t.getAttribute('class') || '',
              u = t.style.cssText
            if ((((s = n._classNamePT = new yt(t, i, 0, 0, s, 2)).setRatio = Zt), (s.pr = -11), (d = !0), (s.b = c), (a = m(t, S)), (i = t._gsClassPT))) {
              for (l = {}, h = i.data; h; ) (l[h.p] = 1), (h = h._next)
              i.setRatio(1)
            }
            return (
              ((t._gsClassPT = s).e = '=' !== e.charAt(1) ? e : c.replace(new RegExp('(?:\\s|^)' + e.substr(2) + '(?![\\w-])'), '') + ('+' === e.charAt(0) ? ' ' + e.substr(2) : '')),
              t.setAttribute('class', s.e),
              (o = g(t, a, m(t), o, l)),
              t.setAttribute('class', c),
              (s.data = o.firstMPT),
              (t.style.cssText = u),
              (s.xfirst = n.parse(t, o.difs, s, r))
            )
          },
        })
        function Gt(t) {
          if ((1 === t || 0 === t) && this.data._totalTime === this.data._totalDuration && 'isFromStart' !== this.data.data) {
            var e,
              i,
              n,
              s,
              r = this.t.style,
              o = f.transform.parse
            if ('all' === this.e) s = !(r.cssText = '')
            else for (n = (e = this.e.split(' ').join('').split(',')).length; -1 < --n; ) (i = e[n]), f[i] && (f[i].parse === o ? (s = !0) : (i = 'transformOrigin' === i ? zt : f[i].p)), Vt(r, i)
            s && (Vt(r, Dt), (t = this.t._gsTransform) && (t.svg && (this.t.removeAttribute('data-svg-origin'), this.t.removeAttribute('transform')), delete this.t._gsTransform))
          }
        }
        for (
          Tt('clearProps', {
            parser: function (t, e, i, n, s) {
              return ((s = new yt(t, i, 0, 0, s, 2)).setRatio = Gt), (s.e = e), (s.pr = -10), (s.data = n._tween), (d = !0), s
            },
          }),
            t = 'bezier,throwProps,physicsProps,physics2D'.split(','),
            wt = t.length;
          wt--;

        )
          St(t[wt])
        ;((t = D.prototype)._firstPT = t._lastParsedTransform = t._transform = null),
          (t._onInitTween = function (t, e, i, n) {
            if (!t.nodeType) return !1
            ;(this._target = O = t), (this._tween = i), (this._vars = e), (M = n), (E = e.autoRound), (d = !1), (b = e.suffixMap || D.suffixMap), (S = rt(t, '')), (u = this._overwriteProps)
            var s,
              r,
              o,
              a,
              l,
              h,
              n = t.style
            if (
              (v && '' === n.zIndex && (('auto' !== (h = ot(t, 'zIndex', S)) && '' !== h) || this._addLazySet(n, 'zIndex', 0)),
              'string' == typeof e && ((o = n.cssText), (h = m(t, S)), (n.cssText = o + ';' + e), (h = g(t, h, m(t)).difs), !it && X.test(e) && (h.opacity = parseFloat(RegExp.$1)), (e = h), (n.cssText = o)),
              e.className ? (this._firstPT = s = f.className.parse(t, e.className, 'className', this, null, null, e)) : (this._firstPT = s = this.parse(t, e, null)),
              this._transformType)
            ) {
              for (
                h = 3 === this._transformType,
                  Dt ? _ && ((v = !0), '' === n.zIndex && (('auto' !== (e = ot(t, 'zIndex', S)) && '' !== e) || this._addLazySet(n, 'zIndex', 0)), y && this._addLazySet(n, 'WebkitBackfaceVisibility', this._vars.WebkitBackfaceVisibility || (h ? 'visible' : 'hidden'))) : (n.zoom = 1),
                  r = s;
                r && r._next;

              )
                r = r._next
              ;(n = new yt(t, 'transform', 0, 0, null, 2)), this._linkCSSP(n, null, r), (n.setRatio = Dt ? qt : Ct), (n.data = this._transform || Yt(t, S, !0)), (n.tween = i), (n.pr = -1), u.pop()
            }
            if (d) {
              for (; s; ) {
                for (l = s._next, r = o; r && r.pr > s.pr; ) r = r._next
                ;(s._prev = r ? r._prev : a) ? (s._prev._next = s) : (o = s), (s._next = r) ? (r._prev = s) : (a = s), (s = l)
              }
              this._firstPT = o
            }
            return !0
          }),
          (t.parse = function (t, e, i, n) {
            var s,
              r,
              o,
              a,
              l,
              h,
              c,
              u,
              d = t.style
            for (s in e) {
              if (('function' == typeof (l = e[s]) && (l = l(M, O)), (u = f[s]))) i = u.parse(t, l, s, this, i, n, e)
              else {
                if ('--' === s.substr(0, 2)) {
                  this._tween._propLookup[s] = this._addTween.call(this._tween, t.style, 'setProperty', rt(t).getPropertyValue(s) + '', l + '', s, !1, s)
                  continue
                }
                ;(a = ot(t, s, S) + ''),
                  (c = 'string' == typeof l),
                  'color' === s || 'fill' === s || 'stroke' === s || -1 !== s.indexOf('Color') || (c && j.test(l))
                    ? (c || (l = (3 < (l = ft(l)).length ? 'rgba(' : 'rgb(') + l.join(',') + ')'), (i = xt(d, s, a, l, !0, 'transparent', i, 0, n)))
                    : c && V.test(l)
                    ? (i = xt(d, s, a, l, !0, null, i, 0, n))
                    : ((h = (r = parseFloat(a)) || 0 === r ? a.substr((r + '').length) : ''),
                      ('' !== a && 'auto' !== a) ||
                        (h =
                          'width' === s || 'height' === s
                            ? ((r = (function (t, e, i) {
                                if ('svg' === (t.nodeName + '').toLowerCase()) return (i || rt(t))[e] || 0
                                if (t.getCTM && Bt(t)) return t.getBBox()[e] || 0
                                var n = parseFloat('width' === e ? t.offsetWidth : t.offsetHeight),
                                  s = ht[e],
                                  r = s.length
                                for (i = i || rt(t, null); -1 < --r; ) (n -= parseFloat(ot(t, 'padding' + s[r], i, !0)) || 0), (n -= parseFloat(ot(t, 'border' + s[r] + 'Width', i, !0)) || 0)
                                return n
                              })(t, s, S)),
                              'px')
                            : 'left' === s || 'top' === s
                            ? ((r = lt(t, s, S)), 'px')
                            : ((r = 'opacity' !== s ? 0 : 1), '')),
                      '' === (c = (u = c && '=' === l.charAt(1)) ? ((o = parseInt(l.charAt(0) + '1', 10)), (l = l.substr(2)), (o *= parseFloat(l)), l.replace(F, '')) : ((o = parseFloat(l)), c ? l.replace(F, '') : '')) && (c = s in b ? b[s] : h),
                      (l = o || 0 === o ? (u ? o + r : o) + c : e[s]),
                      h !== c &&
                        (('' === c && 'lineHeight' !== s) ||
                          ((o || 0 === o) &&
                            r &&
                            ((r = at(t, s, r, h)),
                            '%' === c ? ((r /= at(t, s, 100, '%') / 100), !0 !== e.strictUnits && (a = r + '%')) : 'em' === c || 'rem' === c || 'vw' === c || 'vh' === c ? (r /= at(t, s, 1, c)) : 'px' !== c && ((o = at(t, s, o, c)), (c = 'px')),
                            u && (o || 0 === o) && (l = o + r + c)))),
                      u && (o += r),
                      (!r && 0 !== r) || (!o && 0 !== o)
                        ? void 0 !== d[s] && (l || (l + '' != 'NaN' && null != l))
                          ? ((i = new yt(d, s, o || r || 0, 0, i, -1, s, !1, 0, a, l)).xs0 = 'none' !== l || ('display' !== s && -1 === s.indexOf('Style')) ? l : a)
                          : p('invalid ' + s + ' tween value: ' + e[s])
                        : ((i = new yt(d, s, r, o - r, i, 0, s, !1 !== E && ('px' === c || 'zIndex' === s), 0, a, l)).xs0 = c))
              }
              n && i && !i.plugin && (i.plugin = n)
            }
            return i
          }),
          (t.setRatio = function (t) {
            var e,
              i,
              n,
              s = this._firstPT
            if (1 !== t || (this._tween._time !== this._tween._duration && 0 !== this._tween._time))
              if (t || (this._tween._time !== this._tween._duration && 0 !== this._tween._time) || -1e-6 === this._tween._rawPrevTime)
                for (; s; ) {
                  if (((e = s.c * t + s.s), s.r ? (e = Math.round(e)) : e < 1e-6 && -1e-6 < e && (e = 0), s.type))
                    if (1 === s.type)
                      if (2 === (n = s.l)) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2
                      else if (3 === n) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2 + s.xn2 + s.xs3
                      else if (4 === n) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2 + s.xn2 + s.xs3 + s.xn3 + s.xs4
                      else if (5 === n) s.t[s.p] = s.xs0 + e + s.xs1 + s.xn1 + s.xs2 + s.xn2 + s.xs3 + s.xn3 + s.xs4 + s.xn4 + s.xs5
                      else {
                        for (i = s.xs0 + e + s.xs1, n = 1; n < s.l; n++) i += s['xn' + n] + s['xs' + (n + 1)]
                        s.t[s.p] = i
                      }
                    else -1 === s.type ? (s.t[s.p] = s.xs0) : s.setRatio && s.setRatio(t)
                  else s.t[s.p] = e + s.xs0
                  s = s._next
                }
              else for (; s; ) 2 !== s.type ? (s.t[s.p] = s.b) : s.setRatio(t), (s = s._next)
            else
              for (; s; ) {
                if (2 !== s.type)
                  if (s.r && -1 !== s.type)
                    if (((e = Math.round(s.s + s.c)), s.type)) {
                      if (1 === s.type) {
                        for (n = s.l, i = s.xs0 + e + s.xs1, n = 1; n < s.l; n++) i += s['xn' + n] + s['xs' + (n + 1)]
                        s.t[s.p] = i
                      }
                    } else s.t[s.p] = e + s.xs0
                  else s.t[s.p] = s.e
                else s.setRatio(t)
                s = s._next
              }
          }),
          (t._enableTransforms = function (t) {
            ;(this._transform = this._transform || Yt(this._target, S, !0)), (this._transformType = (this._transform.svg && kt) || (!t && 3 !== this._transformType) ? 2 : 3)
          })
        function Qt(t) {
          ;(this.t[this.p] = this.e), this.data._linkCSSP(this, this._next, null, !0)
        }
        ;(t._addLazySet = function (t, e, i) {
          e = this._firstPT = new yt(t, e, 0, 0, this._firstPT, 2)
          ;(e.e = i), (e.setRatio = Qt), (e.data = this)
        }),
          (t._linkCSSP = function (t, e, i, n) {
            return t && (e && (e._prev = t), t._next && (t._next._prev = t._prev), t._prev ? (t._prev._next = t._next) : this._firstPT === t && ((this._firstPT = t._next), (n = !0)), i ? (i._next = t) : n || null !== this._firstPT || (this._firstPT = t), (t._next = e), (t._prev = i)), t
          }),
          (t._mod = function (t) {
            for (var e = this._firstPT; e; ) 'function' == typeof t[e.p] && t[e.p] === Math.round && (e.r = 1), (e = e._next)
          }),
          (t._kill = function (t) {
            var e,
              i,
              n,
              s = t
            if (t.autoAlpha || t.alpha) {
              for (i in ((s = {}), t)) s[i] = t[i]
              ;(s.opacity = 1), s.autoAlpha && (s.visibility = 1)
            }
            for (t.className && (e = this._classNamePT) && ((n = e.xfirst) && n._prev ? this._linkCSSP(n._prev, e._next, n._prev._prev) : n === this._firstPT && (this._firstPT = e._next), e._next && this._linkCSSP(e._next, e._next._next, n._prev), (this._classNamePT = null)), e = this._firstPT; e; )
              e.plugin && e.plugin !== i && e.plugin._kill && (e.plugin._kill(t), (i = e.plugin)), (e = e._next)
            return r.prototype._kill.call(this, s)
          })
        var $t = function (t, e, i) {
          var n, s, r, o
          if (t.slice) for (s = t.length; -1 < --s; ) $t(t[s], e, i)
          else for (s = (n = t.childNodes).length; -1 < --s; ) (o = (r = n[s]).type), r.style && (e.push(m(r)), i && i.push(r)), (1 !== o && 9 !== o && 11 !== o) || !r.childNodes.length || $t(r, e, i)
        }
        return (
          (D.cascadeTo = function (t, e, i) {
            var n,
              s,
              r,
              o,
              a = A.to(t, e, i),
              l = [a],
              h = [],
              c = [],
              u = [],
              d = A._internals.reservedProps
            for (t = a._targets || a.target, $t(t, h, u), a.render(e, !0, !0), $t(t, c), a.render(0, !0, !0), a._enabled(!0), n = u.length; -1 < --n; )
              if ((s = g(u[n], h[n], c[n])).firstMPT) {
                for (r in ((s = s.difs), i)) d[r] && (s[r] = i[r])
                for (r in ((o = {}), s)) o[r] = h[n][r]
                l.push(A.fromTo(u[n], e, o, s))
              }
            return l
          }),
          r.activate([D]),
          D
        )
      },
      !0
    )
  }),
  _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
  (function () {
    'use strict'
    function t() {
      return (_gsScope.GreenSockGlobals || _gsScope).CSSPlugin
    }
    'undefined' != typeof module && module.exports ? (require('../TweenLite.js'), (module.exports = t())) : 'function' == typeof define && define.amd && define(['TweenLite'], t)
  })()
